/**
 * German translations — Deutsch
 * Complete coverage of all public-facing UI text
 */
const de: Record<string, string> = {
  // ── Navigation ─────────────────────────────────────
  'nav.explore': 'Entdecken',
  'nav.artWorld': 'Kunstwelt',
  'nav.pricing': 'Preise',
  'nav.contact': 'Kontakt',
  'nav.myStudio': 'Mein ArtRouting',
  'nav.admin': 'Admin',
  'nav.login': 'Anmelden',
  'nav.register': 'Registrieren',
  'nav.logout': 'Abmelden',
  'nav.goBack': 'Zur\u00fcck',
  'nav.map': 'Karte',
  'nav.discover': 'Entdecken',
  'nav.routes': 'Routen',
  'nav.artists': 'K\u00fcnstler & Kuratoren',
  'nav.artradar': 'ArtRadar',
  'nav.events': 'Veranstaltungen',
  'nav.myProfile': 'Mein Profil',
  'nav.myPins': 'Meine Pins',
  'nav.myArtworks': 'Meine Kunstwerke',
  'nav.myProvenance': 'Meine Provenienz',
  'nav.myRoutes': 'Meine Routen',
  'nav.myEvents': 'Meine Events',
  'nav.myArtists': 'Meine Künstler',
  'nav.myCurators': 'Meine Kuratoren',
  'nav.myArticles': 'Meine Artikel',
  'myEvents.title': 'Meine Events',
  'nav.saved': 'Gespeichert',
  'nav.import': 'Profil importieren',
  'nav.subscription': 'Mein Abonnement',
  'nav.docs': 'Dokumentation',
  'nav.viewingAs': 'Angezeigt als',
  'nav.returnToAdmin': 'Zur\u00fcck zum Admin',

  // ── Footer ─────────────────────────────────────────
  'footer.privacy': 'Datenschutz',
  'footer.terms': 'Nutzungsbedingungen',
  'footer.cookies': 'Cookie-Richtlinie',
  'footer.tagline': 'Kulturelle Entdeckung f\u00fcr alle.',

  // ── Hero / Landing ─────────────────────────────────
  'hero.headline': 'Entdecke Kunst, wo sie lebt.',
  'hero.subtitle': 'Erkunde K\u00fcnstler, Galerien, Ateliers und kulturelle Orte auf einer lebendigen Entdeckungskarte.',
  'hero.cta1': 'Karte \u00f6ffnen',
  'hero.cta2': 'ArtRadar',
  'hero.scroll': 'Scrollen',
  'card1.title': 'F\u00fcr K\u00fcnstler',
  'card1.desc': 'Werde dort gefunden, wo du kreierst. Profile, Orte und Sichtbarkeit \u2014 verankert in realer Geografie.',
  'card1.cta': 'Deinen Platz sichern',
  'card2.title': 'F\u00fcr Entdecker',
  'card2.desc': 'Finde Kunst in deiner N\u00e4he. Folge Routen, entdecke R\u00e4ume und erlebe Kultur vor Ort.',
  'card2.cta': 'Deiner Neugier folgen',
  'card3.title': 'ArtRadar',
  'card3.desc': 'Geschichten, Highlights und kuratierte kulturelle Signale, die die Karte zum Leben erwecken.',
  'card3.cta': 'Signal lesen',
  'card4.title': 'F\u00fcr Galerien',
  'card4.desc': 'Pr\u00e4sentiere deine Ausstellungen, vernetze dich mit Sammlern und bringe deine Galerie auf die kulturelle Landkarte.',
  'card4.cta': 'Galerie eintragen',
  'explain.title': 'So funktioniert ArtRouting',
  'explain.desc': 'ArtRouting verbindet K\u00fcnstler, Ateliers, Galerien und kulturelle Orte \u00fcber eine interaktive Karte. Entdecke Kunst geografisch \u2014 folge Routen durch offene Ateliers, finde Ausstellungen in der N\u00e4he und erlebe Kultur vor Ort.',
  'explain.pins': 'Kulturelle Pins',
  'explain.pinsDesc': 'K\u00fcnstler, Ateliers, Galerien und kulturelle Orte erscheinen als Pins auf der Karte.',
  'explain.profiles': 'Umfangreiche Profile',
  'explain.profilesDesc': 'Jeder Pin \u00f6ffnet ein Profil mit Bildern, Ausstellungen, \u00d6ffnungszeiten und Kontaktdaten.',
  'explain.routes': 'Kulturelle Routen',
  'explain.routesDesc': 'Orte verbinden sich zu Routen, die Besucher durch Kunst und Kultur einer Region f\u00fchren.',
  'explain.cta': 'ArtRouting beitreten',
  'explain.ctaAuth': 'Dein Atelier zur Karte hinzuf\u00fcgen',

  // ── Pricing ────────────────────────────────────────
  'pricing.title': 'W\u00e4hle deinen Plan',
  'pricing.subtitle': 'Vier Rollen, jeweils drei Wahlmöglichkeiten — Kostenlos, Aktiv und Pro. Nehmen Sie mehrere Rollen ein und zahlen Sie nur einmal, für den höchsten gewählten Tarif.',
  'pricing.artists': 'K\u00fcnstler',
  'pricing.galleries': 'Kunstorte',
  'pricing.earlyAccess': 'Early-Access-Preise \u2014 verf\u00fcgbar w\u00e4hrend der Startphase',
  'pricing.currentPlan': 'Aktueller Plan',
  'pricing.yourPlan': 'DEIN PLAN',
  'pricing.yourCurrentPlan': 'Dein aktueller Plan',
  'pricing.signUpFree': 'Kostenlos registrieren',
  'pricing.signInToSubscribe': 'Anmelden zum Abonnieren',
  'pricing.downgradeToFree': 'Auf Kostenlos wechseln',
  'pricing.subscribe': 'Abonnieren',
  'pricing.upgrade': 'Upgraden',
  'pricing.switchPlan': 'Plan wechseln',
  'pricing.processing': 'Wird verarbeitet...',
  'pricing.activating': 'Dein Abonnement wird aktiviert...',
  'pricing.loading': 'Preise werden geladen...',
  'pricing.loadFailed': 'Preisinformationen konnten nicht geladen werden.',
  'pricing.featureAccess': 'Funktionszugang nach Stufe',
  'pricing.menuFeature': 'Men\u00fc / Funktion',
  'pricing.paypalError': 'PayPal-Fehler aufgetreten. Bitte versuche es erneut.',
  'pricing.paypalLoading': 'PayPal-Abonnements werden geladen...',
  'pricing.pioneer.title': 'Pioneer \u2014 Fr\u00fcher Zugang',
  'pricing.pioneer.desc': 'Voller Zugang zu allen Funktionen \u2014 nur auf Einladung. Danke, dass du ein Pioneer bist!',
  'pricing.pioneer.free': 'Kostenlos',
  'pricing.pioneer.inviteOnly': 'Nur auf Einladung',
  'pricing.pioneer.fullProfile': 'Vollst\u00e4ndiges Profil',
  'pricing.pioneer.artworkGallery': 'Kunstwerk-Galerie',
  'pricing.pioneer.artradar': 'ArtRadar',
  'pricing.pioneer.routes': 'Routen',
  'pricing.pioneer.priorityVisibility': 'Priorisierte Sichtbarkeit',
  'pricing.pioneer.exhibitions': 'Ausstellungen',
  'pricing.pioneer.collectorSignals': 'Sammler-Signale',
  // Tarifkarten — die fette Zeile sieht man zuerst, die Erklärung öffnet sich beim Klick
  'pricing.explorers': 'Explorer',
  'pricing.whatsIncluded': 'Das bekommen Sie',
  'pricing.tapToExpand': 'Tippen Sie auf eine Funktion, um zu sehen, was sie bedeutet',
  'pricing.showExplanation': 'Erklärung anzeigen',
  'pricing.hideExplanation': 'Erklärung ausblenden',
  'pricing.howToRead': 'So lesen Sie diese Tarife',
  'pricing.sharedTiers.title': 'Geteilte Tarife — mehrere Rollen, eine Zahlung',
  'pricing.sharedTiers.body': 'Wählen Sie mehrere Rollen — Künstler, Kunstort, Explorer und Kunsterbe. Sie zahlen einmal für den teuersten gewählten Tarif. Rollenspezifische Funktionen und Grenzen gelten für den gewählten Tarif jeder Rolle.',
  'pricing.coveredByYourPlan': 'Durch Ihren Tarif abgedeckt',
  'pricing.learnMoreRole': 'Mehr über diese Rolle erfahren',
  'pricing.learnLessRole': 'Weniger anzeigen',
  'pricing.comingSoon': 'Demnächst verfügbar',
  // Profile galleries
  'gallery.close': 'Schließen',
  'gallery.credit': 'Bildnachweis',
  'gallery.moreInfo': 'Mehr erfahren',
  'gallery.rotating': 'Profilgalerie',
  'gallery.manage': 'Galerie verwalten',
  'gallery.enlarge': 'Größer anzeigen',
  'gallery.announcement': 'Ankündigung',
  'gallery.previous': 'Vorheriges Bild',
  'gallery.next': 'Nächstes Bild',
  'gallery.goTo': 'Bild {n} von {total} zeigen',
  'gallery.play': 'Diashow fortsetzen',
  'gallery.pause': 'Diashow anhalten',
  'gallery.additional': 'Galerie',
  'gallery.when': 'Wann',
  'gallery.where': 'Wo',
  'gallery.why': 'Warum',
  'gallery.provenance': 'QR-Provenienz',
  'gallery.availability.available': 'Verfügbar',
  'gallery.availability.reserved': 'Reserviert',
  'gallery.availability.sold': 'Verkauft',
  'gallery.availability.not_available': 'Nicht verfügbar',
  'gallery.availability.on_loan': 'Verliehen',
  'gallery.videos': 'Videos',
  'gallery.video': 'Video',
  'gallery.playVideo': 'Video abspielen',
  'galleryEditor.title': 'Galerie verwalten',
  'galleryEditor.back': 'Zurück zum Profil',
  'galleryEditor.denied': 'Nur die Inhaberin bzw. der Inhaber, eine berechtigte delegierte Autorenschaft oder ein Admin kann diese Galerie verwalten.',
  'galleryEditor.usage.rotating': '{used} von {max} rotierenden Bildern genutzt',
  'galleryEditor.usage.additional': '{used} von {max} zusätzlichen Bildern genutzt',
  'galleryEditor.usage.additionalNone': 'Zusätzliche Bilder ab Aktiv',
  'galleryEditor.usage.videos': '{used} von {max} Videolinks genutzt',
  'galleryEditor.window.free': 'Kostenlos: Galerieänderungen einmal pro Kalendermonat.',
  'galleryEditor.window.active': 'Aktiv: Galerieänderungen einmal pro Kalenderwoche.',
  'galleryEditor.window.pro': 'Pro: Galerie jederzeit ändern.',
  'galleryEditor.window.session': 'Ihre Bearbeitungssitzung ist bis {date} offen – bis dahin können Sie alles anordnen.',
  'galleryEditor.window.open': 'Ihr Aktualisierungsfenster ist offen. Die erste Änderung startet eine 24-stündige Bearbeitungssitzung.',
  'galleryEditor.window.closed': 'Die Aktualisierung dieses Zeitraums ist genutzt. Das nächste Fenster öffnet am {date}.',
  'galleryEditor.window.alwaysAllowed': 'Immer möglich: ein Element entfernen, eine Ankündigung vorzeitig beenden und ein Kunstwerk als verkauft oder nicht mehr verfügbar markieren.',
  'galleryEditor.state.published': 'Öffentlich',
  'galleryEditor.state.live': 'Live',
  'galleryEditor.state.scheduled': 'Geplant',
  'galleryEditor.state.expired': 'Abgelaufen',
  'galleryEditor.state.hidden_by_tier': 'Durch Tarif ausgeblendet',
  'galleryEditor.kind.image': 'Bild',
  'galleryEditor.kind.announcement': 'Ankündigung',
  'galleryEditor.kind.artwork': 'Kunstwerk-PIN',
  'galleryEditor.now': 'Jetzt',
  'galleryEditor.alt': 'Alternativtext (beschreibt das Bild)',
  'galleryEditor.caption': 'Bildunterschrift',
  'galleryEditor.credit': 'Bildnachweis',
  'galleryEditor.when': 'Wann (Datum oder Jahr)',
  'galleryEditor.where': 'Wo (Ort oder Ausstellung)',
  'galleryEditor.save': 'Speichern',
  'galleryEditor.saved': 'Gespeichert.',
  'galleryEditor.up': 'Nach oben',
  'galleryEditor.down': 'Nach unten',
  'galleryEditor.toAdditional': 'In die Galerie verschieben',
  'galleryEditor.toRotating': 'In die Rotation verschieben',
  'galleryEditor.edit': 'Bearbeiten',
  'galleryEditor.endNow': 'Jetzt beenden',
  'galleryEditor.ended': 'Ankündigung beendet.',
  'galleryEditor.availability': 'Status des Kunstwerks',
  'galleryEditor.statusSaved': 'Status überall aktualisiert, wo dieses Kunstwerk erscheint.',
  'galleryEditor.confirmRemove': 'Aus der Galerie entfernen? Das verbundene Kunstwerk bzw. der Eintrag bleibt unverändert.',
  'galleryEditor.removed': 'Aus der Galerie entfernt.',
  'galleryEditor.remove': 'Entfernen',
  'galleryEditor.addImage': 'Bild oder Ankündigung hinzufügen',
  'galleryEditor.section': 'Wo es erscheint',
  'galleryEditor.sectionRotating': 'Rotierende Galerie (oben)',
  'galleryEditor.sectionAdditional': 'Galerie (unten)',
  'galleryEditor.kindLabel': 'Art',
  'galleryEditor.imageType': 'Bildart',
  'galleryEditor.type.artwork': 'Kunstwerk',
  'galleryEditor.type.detail': 'Detail',
  'galleryEditor.type.portrait': 'Porträt',
  'galleryEditor.type.studio': 'Atelier / Entstehung',
  'galleryEditor.type.venue': 'Kunstort / Raum',
  'galleryEditor.type.exhibition': 'Ausstellung / Veranstaltung',
  'galleryEditor.image': 'Bild',
  'galleryEditor.imageHelp': 'JPEG, PNG oder WebP. Mindestens 1600 px an der längsten Seite empfohlen. Keine Videodateien.',
  'galleryEditor.externalUrl': 'Link (optional, https)',
  'galleryEditor.start': 'Anzeigen ab',
  'galleryEditor.end': 'Anzeigen bis',
  'galleryEditor.announcementHelp': 'Ankündigungen erscheinen nur auf diesem Profil, verschwinden automatisch zum Enddatum und sind keine ArtRadar-Beiträge.',
  'galleryEditor.rights': 'Ich besitze dieses Bild oder darf es veröffentlichen; erforderliche Genehmigungen liegen vor und der Bildnachweis ist korrekt.',
  'galleryEditor.add': 'Hinzufügen',
  'galleryEditor.added': 'Hinzugefügt.',
  'galleryEditor.connectArtwork': 'Kunstwerk-PIN verbinden',
  'galleryEditor.connectArtworkHelp': 'Zeigen Sie aktuelle und frühere Werke über ihre Kunstwerk-PINs. Eine Verbindung braucht keinen Bildplatz und kopiert das Kunstwerk nie. Wann, wo und – bei dauerhaftem QR – warum erscheinen automatisch.',
  'galleryEditor.searchArtworks': 'Kunstwerke nach Titel suchen',
  'galleryEditor.chooseArtwork': 'Kunstwerk wählen …',
  'galleryEditor.whereArtworkHelp': 'Optional: wo es gezeigt wurde, falls abweichend vom PIN',
  'galleryEditor.connect': 'Verbinden',
  'galleryEditor.empty': 'Noch nichts vorhanden.',
  'galleryEditor.videoTitle': 'Titel',
  'galleryEditor.addVideo': 'Videolink hinzufügen',
  'galleryEditor.err.generic': 'Das hat nicht geklappt. Bitte erneut versuchen.',
  'galleryEditor.err.update_window_closed': 'Die Galerieaktualisierung dieses Zeitraums ist bereits genutzt. Das nächste Fenster öffnet am {date}. Entfernen, Ankündigungen beenden und Kunstwerke als verkauft markieren bleiben möglich.',
  'galleryEditor.err.alt_text_required': 'Alternativtext ist erforderlich.',
  'galleryEditor.err.rights_not_confirmed': 'Bitte bestätigen Sie, dass Sie dieses Bild veröffentlichen dürfen.',
  'galleryEditor.err.invalid_image': 'Laden Sie ein JPEG-, PNG- oder WebP-Bild hoch.',
  'galleryEditor.err.announcement_end_required': 'Eine Ankündigung braucht ein Enddatum.',
  'galleryEditor.err.announcement_end_before_start': 'Das Ende muss nach dem Beginn liegen.',
  'galleryEditor.err.rotating_full': 'Die rotierende Galerie hat bereits 10 Bilder.',
  'galleryEditor.err.additional_full': 'Alle zusätzlichen Bildplätze Ihres Tarifs sind belegt.',
  'galleryEditor.err.additional_not_included': 'Zusätzliche Bilder beginnen mit Aktiv.',
  'galleryEditor.err.videos_full': 'Alle YouTube-Plätze Ihres Tarifs sind belegt.',
  'galleryEditor.err.artwork_not_found': 'Dieses Kunstwerk wurde nicht gefunden.',
  'galleryEditor.err.artwork_already_connected': 'Dieses Kunstwerk ist bereits in der Galerie.',
  'galleryEditor.err.connected_not_found': 'Der verbundene Eintrag wurde nicht gefunden.',
  'galleryEditor.err.invalid_external_url': 'Links müssen mit https:// beginnen.',
  'galleryEditor.err.announcement_rotating_only': 'Ankündigungen gehören in die rotierende Galerie.',
  // Homepage master 17 Sep 2026, Learn pages, Hero Image admin
  'hero.photoAlt': 'Eine Besucherin betrachtet zwei gerahmte Gemälde auf einer Staffelei in einem blauen Atelier voller geschnitzter Rahmen.',
  'hero.credit.prefix': 'Kunstwerk auf der Staffelei von',
  'hero.credit.artistProfile': 'Künstler-PIN',
  'hero.credit.shownAt': 'Zu sehen bei',
  'home.video.watch': 'Ansehen: So funktioniert ArtRouting',
  'home.video.close': 'Video schließen',
  'home.step.places.title': 'Orte auf der Karte',
  'home.step.places.text': 'Künstler, Ateliers, Kunstorte, Ausstellungen und Kunstwerke sind mit realen Orten verbunden, an denen man sie entdecken kann.',
  'home.step.places.cta': 'Bring dich auf die Karte',
  'home.step.profiles.title': 'Profile',
  'home.step.profiles.text': 'Öffne einen PIN und entdecke die Menschen, Kunstwerke, Ausstellungen und Besucherinformationen, die mit diesem Ort verbunden sind.',
  'home.step.routes.title': 'Kunstrouten',
  'home.step.routes.text1': 'Lass eine Entdeckung zur nächsten führen – vom Künstler zum Atelier, zur Ausstellung, zur Galerie oder zu einem anderen Kulturort.',
  'home.step.routes.text2': 'Künstler und Kunstorte können sich auch verbinden und gemeinsam Routen gestalten – mit abgestimmten Besuchen, Öffnungszeiten und Erlebnissen in einer ganzen Region.',
  'home.step.routes.text3': 'Gestalte deine eigene Route durch die Kunst einer Region.',
  'home.step.journeys.title': 'Kunstwerk-Reisen',
  'home.step.journeys.text': 'Verfolge, wie ein Kunstwerk vom Atelier zu Ausstellungen, Galerien, Sammlungen und neuen Orten wandert und dabei seine Geschichte aufbaut.',
  'home.closing.title': 'ArtRouting verbindet die Reise.',
  'home.closing.line1': 'Menschen entdecken Kunst über Orte.',
  'home.closing.line2': 'Kunstwerke bauen ihre Geschichte über die Orte auf, an die sie reisen.',
  'home.closing.line3': 'ArtRouting verbindet beides.',
  'home.plan.title': 'Wähle deinen Tarif',
  'home.plan.text': 'Starte kostenlos und wähle die Stufe der Teilnahme, die zu dir passt.',
  'home.plan.button': 'Tarif wählen',
  'learn.collaboration.title': 'Zusammenarbeiten',
  'learn.collaboration.p1': 'Viele Künstler und Kunstorte haben Unterstützung: eine Assistenz, eine Galerieleitung, ein Familienmitglied, eine Kuratorin. Mit ArtRouting gibst du einer namentlich registrierten Person die Erlaubnis, dein Profil, deine Kunstwerke, Ausstellungen und Informationen mitzuverwalten.',
  'learn.collaboration.p2': 'Du wählst genau aus, was die Person tun darf – Schritt für Schritt. Sie sieht dieselbe Liste, nimmt jeden Teil an oder lehnt ihn ab, und ihr beide akzeptiert dieselben Regeln. Nichts ist aktiv, bevor ihr beide zugestimmt habt.',
  'learn.collaboration.p3': 'Du behältst immer die Kontrolle: Du kannst den Zugriff jederzeit einschränken oder widerrufen, jede Änderung wird festgehalten, und du wirst informiert, wenn deine delegierte Autorenschaft wesentliche Änderungen vornimmt.',
  'learn.collaboration.p4': 'Dein Konto, dein Passwort, die Abrechnung und das Recht zum Widerruf werden nie geteilt. Delegierten Zugriff annehmen kann man in jedem Tarif; dein Tarif bestimmt, wie viele Personen du benennen kannst.',
  'learn.collaboration.ctaAuth': 'Delegierte Autorenschaft öffnen',
  'learn.collaboration.ctaAnon': 'Kostenloses Konto anlegen',
  'learn.messaging.title': 'Verbinden',
  'learn.messaging.p1': 'Mit ArtRouting-Nachrichten schreibst du direkt an Künstler, Kunstorte und andere Teilnehmende – um nach einem Atelierbesuch, einer Ausstellung, einem Kunstwerk oder weiteren Entdeckungen in der Nähe zu fragen.',
  'learn.messaging.p2': 'Gespräche bleiben privat zwischen den Beteiligten. Freigegebene Bilder und PDFs können angehängt werden, und du kannst Nachrichten jederzeit ausschalten oder jemanden blockieren.',
  'learn.messaging.p3': 'Ein Gespräch kann der nächste Schritt auf deiner Kunstroute sein.',
  'learn.messaging.ctaAuth': 'Nachrichten öffnen',
  'learn.messaging.ctaAnon': 'Kostenloses Konto anlegen',
  'adminLanding.slogan1': 'Slogan Zeile 1',
  'adminLanding.slogan2': 'Slogan Zeile 2',
  'adminLanding.support': 'Ergänzende Zeile (optional)',
  'adminLanding.heroImageNote': 'Foto und Credit-Links werden separat verwaltet:',
  'adminLanding.card4': 'Für Kunstorte',
  'adminLanding.card5': 'Zusammenarbeiten',
  'adminLanding.card6': 'Verbinden',
  'adminLanding.card7': 'Kunsterbe',
  'adminLanding.videoUrl': 'Erklärvideo – YouTube-Link (optional; der Button erscheint nur, wenn gesetzt)',
  'adminHero.title': 'Titelbild',
  'adminHero.subtitle': 'Das Foto auf der Startseite und seine Nennung. Das Foto wird bereits gezeigt; tragen Sie hier die Links zu Kunstwerk, Künstlerin und Kunstort ein, sobald deren ArtRouting-Seiten existieren – jeder Link erscheint nach dem Speichern in der Bildnennung.',
  'adminHero.back': 'Zurück zum Admin',
  'adminHero.live': 'Vollständig genannt – alle Links und die Genehmigung sind erfasst.',
  'adminHero.notLive': 'Das Foto ist online, aber {n} Angabe(n) zur Nennung fehlen noch – unten rot markiert.',
  'adminHero.required': 'Fehlt noch',
  'adminHero.ok': 'Erfasst',
  'adminHero.image': 'Foto',
  'adminHero.imageHelp': 'Das Bild oben auf der Startseite. Laden Sie ein neues hoch oder behalten Sie die aktuelle Datei.',
  'adminHero.textPosition': 'Position der Überschrift auf dem Foto',
  'adminHero.textRight': 'Rechts – das Kunstwerk links bleibt gut sichtbar',
  'adminHero.textLeft': 'Links',
  'adminHero.creditName': 'Nennung – Name der Künstlerin / des Künstlers',
  'adminHero.creditNameHelp': 'Erscheint als „Kunstwerk auf der Staffelei von …“. Nur dieser Name wird verlinkt – zum PIN des Kunstwerks.',
  'adminHero.artwork': 'Link zum Kunstwerk-PIN',
  'adminHero.artworkHelp': 'Die ArtRouting-Seite des Kunstwerks auf der Staffelei, z. B. https://artrouting.com/artworks/…',
  'adminHero.artist': 'Link zum Künstler-PIN',
  'adminHero.artistHelp': 'PIN oder Profil der Künstlerin auf ArtRouting, z. B. https://artrouting.com/map/pin/… oder /profiles/…',
  'adminHero.venue': 'Link zum Galerie- / Kunstort-PIN',
  'adminHero.venueHelp': 'Der PIN des Ateliers oder der Galerie, in dem das Kunstwerk gezeigt wird, z. B. https://artrouting.com/map/pin/…',
  'adminHero.linksTo': 'Verlinkt auf',
  'adminHero.permission': 'Nutzungsgenehmigung liegt vor',
  'adminHero.permissionHelp': 'Bestätigen Sie, dass die vereinbarte Genehmigung zur Nutzung dieses Fotos (einschließlich der abgebildeten Personen und Kunstwerke) vorliegt.',
  'adminHero.save': 'Titelbild speichern',
  'adminHero.savedLive': 'Gespeichert. Das Foto ist vollständig genannt.',
  'adminHero.savedNotLive': 'Gespeichert. Das Foto ist online; die rot markierten Angaben fehlen noch.',
  'adminHero.invalidLink': '{field}: Das ist kein Link auf eine existierende ArtRouting-Seite der richtigen Art.',
  'adminHero.saveFailed': 'Speichern fehlgeschlagen. Bitte erneut versuchen.',
  'adminHero.superadminOnly': 'Nur Superadmins können das Titelbild verwalten.',
  'adminHero.cardDesc': 'Das Startseitenfoto und seine Nennung mit Links zu Kunstwerk-, Künstler- und Galerie-PIN.',
  'adminHero.cardStat': 'Nennungs-Links',
  'adminHero.cardCta': 'Verwalten',
  // Delegierte Autorenschaft, Ausstellungsnachweise, verbundene Historie
  'nav.authorship': 'Autorenschaft',
  'authorship.loading': 'Autorenschaft wird geladen …',
  'authorship.title': 'Delegierte Autorenschaft',
  'authorship.subtitle': 'Lassen Sie eine namentlich benannte Person bei einer Ihrer Rollen mitarbeiten – nur im Rahmen der Berechtigungen, denen Sie beide zustimmen. Sie behalten die volle Kontrolle und können jederzeit widerrufen.',
  'authorship.back': 'Alle Vereinbarungen',
  'authorship.invite.open': 'Delegierte Autorin / delegierten Autor benennen',
  'authorship.invite.role': 'Zu verwaltende Rolle',
  'authorship.invite.chooseRole': 'Rolle wählen …',
  'authorship.invite.authorEmail': 'Registrierte ArtRouting-E-Mail der Autorin / des Autors',
  'authorship.invite.authorEmailHelp': 'Die Person muss bereits ein ArtRouting-Konto haben',
  'authorship.invite.approvers': 'Zusätzliche erforderliche Zustimmende (optional)',
  'authorship.invite.approversHelp': 'Registrierte E-Mails, durch Kommas getrennt – z. B. Mitinhaber eines Projekts',
  'authorship.invite.chooseAll': 'Wählen Sie für jede Berechtigung Erlauben oder Nicht erlauben – nichts ist vorausgewählt.',
  'authorship.invite.send': 'Einladung senden',
  'authorship.roleType.artist': 'Künstler',
  'authorship.roleType.venue': 'Kunstort',
  'authorship.roleType.explorer': 'Explorer',
  'authorship.perms.title': 'Berechtigungen',
  'authorship.perms.ownerHelp': 'Rolleninhaber: Wählen Sie pro Zeile eine Option. Alles nicht Erlaubte bleibt deaktiviert.',
  'authorship.perms.authorHelp': 'Delegierte Autorin / delegierter Autor: Nehmen Sie jede vom Inhaber erlaubte Berechtigung an oder lehnen Sie sie ab. Nicht erlaubte Berechtigungen können Sie nicht hinzufügen.',
  'authorship.perms.finalHelp': 'Die endgültige Liste: Eine Berechtigung ist nur aktiv, wenn der Inhaber sie erlaubt, die Autorin / der Autor sie angenommen und alle erforderlichen Zustimmenden zugestimmt haben.',
  'authorship.perms.action': 'Konkrete Handlung',
  'authorship.perms.ownerChoice': 'Rolleninhaber',
  'authorship.perms.authorChoice': 'Delegierte Autorenschaft',
  'authorship.perms.status': 'Ergebnis',
  'authorship.perm.sensitive': 'Sensibel',
  'authorship.perm.notYetAvailable': 'Auf ArtRouting noch nicht verfügbar – eine Zustimmung wird nur festgehalten und gewährt nichts, bis die Funktion startet.',
  'authorship.perm.granted': 'Gewährt',
  'authorship.perm.awaitingAuthor': 'Wartet auf die Autorin / den Autor',
  'authorship.perm.awaitingApprover': 'Wartet auf Zustimmung',
  'authorship.perm.disabled': 'Deaktiviert',
  'authorship.choice.allow': 'Erlauben',
  'authorship.choice.deny': 'Nicht erlauben',
  'authorship.choice.accept': 'Annehmen',
  'authorship.choice.decline': 'Ablehnen',
  'authorship.rules.title': 'Regeln – jedes Kästchen muss angekreuzt werden',
  'authorship.rules.help': 'Beide Seiten akzeptieren dieselben Regeln. Nichts wird aktiv, bevor alle Erforderlichen zugestimmt haben.',
  'authorship.final.owner': 'ROLLENINHABER: Ich habe die obigen Berechtigungen gewählt, die Regeln gelesen und ermächtige diese benannte Person NUR im erlaubten Umfang.',
  'authorship.final.author': 'DELEGIERTE AUTORENSCHAFT: Ich habe die genauen Berechtigungen geprüft, jede angenommen oder abgelehnt, die Regeln gelesen und stimme dem erlaubten Umfang zu.',
  'authorship.final.approver': 'ZUSÄTZLICHE ERFORDERLICHE ZUSTIMMUNG: Ich stimme genau diesem Berechtigungsumfang zu und akzeptiere die Regeln.',
  'authorship.status.pending_owner': 'Wartet auf den Inhaber',
  'authorship.status.pending_author': 'Wartet auf die Autorin / den Autor',
  'authorship.status.pending_approval': 'Wartet auf Zustimmung',
  'authorship.status.active': 'Aktiv',
  'authorship.status.declined': 'Abgelehnt',
  'authorship.status.revoked': 'Beendet',
  'authorship.status.expired': 'Einladung abgelaufen',
  'authorship.list.needsYou': 'Wartet auf Ihre Entscheidung',
  'authorship.list.myAuthors': 'Autorenschaften für meine Rollen',
  'authorship.list.iAuthor': 'Rollen, bei denen ich mitarbeite',
  'authorship.list.ended': 'Beendet',
  'authorship.list.empty': 'Noch keine Autorenschafts-Vereinbarungen.',
  'authorship.list.ownerAuthor': 'Inhaber {owner} · Autor {author}',
  'authorship.list.granted': '{n} gewährt',
  'authorship.rulesVersion': 'Regelversion {v}',
  'authorship.party.owner': 'Rolleninhaber',
  'authorship.party.author': 'Delegierte Autorenschaft',
  'authorship.party.approver': 'Erforderliche Zustimmung',
  'authorship.party.accepted': 'Akzeptiert',
  'authorship.party.approved': 'Zugestimmt',
  'authorship.party.awaitingApproval': 'Noch nicht zugestimmt',
  'authorship.expires': 'Diese Einladung läuft am {date} ab.',
  'authorship.endedNote': 'Beendet am {date}. Der Zugriff endete sofort; Zuschreibung und Verlauf bleiben erhalten.',
  'authorship.change.help': 'Das Einschränken einer Berechtigung wirkt sofort. Eine neu erlaubte Berechtigung beginnt erst, wenn die Autorin / der Autor (und ggf. Zustimmende) sie erneut annehmen.',
  'authorship.change.save': 'Berechtigungsänderungen speichern',
  'authorship.change.saved': 'Berechtigungsänderungen gespeichert.',
  'authorship.respond.submit': 'Meine Auswahl bestätigen',
  'authorship.respond.done': 'Ihre Antworten wurden gespeichert.',
  'authorship.respond.declineAll': 'Einladung ablehnen',
  'authorship.respond.declineAdditions': 'Neue Berechtigungen ablehnen',
  'authorship.respond.declined': 'Abgelehnt.',
  'authorship.owner.confirm': 'Bestätigen und an die Autorin / den Autor senden',
  'authorship.owner.confirmed': 'Bestätigt. Die Autorin / der Autor prüft nun die Berechtigungen.',
  'authorship.approver.approve': 'Diesem Berechtigungsumfang zustimmen',
  'authorship.approver.done': 'Ihre Zustimmung wurde gespeichert.',
  'authorship.revoke.revoke': 'Zugriff widerrufen',
  'authorship.revoke.stepDown': 'Als Autorin / Autor zurücktreten',
  'authorship.revoke.confirmOwner': 'Den Zugriff dieser Person jetzt widerrufen? Das wirkt sofort.',
  'authorship.revoke.confirmAuthor': 'Jetzt zurücktreten? Ihr Zugriff endet sofort.',
  'authorship.revoke.done': 'Der Zugriff ist beendet.',
  'authorship.revoke.help': 'Das Beenden des Zugriffs löscht weder Zuschreibung noch Protokollverlauf.',
  'authorship.history': 'Verlauf',
  'authorship.system': 'ArtRouting',
  'authorship.action.invite': 'eingeladen',
  'authorship.action.owner_confirm': 'vom Inhaber bestätigt',
  'authorship.action.accept': 'von der Autorenschaft angenommen',
  'authorship.action.accept_additions': 'neue Berechtigungen angenommen',
  'authorship.action.decline': 'abgelehnt',
  'authorship.action.decline_additions': 'neue Berechtigungen abgelehnt',
  'authorship.action.approve': 'zugestimmt',
  'authorship.action.activate': 'aktiv geworden',
  'authorship.action.permissions_changed': 'Berechtigungen geändert',
  'authorship.action.revoke': 'beendet',
  'authorship.err.generic': 'Das hat nicht geklappt. Bitte erneut versuchen.',
  'authorship.err.permission_not_chosen': 'Wählen Sie für jede Berechtigung Erlauben oder Nicht erlauben.',
  'authorship.err.rules_not_accepted': 'Jede Regel und die abschließende Zustimmung müssen angekreuzt sein.',
  'authorship.err.author_not_registered': 'Kein ArtRouting-Konto nutzt diese E-Mail-Adresse.',
  'authorship.err.author_is_owner': 'Der Rolleninhaber kann nicht sein eigener Autor sein.',
  'authorship.err.cannot_invite_self': 'Sie können sich nicht selbst einladen.',
  'authorship.err.already_exists': 'Diese Person hat bereits eine offene Vereinbarung für diese Rolle.',
  'authorship.err.tier_cap_reached': 'Die Grenze Ihres Tarifs für delegierte Autorenschaften dieser Rolle ist erreicht. Siehe Preisseite.',
  'authorship.err.not_allowed': 'Das dürfen Sie nicht.',
  'authorship.err.beyond_own_rights': 'Sie können keine Berechtigung vergeben, die Sie selbst nicht haben.',
  'authorship.err.approver_not_registered': 'Eine Zustimmungs-E-Mail hat kein ArtRouting-Konto.',
  'authorship.err.approver_is_author': 'Die Autorin / der Autor kann nicht zugleich zustimmen.',
  'authorship.err.permission_not_answered': 'Nehmen Sie jede erlaubte Berechtigung an oder lehnen Sie sie ab.',
  'authorship.err.wrong_state': 'Diese Vereinbarung kann in ihrem aktuellen Zustand nicht geändert werden.',
  'authorship.err.not_found': 'Vereinbarung nicht gefunden.',
  'authorship.err.role_not_found': 'Diese Rolle existiert nicht mehr.',
  'authorship.err.cannot_edit_own_grant': 'Sie können Ihre eigenen Berechtigungen nicht ändern.',
  'exhibitionRecords.title': 'Berufliche Ausstellungsnachweise',
  'exhibitionRecords.help': 'Verbinden Sie Ihr berufliches Profil mit bestehenden ArtRouting-Ausstellungen, an denen Sie eine anerkannte Rolle hatten. Das verknüpft die Ausstellung, kopiert sie nicht und gibt keine Bearbeitungsrechte.',
  'exhibitionRecords.usage': '{used} von {limit} Nachweisen genutzt',
  'exhibitionRecords.unlimited': '{used} Nachweise · keine Tarifgrenze',
  'exhibitionRecords.notIncluded': 'Ausstellungsnachweise beginnen mit Explorer Aktiv.',
  'exhibitionRecords.notExplorer': 'Ausstellungsnachweise gehören zur Explorer-Rolle. Fügen Sie die Explorer-Rolle unter Rollen & Registrierung hinzu.',
  'exhibitionRecords.search': 'Ausstellungen nach Titel suchen',
  'exhibitionRecords.role': 'Ihre Rolle, z. B. Kuratorin',
  'exhibitionRecords.add': 'Nachweis hinzufügen',
  'exhibitionRecords.remove': 'Entfernen',
  'exhibitionRecords.limitReached': 'Die Nachweis-Grenze Ihres Tarifs ist erreicht.',
  'exhibitionRecords.contributors': 'Beteiligte Fachleute',
  'artworkErr.artwork_limit_reached': 'Die Kunstwerk-PIN-Grenze Ihres Tarifs ({limit}) ist erreicht. Bestehende Kunstwerke bleiben; für mehr bitte upgraden.',
  'artworkErr.venue_artworks_not_included': 'Vom Kunstort verwaltete Kunstwerk-PINs beginnen mit Kunstort Aktiv.',
  'provenanceEvent.status_change': 'Statusänderung',
  'admin.paypal.plans.title': 'Abo-Plan-IDs',
  'admin.paypal.plans.help': 'Jeder bezahlte Tarif auf der Preisseite braucht einen eigenen PayPal-Abo-Plan. Legen Sie ihn unter Abonnements → Pläne an und fügen Sie hier seine Plan-ID ein:',
  'admin.paypal.plans.missingCount': '{n} von {total} Tarifen brauchen noch eine echte PayPal-Plan-ID – unten rot markiert.',
  'admin.paypal.plans.allSet': 'Alle Tarife haben eine echte PayPal-Plan-ID.',
  'admin.paypal.plans.artist': 'Künstler-Tarife',
  'admin.paypal.plans.venue': 'Kunstort-Tarife',
  'admin.paypal.plans.explorer': 'Explorer-Tarife',
  'admin.paypal.plans.heritage': 'Kunsterbe-Tarife',
  'admin.paypal.plans.heritageNote': 'Kunsterbe steht auf der Preisseite als „Demnächst verfügbar“. Die Plan-IDs werden jetzt gespeichert und verwendet, sobald Kunsterbe buchbar ist.',
  'admin.paypal.plans.heritageActive': 'Kunsterbe Aktiv',
  'admin.paypal.plans.heritagePro': 'Kunsterbe Pro',
  'admin.paypal.plans.markerEmpty': 'Noch nicht angelegt – diesen Plan in PayPal erstellen und die Plan-ID einfügen',
  'admin.paypal.plans.markerInvalid': 'Keine echte PayPal-Plan-ID (erwartet: P- gefolgt von 20–30 Buchstaben und Ziffern)',
  'admin.paypal.plans.markerOk': 'Echte Plan-ID',
  'admin.paypal.plans.placeholder': 'P-…',
  // Geführte Registrierung (/welcome), E-Mail-Bestätigung, MV-Pilot
  'register.shortSubtitle': 'Werden Sie in wenigen Minuten Teil von ArtRouting.',
  'register.step.account': 'Konto anlegen: Name, E-Mail-Adresse und Passwort.',
  'register.step.verify': 'E-Mail-Adresse über den zugesandten Link bestätigen.',
  'register.step.rolePin': 'Rolle wählen und den ersten ArtRouting-PIN beanspruchen oder erstellen.',
  'verifyEmail.checking': 'Ihre E-Mail-Adresse wird bestätigt …',
  'verifyEmail.doneTitle': 'E-Mail-Adresse bestätigt',
  'verifyEmail.doneBody': 'Vielen Dank. Setzen Sie Ihre Registrierung dort fort, wo Sie aufgehört haben.',
  'verifyEmail.continue': 'Registrierung fortsetzen',
  'verifyEmail.signInToContinue': 'Anmelden und fortfahren',
  'verifyEmail.failedTitle': 'Dieser Link funktioniert nicht mehr',
  'verifyEmail.failedBody': 'Der Bestätigungslink ist ungültig oder wurde bereits verwendet. Fordern Sie auf Ihrer Registrierungsseite einen neuen an.',
  'verifyEmail.requestNew': 'Neuen Link anfordern',
  'welcome.title': 'Mein ArtRouting einrichten',
  'welcome.subtitle': 'Ein paar kurze Schritte. Ihr Fortschritt wird gespeichert – Sie können jederzeit unterbrechen und später weitermachen.',
  'welcome.loading': 'Ihre Registrierung wird geladen …',
  'welcome.loadFailed': 'Ihre Registrierung konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
  'welcome.actionFailed': 'Das hat nicht geklappt. Bitte versuchen Sie es erneut.',
  'welcome.addRole': 'Weitere Rolle hinzufügen',
  'welcome.banner': 'Schließen Sie die Einrichtung Ihres ArtRouting ab: {step}.',
  'welcome.banner.cta': 'Weiter',
  'welcome.status.account_created': 'E-Mail-Adresse bestätigen',
  'welcome.status.email_verified': 'Rolle wählen',
  'welcome.status.pin_pending': 'ersten PIN beanspruchen oder erstellen',
  'welcome.status.claim_under_review': 'Ihr PIN-Anspruch wird geprüft',
  'welcome.status.profile_pending': 'Mindestprofil vervollständigen',
  'welcome.status.active': 'Registrierung aktiv',
  'welcome.status.mv_pilot_active': 'Registrierung aktiv',
  'welcome.step.email.title': 'E-Mail-Adresse bestätigen',
  'welcome.step.email.pending': 'Wir haben Ihnen einen Bestätigungslink geschickt. Öffnen Sie ihn, um fortzufahren – er bringt Sie direkt hierher zurück.',
  'welcome.step.email.done': 'E-Mail-Adresse bestätigt.',
  'welcome.step.email.resend': 'Link erneut senden',
  'welcome.step.email.resent': 'Ein neuer Bestätigungslink ist unterwegs.',
  'welcome.step.roles.title': 'Rolle wählen',
  'welcome.step.roles.help': 'Wählen Sie zuerst Ihre Hauptrolle. Ein Konto kann mehrere Rollen mit jeweils eigenem Profil haben – weitere lassen sich jederzeit hinzufügen.',
  'welcome.step.roles.primary': 'Hauptrolle',
  'welcome.step.roles.save': 'Rollen speichern',
  'welcome.step.roles.saved': 'Rollen gespeichert.',
  'welcome.step.pin.title': 'Ihr erster ArtRouting-PIN',
  'welcome.step.pin.help': 'Alle Teilnehmenden beginnen mit einem realen Ort auf der Karte. Wenn ArtRouting Sie bereits führt, beanspruchen Sie Ihren PIN. Wenn nicht, erstellen Sie einen neuen.',
  'welcome.step.pin.fromLink': 'Sie sind über diesen PIN gekommen:',
  'welcome.step.pin.claimTitle': 'Ihren ArtRouting-PIN ansehen und beanspruchen',
  'welcome.step.pin.searchPlaceholder': 'Nach Name oder Ort suchen',
  'welcome.step.pin.search': 'Suchen',
  'welcome.step.pin.noResults': 'Kein unbeanspruchter PIN für diese Suche gefunden.',
  'welcome.step.pin.claim': 'Diesen PIN beanspruchen',
  'welcome.step.pin.claimNote': 'Bei der Registrierung beansprucht.',
  'welcome.step.pin.createTitle': 'Noch nicht gelistet?',
  'welcome.step.pin.createHelp': 'Suchen Sie zuerst, damit kein Duplikat entsteht. Ist Ihr Ort nicht gelistet, erstellen Sie einen neuen PIN und bestätigen Sie seine Position auf der Karte.',
  'welcome.step.pin.privacyArtist': 'Künstler: Eine reale Atelier- oder Arbeitsadresse ist nötig, Ihren Atelier-PIN können Sie aber öffentlich ausblenden.',
  'welcome.step.pin.searchFirst': 'Zuerst suchen',
  'welcome.step.pin.create': 'Neuen PIN erstellen',
  'welcome.step.pin.done': 'Ihr erster PIN: {name}.',
  'welcome.step.pin.review': 'Ihr Anspruch auf {name} wird geprüft. Wir benachrichtigen Sie, sobald er bestätigt ist.',
  'welcome.step.pin.view': 'PIN ansehen',
  'welcome.step.area.title': 'Ihre Gegend',
  'welcome.step.area.help': 'Explorer geben Ort und Land oder eine ungefähre Gegend an. Ihre private Adresse wird nie veröffentlicht.',
  'welcome.step.area.placeholder': 'z. B. Rostock, Deutschland',
  'welcome.step.area.save': 'Gegend speichern',
  'welcome.step.profile.title': 'Mindestprofil',
  'welcome.step.profile.artist': 'Legen Sie Ihr Künstlerprofil mit öffentlichem Namen und Medium oder Disziplin an. Alles Weitere kann später folgen.',
  'welcome.step.profile.gallery': 'Ihr Kunstort-PIN braucht öffentlichen Namen, Art des Kunstorts und physische Adresse. Ergänzen Sie Öffnungszeiten oder Terminhinweise, soweit vorhanden.',
  'welcome.step.profile.explorer': 'Ihr öffentlicher Name und Ihre Gegend genügen.',
  'welcome.step.profile.createArtist': 'Künstlerprofil anlegen',
  'welcome.step.profile.editPin': 'Kunstort-PIN vervollständigen',
  'welcome.step.profile.done': 'Mindestprofil vollständig.',
  'welcome.done.title': 'Ihre Registrierung ist aktiv',
  'welcome.done.body': 'Alles Nötige ist vorhanden. Ergänzen Sie den Rest Ihres Profils, wann immer Sie möchten.',
  'welcome.done.open': 'Mein ArtRouting öffnen',
  'welcome.done.continue': 'Dort weitermachen, wo Sie begonnen haben',
  'welcome.mv.title': 'Pilotprojekt Mecklenburg-Vorpommern',
  'welcome.mv.body': 'Ihre ArtRouting-Präsenz liegt in Mecklenburg-Vorpommern: Sie nutzen alle ArtRouting-Funktionen ein Jahr lang ab Ihrem Registrierungsdatum kostenlos – in jeder Ihrer Rollen.',
  'welcome.mv.dates': 'Beginn {start} · Ende {end}',
  'pinDetail.viewAndClaim': 'Ihren ArtRouting-PIN ansehen und beanspruchen',
  'pinDetail.viewAndClaimHelp': 'Ist das Ihr Atelier, Ihr Kunstort oder Ihr Ort? Legen Sie ein kostenloses Konto an und beanspruchen Sie ihn – Sie kehren direkt zu diesem PIN zurück.',
  'pinDetail.registerToClaim': 'Registrieren und beanspruchen',
  'pinDetail.orSignIn': 'Schon registriert? Anmelden',
  'account.section.setup': 'Registrierung & Rollen',
  'account.setup.active': 'Ihre Registrierung ist aktiv. Hier fügen Sie weitere Rollen hinzu oder sehen Ihren ersten PIN.',
  'account.setup.open': 'Rollen & Registrierung',
  'admin.mvPilot.grant': 'MV-Pilot gewähren',
  'admin.mvPilot.end': 'MV-Pilot beenden',
  'admin.mvPilot.granted': 'Pilotprojekt Mecklenburg-Vorpommern für ein Jahr ab Registrierung gewährt.',
  'admin.mvPilot.ended': 'Pilotprojekt Mecklenburg-Vorpommern beendet.',
  'admin.mvPilot.failed': 'Der Pilotstatus konnte nicht geändert werden.',
  'admin.mvPilot.help': 'Pilotprojekt Mecklenburg-Vorpommern: alle Funktionen ein Jahr ab Registrierungsdatum kostenlos. Wird automatisch gewährt, wenn der erste PIN in MV liegt.',



  // ── Subscription ───────────────────────────────────
  'sub.title': 'Mein Abonnement',
  'sub.yourPlan': 'Dein aktueller Plan',
  'sub.status': 'Status',
  'sub.nextBilling': 'N\u00e4chste Abrechnung',
  'sub.since': 'Seit',
  'sub.paypalId': 'PayPal-ID',
  'sub.adminAssigned': 'Dein Plan wurde von einem Administrator zugewiesen. Kein PayPal-Abonnement erforderlich.',
  'sub.freeDesc': 'Du bist auf der kostenlosen Stufe mit einfacher Kartensichtbarkeit. Upgrade f\u00fcr erweiterte Profilfunktionen.',
  'sub.cancelConfirm': 'Bist du sicher, dass du dein Abonnement k\u00fcndigen m\u00f6chtest? Du verlierst den Zugang zu Premium-Funktionen am Ende des aktuellen Abrechnungszeitraums.',
  'sub.cancelBtn': 'Abonnement k\u00fcndigen',
  'sub.cancelling': 'Wird gek\u00fcndigt...',
  'sub.suspended': 'Dein Abonnement ist aufgrund eines Zahlungsproblems pausiert. Bitte aktualisiere deine Zahlungsmethode bei PayPal.',
  'sub.upgrade': 'Plan upgraden',
  'sub.upgradePro': 'Auf Pro upgraden',
  'sub.activated': 'Abonnement erfolgreich aktiviert!',
  'sub.activateFailed': 'Abonnement konnte nicht aktiviert werden. Bitte kontaktiere den Support.',
  'sub.cancelSuccess': 'Abonnement gek\u00fcndigt. Du beh\u00e4ltst den Zugang bis zum Ende des Abrechnungszeitraums.',
  'sub.cancelFailed': 'Abonnement konnte nicht gek\u00fcndigt werden',

  // ── Auth ───────────────────────────────────────────
  'auth.welcomeBack': 'Willkommen zur\u00fcck',
  'auth.loginSubtitle': 'Bei ArtRouting anmelden',
  'auth.createAccount': 'Konto erstellen',
  'auth.registerSubtitle': 'Tritt ArtRouting bei, um Kultur zu entdecken und zu teilen',
  'auth.email': 'E-Mail',
  'auth.emailPlaceholder': 'du@beispiel.de',
  'auth.password': 'Passwort',
  'auth.passwordPlaceholder': 'Mind. 8 Zeichen',
  'auth.confirmPassword': 'Passwort best\u00e4tigen',
  'auth.confirmPlaceholder': 'Passwort erneut eingeben',
  'auth.name': 'Anzeigename',
  'auth.namePlaceholder': 'Dein Name',
  'auth.city': 'Meine Stadt',
  'auth.cityPlaceholder': 'z.B. Amsterdam, Berlin, Kapstadt',
  'auth.cityHelp': 'Legt deinen „In der Nähe"-Standort auf der Karte fest',
  'auth.login': 'Anmelden',
  'auth.loggingIn': 'Anmeldung l\u00e4uft...',
  'auth.register': 'Konto erstellen',
  'auth.registering': 'Konto wird erstellt...',
  'auth.noAccount': 'Noch kein Konto?',
  'auth.registerHere': 'Hier registrieren',
  'auth.hasAccount': 'Bereits ein Konto?',
  'auth.loginHere': 'Hier anmelden',
  'auth.fillAllFields': 'Bitte f\u00fclle alle Felder aus',
  'auth.passwordsNoMatch': 'Passw\u00f6rter stimmen nicht \u00fcberein',
  'auth.passwordTooShort': 'Passwort muss mindestens 8 Zeichen lang sein',
  'auth.agreeRequired': 'Du musst der Datenschutzerkl\u00e4rung und den Nutzungsbedingungen zustimmen',
  'auth.iAmA': '',
  'auth.explorer': 'Entdecker',
  'auth.explorerDesc': 'Ich möchte Kunst entdecken',
  'auth.artist': 'Künstler',
  'auth.artistDesc': 'Ich erschaffe und präsentiere Kunst',
  'auth.gallery': 'Galerie',
  'auth.galleryDesc': 'Ich vertrete eine Galerie oder einen Veranstaltungsort',
  'auth.agreeTo': 'Ich stimme zu',
  'auth.and': 'und',

  // ── Map / Pin Types ────────────────────────────────
  'pin.gallery': 'Galerie',
  'pin.museum': 'Museum',
  'pin.art_centre': 'Kunstzentrum',
  'pin.studio': 'Atelier',
  'pin.venue': 'Veranstaltungsort',
  'pin.heritage': 'Kulturerbe',
  'pin.supplier': 'Zulieferer',
  'pin.education': 'Bildung',
  'pin.residency': 'Residenz',
  'pin.public_art': '\u00d6ffentliche Kunst',
  'pin.cultural_site': 'Kulturst\u00e4tte',
  'pin.collection': 'Sammlung',
  'map.search': 'Pins suchen...',
  'map.filters': 'Filter',
  'map.toggle': 'Umschalten',
  'map.nearMe': 'In meiner N\u00e4he',
  'map.allPins': 'Alle Pins',
  'map.backToMap': 'Zur\u00fcck zur Karte',

  // ── Pin Detail ─────────────────────────────────────
  'pinDetail.loading': 'Pin wird geladen...',
  'pinDetail.notFound': 'Pin nicht gefunden',
  'pinDetail.deleteConfirm': 'Diesen Pin l\u00f6schen? Dies kann nicht r\u00fcckg\u00e4ngig gemacht werden.',
  'pinDetail.claimSubmitted': 'Anspruch eingereicht! Ein Admin wird ihn pr\u00fcfen.',
  'pinDetail.releaseConfirm': 'Diesen Standort freigeben? Du verlierst die Eigent\u00fcmerschaft und er wird nicht mehr beansprucht.',
  'pinDetail.verified': 'Verifiziert',
  'pinDetail.about': '\u00dcber',
  'pinDetail.edit': 'Bearbeiten',
  'pinDetail.delete': 'L\u00f6schen',
  'pinDetail.claim': 'Standort übernehmen',
  'pinDetail.release': 'Freigeben',
  'pinDetail.openingHours': '\u00d6ffnungszeiten',
  'pinDetail.contact': 'Kontakt',
  'pinDetail.website': 'Webseite',
  'pinDetail.address': 'Adresse',
  'pinDetail.amenities': 'Ausstattung',
  'pinDetail.artworks': 'Kunstwerke',
  'pinDetail.historicalPeriod': 'Historische Epoche',
  'pinDetail.historicalDescription': 'Historische Beschreibung',
  'pinDetail.foundation': 'Stiftung',
  'pinDetail.officialWebsite': 'Offizielle Webseite',
  'pinDetail.verificationStatus': 'Verifizierungsstatus',
  'pinDetail.nearbyCulturalLocations': 'Kulturelle Orte in der Nähe',
  'pinDetail.artRouteConnection': 'Verknüpfte Kunstroute',
  'pinDetail.socialMedia': 'Soziale Medien',
  'pinDetail.gallery': 'Galerie',
  'pinDetail.claimPending': 'Anspruch wird geprüft',
  'pinDetail.claimPendingMsg': 'Dein Anspruch wird von einem Administrator geprüft.',
  'pinDetail.galleryImageAlt': 'Galeriebild',

  // Heritage subtypes
  'heritage.artist_estate': 'K\u00fcnstlernachlass',
  'heritage.historic_studio': 'Historisches Atelier',
  'heritage.birthplace': 'Geburtsort',
  'heritage.burial_site': 'Grabst\u00e4tte',
  'heritage.cultural_movement_site': 'Ort der Kulturbewegung',
  'heritage.historic_exhibition': 'Historische Ausstellung',

  // Verification statuses
  'verification.unverified': 'Nicht verifiziert',
  'verification.verified': 'Verifiziert',
  'verification.documented': 'Dokumentiert',
  'verification.community': 'Von der Community vorgeschlagen',

  // Amenities
  'amenity.parking': 'Parkplatz',
  'amenity.wheelchair': 'Rollstuhlgerecht',
  'amenity.cafe': 'Caf\u00e9',
  'amenity.shop': 'Shop',
  'amenity.restrooms': 'Toiletten',
  'amenity.wifi': 'WLAN',
  'amenity.guided_tours': 'F\u00fchrungen',
  'amenity.audio_guide': 'Audioguide',
  'amenity.lockers': 'Schlie\u00dff\u00e4cher',
  'amenity.garden': 'Garten',

  // ── Discover ───────────────────────────────────────
  'discover.all': 'Alle',
  'discover.places': 'Orte',
  'discover.heritage': 'Kulturerbe',
  'discover.events': 'Veranstaltungen',
  'discover.articles': 'Artikel',
  'discover.routes': 'Routen',
  'discover.artists': 'K\u00fcnstler',
  'discover.artworks': 'Kunstwerke',
  'discover.place': 'Ort',
  'discover.places_plural': 'Orte',
  'discover.event': 'Veranstaltung',
  'discover.events_plural': 'Veranstaltungen',
  'discover.article': 'Artikel',
  'discover.articles_plural': 'Artikel',
  'discover.route': 'Route',
  'discover.routes_plural': 'Routen',
  'discover.artist': 'K\u00fcnstler',
  'discover.artists_plural': 'K\u00fcnstler',
  'discover.artwork': 'Kunstwerk',
  'discover.artworks_plural': 'Kunstwerke',
  'discover.heritageSite': 'Kulturerbe-St\u00e4tte',
  'discover.heritageSites': 'Kulturerbe-St\u00e4tten',

  // ── Events ─────────────────────────────────────────
  'event.exhibition': 'Ausstellung',
  'event.opening': 'Er\u00f6ffnung',
  'event.art_fair': 'Kunstmesse',
  'event.workshop': 'Workshop',
  'event.open_studio': 'Offenes Atelier',
  'event.performance': 'Performance',
  'event.festival': 'Festival',
  'event.talk': 'Vortrag / Lesung',
  'event.guided_tour': 'F\u00fchrung',
  'event.dateTBA': 'Datum folgt',
  'event.backToEvents': 'Zur\u00fcck zu Veranstaltungen',

  // Months
  'month.0': 'Januar', 'month.1': 'Februar', 'month.2': 'M\u00e4rz',
  'month.3': 'April', 'month.4': 'Mai', 'month.5': 'Juni',
  'month.6': 'Juli', 'month.7': 'August', 'month.8': 'September',
  'month.9': 'Oktober', 'month.10': 'November', 'month.11': 'Dezember',

  // ── Profiles ───────────────────────────────────────
  'profile.backToArtists': 'Zur\u00fcck zu K\u00fcnstlern',
  'profile.notFound': 'Profil nicht gefunden',
  'profile.deleteConfirm': 'Bist du sicher, dass du dieses Profil l\u00f6schen m\u00f6chtest? Dies kann nicht r\u00fcckg\u00e4ngig gemacht werden.',
  'profile.networkError': 'Netzwerkfehler \u2014 bitte versuche es erneut.',

  // ── Artworks ───────────────────────────────────────
  'artwork.backToArtworks': 'Zur\u00fcck zu Kunstwerken',
  'artwork.notFound': 'Kunstwerk nicht gefunden',

  // ── Routes ─────────────────────────────────────────
  'route.backToRoutes': 'Zur\u00fcck zu Routen',
  'route.notFound': 'Route nicht gefunden',

  // ── Bookmarks ──────────────────────────────────────
  'bookmarks.title': 'Lesezeichen',
  'bookmarks.loginRequired': 'Melde dich an, um deine gespeicherten Eintr\u00e4ge zu sehen.',
  'bookmarks.loading': 'Lesezeichen werden geladen...',
  'bookmarks.savedItem': 'gespeicherter Eintrag',
  'bookmarks.savedItems': 'gespeicherte Eintr\u00e4ge',
  'bookmarks.removeError': 'Fehler beim Entfernen des Lesezeichens',
  'bookmarks.pins': 'Pins',
  'bookmarks.routes': 'Routen',
  'bookmarks.artworks': 'Kunstwerke',
  'bookmarks.articles': 'Artikel',
  'bookmarks.events': 'Veranstaltungen',
  'bookmarks.profiles': 'Profile',
  'bookmarks.empty': 'Noch keine gespeicherten Eintr\u00e4ge',

  // ── Tiers ──────────────────────────────────────────

  // ── Common ─────────────────────────────────────────
  // Admin → Tarifnamen (Superadmin benennt Tarife seitenweit um)
  'admin.backToDashboard': '← Zurück zum Dashboard',
  // Admin → Tarifpreise (Superadmin legt fest, was jeder Tarif kostet)
  'admin.tierPricing.title': 'Tarifpreise',
  'admin.tierPricing.intro': 'Lege fest, was jeder Tarif kostet. Die öffentliche Preisseite und die Bezeichnungen in den PayPal-Einstellungen übernehmen, was du hier einträgst. Beide Sprachen sind erforderlich — die Preiszeile enthält Wörter, nicht nur Zahlen.',
  'admin.tierPricing.paypalNote': 'Das ändert, was ArtRouting als Preis nennt, nicht was PayPal abbucht. Um den tatsächlich berechneten Betrag zu ändern, lege in PayPal einen neuen Plan an und trage dessen ID ein unter',
  'admin.tierPricing.paypalLink': 'PayPal-Einstellungen',
  'admin.tierPricing.priceEn': 'Preis (Englisch)',
  'admin.tierPricing.priceDe': 'Preis (Deutsch)',
  'admin.tierPricing.periodEn': 'Zeitraum (Englisch)',
  'admin.tierPricing.periodDe': 'Zeitraum (Deutsch)',
  'admin.tierPricing.preview': 'Erscheint als',
  'admin.tierPricing.saved': 'Gespeichert — der neue Preis gilt jetzt auf der ganzen Seite',
  'admin.tierPricing.saveFailed': 'Der Preis konnte nicht gespeichert werden',
  'admin.tierPricing.loadFailed': 'Die Tarifpreise konnten nicht geladen werden',
  'admin.tierPricing.reset': 'Alle Preise auf die Standardwerte zurücksetzen',
  'admin.tierPricing.resetConfirm': 'Alle Tarifpreise auf den Standard zurücksetzen? Deine eigenen Preise gehen verloren.',
  'admin.tierPricing.superadminOnly': 'Nur ein Superadmin kann Tarifpreise ändern.',
  'admin.tierNames.title': 'Tarifnamen',
  'admin.tierNames.intro': 'Benenne hier jeden Tarif um. Was du einträgst, zeigt die ganze Seite — Preisseite, Tarif-Badges, Tarif-Editor, Admin-Listen. Beide Sprachen sind erforderlich.',
  'admin.tierNames.nameEn': 'Name (Englisch)',
  'admin.tierNames.nameDe': 'Name (Deutsch)',
  'admin.tierNames.labelEn': 'Untertitel (Englisch)',
  'admin.tierNames.labelDe': 'Untertitel (Deutsch)',
  'admin.tierNames.saved': 'Gespeichert — der neue Name gilt jetzt auf der ganzen Seite',
  'admin.tierNames.saveFailed': 'Der Name konnte nicht gespeichert werden',
  'admin.tierNames.loadFailed': 'Die Tarifnamen konnten nicht geladen werden',
  'admin.tierNames.reset': 'Alle Tarife auf die Standardnamen zurücksetzen',
  'admin.tierNames.resetConfirm': 'Alle Tarifnamen auf den Standard zurücksetzen? Deine eigenen Bezeichnungen gehen verloren.',
  'admin.tierNames.superadminOnly': 'Nur ein Superadmin kann Tarife umbenennen.',
  'common.save': 'Speichern',
  'common.cancel': 'Abbrechen',
  'common.saving': 'Speichern…',
  'common.delete': 'L\u00f6schen',
  'common.edit': 'Bearbeiten',
  'common.create': 'Erstellen',
  'common.loading': 'Wird geladen...',
  'common.error': 'Ein Fehler ist aufgetreten',
  'common.back': 'Zur\u00fcck',
  'common.search': 'Suchen...',
  'common.noResults': 'Keine Ergebnisse gefunden',
  'common.perMonth': '/Monat',
  'common.viewAll': 'Alle anzeigen',
  'common.readMore': 'Mehr lesen',
  'common.showMore': 'Mehr anzeigen',
  'common.showLess': 'Weniger anzeigen',
  'common.preview': 'Vorschau',
  'common.upload': 'Hochladen',
  'common.uploading': 'Wird hochgeladen...',
  'common.selectImage': 'Bitte w\u00e4hle eine Bilddatei',
  'common.imageTooLarge': 'Bild muss kleiner als 10 MB sein',
  'common.uploadFailed': 'Hochladen fehlgeschlagen',

  // ── Legal Pages ────────────────────────────────────
  'legal.privacyTitle': 'Datenschutzerkl\u00e4rung',
  'legal.termsTitle': 'Nutzungsbedingungen',
  'legal.cookiesTitle': 'Cookie-Richtlinie',
  'legal.lastUpdated': 'Zuletzt aktualisiert',
  'legal.backToHome': 'Zur\u00fcck zur Startseite',

  // ── Error Boundary ─────────────────────────────────
  'error.newVersion': 'Eine neue Version ist verf\u00fcgbar.',
  'error.reload': 'Neu laden',

  // ── Articles / ArtRadar ────────────────────────────
  'articles.title': 'ArtRadar',
  'articles.subtitle': 'Geschichten, Highlights und kulturelle Signale',
  'articles.readArticle': 'Artikel lesen',
  'articles.backToArticles': 'Zur\u00fcck zu ArtRadar',
  'articles.noArticles': 'Noch keine Artikel ver\u00f6ffentlicht.',
  'articles.published': 'Ver\u00f6ffentlicht',
  'articles.by': 'von',

  // ── Submissions ────────────────────────────────────
  'submissions.title': 'Einreichungen',
  'submissions.new': 'Neue Einreichung',
  'submissions.loading': 'Einreichungen werden geladen...',
  'submissions.empty': 'Noch keine Einreichungen.',

  // ── Docs ───────────────────────────────────────────
  'docs.title': 'Dokumentation',
  'docs.loading': 'Dokumentation wird geladen...',

  // ── My Pages ───────────────────────────────────────
  'myPins.title': 'Meine Pins',
  'myPins.createPin': 'Pin erstellen',
  'myPins.browseMap': 'Karte durchsuchen',
  'myPins.noPins': 'Noch keine Pins',
  'myPins.noPinsDesc': 'Erstelle einen neuen Pin oder durchsuche die Karte, um Orte zu finden und zu beanspruchen.',
  'myPins.all': 'Alle',
  'myPins.loading': 'Deine Pins werden geladen...',

  'myProfile.title': 'Mein Profil',
  'myProfile.noProfile': 'Du hast noch kein Profil',
  'myProfile.noProfileDesc': 'Erstelle dein K\u00fcnstlerprofil, um deine Arbeit zu pr\u00e4sentieren, auf der Karte entdeckt zu werden und dein Portfolio aufzubauen.',
  'myProfile.createProfile': 'Profil erstellen',
  'myProfile.guidedSetup': 'Geführte Einrichtung',
  'myProfile.importFromUrl': 'Von URL importieren',
  'myProfile.editProfile': 'Profil bearbeiten',
  'myProfile.viewPublic': '\u00d6ffentliches Profil ansehen',

  'myArtworks.title': 'Meine Kunstwerke',
  'myArtworks.addArtwork': 'Kunstwerk hinzuf\u00fcgen',
  'myArtworks.noArtworks': 'Du hast noch keine Kunstwerke hinzugef\u00fcgt',
  'myArtworks.noArtworksDesc': 'F\u00fcge Kunstwerke hinzu, um dein Portfolio zu pr\u00e4sentieren.',
  'myArtworks.importFromWeb': 'Von Webseite importieren',
  'myArtworks.loading': 'Deine Kunstwerke werden geladen...',

  'myRoutes.title': 'Meine Routen',
  'myRoutes.createRoute': 'Route erstellen',
  'myRoutes.noRoutes': 'Noch keine Routen',
  'myRoutes.noRoutesDesc': 'Erstelle eine kulturelle Route, um Orte zu verbinden und Besucher zu f\u00fchren.',
  'myRoutes.loading': 'Deine Routen werden geladen...',

  // ── List Pages ─────────────────────────────────────
  'profilesList.title': 'K\u00fcnstler & Kuratoren',
  'profilesList.subtitle': 'Entdecke K\u00fcnstler, Kuratoren und kreative Fachleute auf der Karte.',
  'profilesList.loading': 'Profile werden geladen...',
  'profilesList.noResults': 'Keine Profile gefunden',
  'profilesList.noResultsDesc': 'Sei der Erste, der ein Profil erstellt.',
  'profilesList.search': 'K\u00fcnstler suchen...',
  'profilesList.allCountries': 'Alle L\u00e4nder',
  'profilesList.artistsTitle': 'K\u00fcnstler & Kollektive',
  'profilesList.artistsSubtitle': 'K\u00fcnstler, Kollektive und andere Kreative auf ArtRouting. Durchsuche die Liste, um Mitstreiter oder Kunden zu finden.',
  'profilesList.artistsSearchPlaceholder': 'K\u00fcnstler nach Name, Stadt, Bio, Medium suchen...',
  'profilesList.noArtists': 'Keine K\u00fcnstler entsprechen dieser Suche.',
  'profilesList.curatorsTitle': 'Kuratoren',
  'profilesList.curatorsSubtitle': 'Kuratoren (Galerien, Agenten, Manager), die dein Profil, deine Kunstwerke und Artikel verwalten k\u00f6nnen.',
  'profilesList.curatorsSearchPlaceholder': 'Kuratoren nach Name, Spezialgebiet, Region, Sprache suchen...',
  'profilesList.noCurators': 'Noch keine Kuratoren entsprechen dieser Suche.',
  'profilesList.createCuratorProfile': 'Mein Kulturelle-Multiplikator-Profil erstellen',
  'profilesList.amplifiersTitle': 'Kulturelle Multiplikatoren',
  'profilesList.amplifiersSubtitle': 'Kuratoren, Journalisten, Sammler, Kritiker, Forscher und andere Fachleute, die das \u00d6kosystem der bildenden Kunst st\u00e4rken und vernetzen.',
  'profilesList.amplifiersSearchPlaceholder': 'Multiplikatoren nach Name, Spezialgebiet, Region, Sprache suchen...',
  'profilesList.noAmplifiers': 'Noch keine Kulturellen Multiplikatoren entsprechen dieser Suche.',
  'account.section.amplifier': 'Kultureller Multiplikator',
  'account.section.amplifierDesc': 'Als {tier} Nutzer kannst du als Kultureller Multiplikator agieren \u2014 eine Fachperson, die K\u00fcnstler unterst\u00fctzt, dokumentiert, organisiert oder das \u00d6kosystem der bildenden Kunst mitgestaltet. W\u00e4hle unten deine Rolle.',
  'account.amplifier.toggle': 'Ich m\u00f6chte als Kultureller Multiplikator agieren',
  'account.amplifier.roleLabel': 'Meine Rolle',
  'account.amplifier.roleHint': 'Deine Rolle wird neben deinem Namen bei den K\u00fcnstlern und Profilen angezeigt, die du unterst\u00fctzt.',
  // Öffentliche Messaging-Rollen — wer jemand ist, nie was er abonniert hat.
  'role.artist': 'Künstler',
  'role.gallery': 'Galerie',
  'role.explorer': 'Explorer',
  'amplifier.role.curator': 'Kurator',
  'amplifier.role.journalist': 'Journalist',
  'amplifier.role.collector': 'Sammler',
  'amplifier.role.critic': 'Kritiker',
  'amplifier.role.researcher': 'Forscher',
  'amplifier.role.historian': 'Historiker',
  'amplifier.role.art_advisor': 'Kunstberater',
  'amplifier.role.organizer': 'Organisator',
  'amplifier.role.editor_writer': 'Redakteur / Autor',

  'artworksList.title': 'Kunstwerke',
  'artworksList.subtitle': 'Erkunde Kunstwerke von K\u00fcnstlern auf der ganzen Welt.',
  'artworksList.loading': 'Kunstwerke werden geladen...',
  'artworksList.noResults': 'Noch keine Kunstwerke',
  'artworksList.noResultsDesc': 'Sei der Erste, der ein Kunstwerk registriert.',
  'artworksList.registerArtwork': 'Kunstwerk registrieren',

  'routesList.title': 'Kulturelle Routen',
  'routesList.subtitle': 'Folge kuratierten Routen durch Kunstviertel, offene Ateliers und Ausstellungswege.',
  'routesList.loading': 'Routen werden geladen...',
  'routesList.noResults': 'Keine Routen gefunden',
  'routesList.search': 'Routen suchen...',
  'routesList.allTypes': 'Alle Typen',
  'routesList.allCountries': 'Alle L\u00e4nder',

  'eventsList.title': 'Veranstaltungen',
  'eventsList.subtitle': 'Ausstellungen, Er\u00f6ffnungen, Workshops und kulturelle Ereignisse.',
  'eventsList.loading': 'Veranstaltungen werden geladen...',
  'eventsList.noResults': 'Keine Veranstaltungen gefunden',
  'eventsList.noResultsDesc': 'Schau bald wieder vorbei f\u00fcr kommende Veranstaltungen.',
  'eventsList.search': 'Veranstaltungen suchen...',
  'eventsList.allTypes': 'Alle Typen',
  'eventsList.upcoming': 'Kommende',
  'eventsList.past': 'Vergangene',
  'eventsList.all': 'Alle',
  'eventsList.pastEvent': 'Vergangene Veranstaltung',
  'eventsList.ended': 'Beendet',
  'eventsList.happeningNow': 'Jetzt live',
  'eventsList.thisWeek': 'Diese Woche',
  'eventsList.thisMonth': 'Diesen Monat',
  'eventsList.laterThisYear': 'Später im Jahr',
  'eventsList.allTime': 'Alle',
  'eventsList.showArchive': 'Archiv anzeigen',
  'eventsList.hideArchive': 'Archiv ausblenden',
  'eventsList.archiveSection': 'Archiv',
  'footer.impressum': 'Impressum',
  'legal.impressumTitle': 'Impressum',
  'legal.impressumSubtitle': 'Angaben gemäß § 5 DDG und § 18 MStV',
  'legal.impressumProject': 'Ein Projekt von:',
  'legal.impressumRepresentedBy': 'Vertretungsberechtigt',
  'legal.impressumAddress': 'Anschrift',
  'legal.impressumContact': 'Kontakt',
  'legal.impressumEmailLabel': 'E-Mail',
  'legal.impressumRegister': 'Handelsregister',
  'legal.impressumRegisterTbd': 'Handelsregistereintrag wird ergänzt.',
  'legal.impressumResponsible': 'Verantwortlich für journalistisch-redaktionelle Inhalte gemäß § 18 Abs. 2 MStV',
  'legal.impressumDisclaimer': 'Haftungsausschluss',
  'legal.impressumDisclaimerBody': 'Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.',

  // ── Discover Page ──────────────────────────────────
  'discover.title': 'Entdecken',
  'discover.subtitle': 'Erkunde die kulturelle Karte',
  'discover.search': 'Orte, K\u00fcnstler, Kunstwerke suchen...',
  'discover.loading': 'Wird entdeckt...',
  'discover.noResults': 'Keine Ergebnisse gefunden',

  // ── Article Categories ─────────────────────────────
  'articleCat.gallery_spotlight': 'Galerie-Spotlight',
  'articleCat.artist_profile': 'K\u00fcnstlerportr\u00e4t',
  'articleCat.exhibition_review': 'Ausstellungskritik',
  'articleCat.cultural_insight': 'Kultureller Einblick',
  'articleCat.route_guide': 'Routenf\u00fchrer',
  'articleCat.news': 'Nachrichten',
  'articleCat.event': 'Veranstaltung',
  'articleCat.opinion': 'Meinung',
  'articleCat.interview': 'Interview',
  'articleCat.opportunity': 'Gelegenheit',
  'articleCat.educational_guide': 'Lernartikel',
  'articleCat.heritage_story': 'Kulturerbe-Geschichte',

  // ── Route Types ────────────────────────────────────
  'routeType.art_trail': 'Kunstpfad',
  'routeType.heritage': 'Kulturerbe',
  'routeType.walking': 'Zu Fuß',
  'routeType.cycling': 'Radfahren',
  'routeType.driving': 'Autofahrt',
  'routeType.cultural': 'Kulturell',
  'routeType.mixed': 'Gemischt',
  'routeType.my_route': 'Eigene Route',

  // ── Form Labels (shared) ───────────────────────────
  'form.title': 'Titel',
  'form.name': 'Name',
  'form.displayName': 'Anzeigename',
  'form.description': 'Beschreibung',
  'form.bio': 'Biografie',
  'form.medium': 'Medium',
  'form.year': 'Jahr',
  'form.dimensions': 'Ma\u00dfe',
  'form.website': 'Webseite',
  'form.city': 'Stadt',
  'form.country': 'Land',
  'form.address': 'Adresse',
  'form.latitude': 'Breitengrad',
  'form.longitude': 'L\u00e4ngengrad',
  'form.visibility': 'Sichtbarkeit',
  'form.status': 'Status',
  'form.type': 'Typ',
  'form.category': 'Kategorie',
  'form.tags': 'Schlagw\u00f6rter',
  'form.image': 'Bild',
  'form.startDate': 'Startdatum',
  'form.endDate': 'Enddatum',
  'form.venue': 'Veranstaltungsort',
  'form.price': 'Preis',
  'form.free': 'Kostenlos',
  'form.selectType': 'Typ w\u00e4hlen',
  'form.selectCountry': 'Land w\u00e4hlen',
  'form.saving': 'Wird gespeichert...',
  'form.create': 'Erstellen',
  'form.update': 'Aktualisieren',
  'form.publish': 'Ver\u00f6ffentlichen',
  'form.draft': 'Entwurf',
  'form.published': 'Ver\u00f6ffentlicht',
  'form.archived': 'Archiviert',
  'form.pending': 'Ausstehend',
  'form.approved': 'Genehmigt',
  'form.rejected': 'Abgelehnt',
  'form.cancel': 'Abbrechen',
  'form.saveChanges': 'Änderungen speichern',
  'form.creating': 'Wird erstellt...',
  'form.delete': 'Löschen',
  'form.confirmDelete': 'Bist du sicher? Dies kann nicht rückgängig gemacht werden.',
  'form.yesDelete': 'Ja, löschen',
  'form.release': 'Freigeben',
  'form.location': 'Standort',
  'form.submitForReview': 'Zur Prüfung einreichen',
  'pinForm.deletePin': 'Pin löschen',
  'adminUsers.deleteUser': 'Löschen + alle Daten',
  'adminUsers.deleteUserTitle': 'Diesen Nutzer und alle damit verbundenen Daten endgültig löschen (DSGVO)',
  'adminUsers.deleteUserConfirm': 'DSGVO-LÖSCHUNG: {name} ({email}) und ALLE Daten — Pins, Kunstwerke, Profile, Routen, Veranstaltungen, Artikel, Lesezeichen und Konto — dauerhaft entfernen? Dies kann nicht rückgängig gemacht werden.',
  'adminUsers.deleteUserDone': 'Nutzer und alle Daten gelöscht.',
  'adminUsers.deleteUserPartial': 'Nutzer gelöscht, aber Verweise verbleiben in:',
  'adminUsers.deleteUserError': 'Nutzer konnte nicht gelöscht werden',
  'adminFreePro.cardTitle': 'Gratis-Pro-Bericht',
  'adminFreePro.cardDesc': 'Alle Nutzer mit der automatischen Gratis-Pro-Testphase — wie lange sie sie schon haben und wann sie ausläuft. Nutze ihn, um sie zur Umstellung anzuschreiben oder zurück auf Gratis fallen zu lassen.',
  'adminFreePro.cardStat': 'In Testphase',
  'adminFreePro.cardCta': 'Erstellen →',
  'adminFreePro.title': 'Gratis-Pro-Bericht',
  'adminFreePro.subtitle': 'Nutzer mit der bei der Registrierung automatisch vergebenen Gratis-Pro-Testphase. Schreibe sie an, um sie auf einen bezahlten Tarif umzustellen — oder lass die Testphase zurück auf Gratis auslaufen.',
  'adminFreePro.backToAdmin': '← Zurück zum Admin',
  'adminFreePro.loading': 'Bericht wird erstellt…',
  'adminFreePro.error': 'Gratis-Pro-Bericht konnte nicht geladen werden.',
  'adminFreePro.empty': 'Derzeit befindet sich kein Nutzer in einer Gratis-Pro-Testphase.',
  'adminFreePro.statTotal': 'In Gratis-Pro-Testphase',
  'adminFreePro.statExpiringSoon': 'Läuft in 7 Tagen aus',
  'adminFreePro.statExpired': 'Bereits ausgelaufen',
  'adminFreePro.generatedAt': 'Erstellt',
  'adminFreePro.copyEmails': 'E-Mail-Liste kopieren',
  'adminFreePro.copied': 'Kopiert!',
  'adminFreePro.downloadCsv': 'CSV herunterladen',
  'adminFreePro.refresh': 'Aktualisieren',
  'adminFreePro.colName': 'Name',
  'adminFreePro.colEmail': 'E-Mail',
  'adminFreePro.colType': 'Typ',
  'adminFreePro.colRegistered': 'Registriert',
  'adminFreePro.colDaysOnPro': 'Tage mit Gratis-Pro',
  'adminFreePro.colTrialTier': 'Test-Tarif',
  'adminFreePro.colExpires': 'Testphase endet',
  'adminFreePro.colDaysLeft': 'Tage übrig',
  'adminFreePro.colStatus': 'Status',
  'adminFreePro.statusActive': 'Aktiv',
  'adminFreePro.statusExpired': 'Ausgelaufen',
  'adminFreePro.daysSuffix': 'T',
  'superadmin.deleteItem': 'Löschen (Admin)',
  'superadmin.deleteItemConfirm': 'Dieses Element endgültig löschen? Dies kann nicht rückgängig gemacht werden.',
  'superadmin.deleteError': 'Löschen fehlgeschlagen',
  'superadmin.wipeOwner': 'Eigentümer + alle Daten löschen',
  'superadmin.wipeOwnerConfirm': 'DSGVO-LÖSCHUNG: {name} und ALLE Daten — Pins, Kunstwerke, Profile, Routen, Veranstaltungen, Artikel, Lesezeichen und Konto — dauerhaft entfernen? Dies kann nicht rückgängig gemacht werden.',
  'superadmin.wipeOwnerDone': 'Eigentümer und alle Daten gelöscht.',
  'superadmin.wipeOwnerPartial': 'Eigentümer gelöscht, aber Verweise verbleiben in:',
  'pinForm.createPin': 'Pin erstellen',
  'pinForm.amenities': 'Ausstattung',
  'pinForm.associatedArtist': 'Verknüpfter Künstler',
  'pinForm.foundationName': 'Name der Stiftung',
  'pinForm.galleryMission': 'Galerie-Auftrag',
  'pinForm.heritageType': 'Typ des Kulturerbes',
  'pinForm.historicalDescription': 'Historische Beschreibung',
  'pinForm.historicalPeriod': 'Historische Epoche',
  'pinForm.officialWebsite': 'Offizielle Webseite',
  'pinForm.sourceReferences': 'Quellenangaben',
  'pinForm.verificationStatus': 'Verifizierungsstatus',
  'eventForm.createEvent': 'Veranstaltung erstellen',
  'eventForm.venueName': 'Name des Veranstaltungsorts',

  // ── Profile Types ──────────────────────────────────
  'profileType.artist': 'K\u00fcnstler',
  'profileType.collective': 'Kollektiv',
  'profileType.curator': 'Kurator',
  'profileType.gallery': 'Galerie',

  // ── Create/Edit Pages ──────────────────────────────
  'createProfile.title': 'Profil erstellen',
  'editProfile.title': 'Profil bearbeiten',
  'createArtwork.title': 'Kunstwerk erstellen',
  'editArtwork.title': 'Kunstwerk bearbeiten',
  'createEvent.title': 'Veranstaltung erstellen',
  'editEvent.title': 'Veranstaltung bearbeiten',
  'createRoute.title': 'Route erstellen',
  'editRoute.title': 'Route bearbeiten',
  'createPin.title': 'Pin erstellen',
  'editPin.title': 'Pin bearbeiten',

  // ── Route Detail ───────────────────────────────────
  'routeDetail.stops': 'Haltestellen',
  'routeDetail.distance': 'Entfernung',
  'routeDetail.duration': 'Dauer',
  'routeDetail.difficulty': 'Schwierigkeit',
  'routeDetail.startRoute': 'Route starten',

  // ── Provenance ─────────────────────────────────────
  'provenance.title': 'Provenienz',
  'provenance.history': 'Geschichte',
  'provenance.claimOwnership': 'Eigentum beanspruchen',
  'provenance.verified': 'Verifiziert',
  'provenance.certificate': 'Herkunftsnachweis',
  'provenance.verifiedChain': 'ArtRouting — Verifizierte Eigentumskette',
  'provenance.notFound': 'Kunstwerk nicht gefunden',
  'provenance.transfer': 'Eigentum übertragen',
  'provenance.printCert': 'Zertifikat drucken',
  'provenance.noEvents': 'Noch keine Provenienz-Ereignisse erfasst.',
  'provenance.disputed': 'Angefochten',
  'provenance.unverified': 'Nicht verifiziert',
  'provenance.currentOwner': 'Aktueller Eigentümer',
  'provenance.ownershipHistory': 'Eigentumsgeschichte',
  'provenance.timeline': 'Provenienz-Zeitleiste',
  'provenance.claimBtn': 'Dieses Kunstwerk gehört mir',
  'provenance.howAcquired': 'Wie haben Sie dieses Kunstwerk erworben?',
  'provenance.selectMethod': 'Auswählen...',
  'provenance.dateAcquired': 'Erwerbsdatum',
  'provenance.notes': 'Anmerkungen / Beschreibung',
  'provenance.noRecords': 'Noch keine Provenienz-Einträge',
  'provenance.allQrLink': 'Alle QR-Codes verlinken auf:',
  'provenance.permanent': 'Permanent — dieser Link ändert sich nie',
  'provenance.qrGenerating': 'QR wird generiert...',
  'provenance.reloadPage': 'Seite neu laden',

  // Provenance event types
  'provenanceEvent.creation': 'Erstellt',
  'provenanceEvent.created': 'Erstellt',
  'provenanceEvent.sale': 'Verkauf',
  'provenanceEvent.gift': 'Schenkung',
  'provenanceEvent.inheritance': 'Erbschaft',
  'provenanceEvent.commission': 'Auftragsarbeit',
  'provenanceEvent.exhibition_loan': 'Ausstellungsleihe',
  'provenanceEvent.exhibition_return': 'Ausstellungsrückgabe',
  'provenanceEvent.consignment': 'Kommission',
  'provenanceEvent.auction': 'Auktion',
  'provenanceEvent.donation': 'Spende',
  'provenanceEvent.theft': 'Diebstahl',
  'provenanceEvent.theft_reported': 'Diebstahl gemeldet',
  'provenanceEvent.recovery': 'Wiedererlangung',
  'provenanceEvent.recovered': 'Wiedergefunden',
  'provenanceEvent.restoration': 'Restaurierung',
  'provenanceEvent.appraisal': 'Bewertung',
  'provenanceEvent.found_claimed': 'Gefunden/Beansprucht',
  'provenanceEvent.location_change': 'Standortwechsel',
  'provenanceEvent.deaccession': 'Abgang',
  'provenanceEvent.exhibition': 'Ausstellung',
  'provenanceEvent.loan': 'Leihgabe',
  'provenanceEvent.return': 'Rückgabe',
  'provenanceEvent.other': 'Sonstiges',

  // Transfer form
  'transfer.newOwnerName': 'Name des neuen Eigentümers',
  'transfer.newOwnerEmail': 'E-Mail des neuen Eigentümers',
  'transfer.type': 'Übertragungsart',
  'transfer.date': 'Übertragungsdatum',
  'transfer.notes': 'Anmerkungen',
  'transfer.submitting': 'Wird übertragen...',

  // ── Lens ─────────────────────────────────────────
  'lens.notFound': 'Nicht gefunden',
  'lens.notFoundDesc': 'Dieser Eintrag konnte auf ArtRouting nicht gefunden werden.',
  'lens.viewProvenance': 'Provenienz anzeigen',
  'lens.provenanceDesc': 'Eigentumskette und Geschichte',
  'lens.location': 'Standort',
  'lens.discoveredVia': 'Entdeckt über ArtRouting',
  'lens.entityArtwork': 'Kunstwerk',
  'lens.entityPin': 'Standort',
  'lens.entityProfile': 'Künstler',
  'lens.entityRoute': 'Kulturroute',
  'lens.entityEvent': 'Veranstaltung',
  'lens.qrLinksTo': 'Dieser QR-Code verlinkt auf:',
  'lens.qrIdentical': 'Alle QR-Codes oben sind identisch — wählen Sie die passende Größe.',
  'lens.sizeMedium': 'Mittel',

  // ── Consignment ──────────────────────────────────
  'consignment.yourPrice': 'Ihr Preis:',
  'consignment.galleryPrice': 'Galeriepreis:',
  'consignment.artistAskingPrice': 'Preisvorstellung des Künstlers:',
  'consignment.galleryDisplayPrice': 'Galerie-Anzeigepreis',
  'consignment.notesOptional': 'Anmerkungen (optional)',
  'consignment.accept': 'Annehmen',
  'consignment.reject': 'Ablehnen',
  'consignment.withdraw': 'Zurückziehen',
  'consignment.remove': 'Entfernen',
  'consignment.inboxTitle': 'Einreichungseingang',
  'consignment.inboxDesc': 'Kunstwerk-Einreichungen von Künstlern prüfen. Mit Galeriepreis annehmen oder ablehnen.',
  'consignment.myTitle': 'Meine Einreichungen',
  'consignment.submitToEvent': 'Für Veranstaltung einreichen',
  'consignment.selectEvent': 'Veranstaltung auswählen...',
  'consignment.askingPrice': 'Ihre Preisvorstellung',
  'consignment.submitting': 'Wird eingereicht...',
  'consignment.submit': 'Einreichen',
  'consignment.submitted': 'Einreichung gesendet!',

  // ── Artwork Detail ───────────────────────────────
  'artworkDetail.medium': 'Medium',
  'artworkDetail.dimensions': 'Maße',
  'artworkDetail.yearCreated': 'Entstehungsjahr',
  'artworkDetail.location': 'Standort',
  'artworkDetail.price': 'Preis',
  'artworkDetail.availability': 'Verfügbarkeit',
  'artworkDetail.contact': 'Kontakt',
  'artworkDetail.claimArtwork': 'Dieses Kunstwerk beanspruchen',
  'artworkDetail.claimSubmitted': 'Anspruch eingereicht!',
  'artworkDetail.saved': 'Gespeichert',
  'artworkDetail.anonymous': 'Anonym',
  'artworkDetail.available': 'Verfügbar',
  'artworkDetail.sold': 'Verkauft',
  'artworkDetail.onLoan': 'Leihgabe',
  'artworkDetail.notForSale': 'Nicht verkäuflich',
  'artworkDetail.salesContact': 'Verkaufskontakt',
  'artworkDetail.pinLocation': 'Pin / Standort',
  'artworkDetail.provenance': 'Provenienz',
  'artworkDetail.condition': 'Zustand',

  // ── Profile Detail ───────────────────────────────
  'profileDetail.hostPins.title': 'Galerien & Ateliers',
  'profileDetail.claimProfile': 'Dieses Profil beanspruchen',
  'profileDetail.claimSubmitted': 'Anspruch eingereicht!',
  'profileDetail.artisticStyle': 'Künstlerischer Stil:',
  'profileDetail.studioHours': 'Atelierzeiten:',
  'profileDetail.saved': 'Gespeichert',

  // ── Article Detail ───────────────────────────────
  'articleDetail.moreFrom': 'Mehr von ArtRadar',
  'articleDetail.notFound': 'Artikel nicht gefunden',
  'articleDetail.saved': 'Gespeichert',

  // ── Map Page ─────────────────────────────────────
  'map.viewDetails': 'Details anzeigen',
  'map.partOfRoute': 'Teil einer Route',
  'map.viewRoute': 'Route anzeigen',
  'map.youAreHere': 'Sie sind hier',
  'map.eventFilter.label': 'Events auf der Karte',
  'map.eventFilter.all': 'Alle Zeit',
  'map.eventFilter.now': 'Jetzt',
  'map.eventFilter.week': 'Diese Woche',
  'map.eventFilter.month': 'Diesen Monat',
  'map.eventFilter.later': 'Später',
  'map.pastelCommunity': 'Pastell = Community',
  'map.brightVerified': 'Hell = Eigentümer verifiziert',

  // ── Discover Page Extras ─────────────────────────
  'discover.showAllTypes': 'Alle Typen anzeigen',
  'discover.allCountries': 'Alle Länder',
  'discover.clearSearch': 'Suche löschen',
  'discover.loadMore': 'Mehr laden',
  'discover.locating': 'Wird geortet...',
  'discover.nearMeOn': 'In der Nähe AN',
  'discover.nearMe': 'In der Nähe',
  'discover.browsing': 'Durchsuche',
  'discover.items': 'Einträge',
  'discover.item': 'Eintrag',
  'discover.within': 'innerhalb von',
  'discover.km': 'km',
  'discover.found': 'Gefunden:',
  'discover.resultsFor': 'Ergebnisse für',
  'discover.resultFor': 'Ergebnis für',

  // ── Events List Extras ───────────────────────────
  'eventsList.dateTBA': 'Datum folgt',
  'eventsList.locating': 'Wird geortet...',
  'eventsList.nearMeOn': 'In der Nähe AN',
  'eventsList.nearMe': 'In der Nähe',
  'eventsList.loadMore': 'Mehr laden',
  'eventsList.remaining': 'übrig',

  // ── Route List Extras ────────────────────────────
  'routesList.easy': 'Einfach',
  'routesList.moderate': 'Mittel',
  'routesList.challenging': 'Anspruchsvoll',

  // ── Submission Pages ─────────────────────────────
  'submission.newPin': 'Neuer Pin',
  'submission.updatePin': 'Pin aktualisieren',
  'submission.newEvent': 'Neue Veranstaltung',
  'submission.newRoute': 'Neue Route',
  'submission.newArticle': 'Neuer Artikel',
  'submission.emptyDesc': 'Sie haben noch nichts eingereicht',
  'submission.untitled': 'Ohne Titel',
  'submission.needsChanges': 'Änderungen nötig',
  'submission.notFound': 'Einreichung nicht gefunden',
  'submission.region': 'Region',

  // ── Bookmarks Extras ─────────────────────────────
  'bookmarks.emptyDesc': 'Speichern Sie Einträge von der Karte, Routen oder Artikeln, um sie hier wiederzufinden.',


  // ── Docs ─────────────────────────────────────────
  'docs.saving': 'Wird gespeichert...',
  'docs.save': 'Speichern',
  'docs.documents': 'Dokumente',

  // ── Pin Edit/Create Extras ───────────────────────
  'pinForm.phone': 'Telefon',
  'pinForm.email': 'E-Mail',
  'pinForm.openingHours': 'Öffnungszeiten',
  'pinForm.entryFee': 'Eintrittspreis',
  'pinForm.languages': 'Sprachen',
  'pinForm.mission': 'Galerie- / Veranstaltungsort-Mission',
  'pinForm.culturalSignificance': 'Kulturelle Bedeutung',
  'pinForm.historicalNotes': 'Historische Anmerkungen',
  'pinForm.bestTimeToVisit': 'Beste Besuchszeit',

  // ── Event Edit/Create Extras ─────────────────────
  'eventForm.eventTitle': 'Veranstaltungstitel',
  'eventForm.eventType': 'Veranstaltungstyp',
  'eventForm.recurrence': 'Wiederholung',
  'eventForm.oneTime': 'Einmalig',
  'eventForm.daily': 'Täglich',
  'eventForm.weekly': 'Wöchentlich',
  'eventForm.monthly': 'Monatlich',
  'eventForm.linkedVenue': 'Verknüpfter Veranstaltungsort (Pin)',
  'eventForm.ticketPrice': 'Ticketpreis',
  'eventForm.deleteConfirm': 'Diese Veranstaltung löschen? Dies kann nicht rückgängig gemacht werden.',
  'eventForm.saved': 'Gespeichert!',
  'eventForm.deleting': 'Wird gelöscht...',

  // ── Profile Edit/Create Extras ───────────────────
  'profileForm.mediums': 'Medien',
  'profileForm.instagram': 'Instagram',
  'profileForm.facebook': 'Facebook',

  // ── Artwork Edit/Create Extras ───────────────────
  'artworkForm.artistName': 'Künstlername',
  'artworkForm.artworkUid': 'Werk-ID',
  'artworkForm.createArtwork': 'Werk erstellen',
  'profileForm.createProfile': 'Profil erstellen',
  'profileForm.displayName': 'Anzeigename',
  'profileForm.profileType': 'Profiltyp',
  'routeForm.createRoute': 'Route erstellen',
  'routeForm.deleteRoute': 'Route löschen',

  // ── Route Create Extras ──────────────────────────
  'routeForm.difficulty': 'Schwierigkeitsgrad',
  'routeForm.easy': 'Einfach',
  'routeForm.moderate': 'Mittel',
  'routeForm.challenging': 'Anspruchsvoll',
  'routeForm.region': 'Region',

  // ── Event Detail ─────────────────────────────────
  'eventDetail.artworks': 'Kunstwerke',
  'eventDetail.tags': 'Schlagwörter',
  'eventDetail.linkedPins': 'Orte bei dieser Veranstaltung',
  'eventDetail.joinEvent': 'An dieser Veranstaltung teilnehmen',
  'eventDetail.joinEventHint': 'Verknüpfe deine Orte und Kunstwerke, damit sie erscheinen, wenn jemand diese Veranstaltung auf der Karte erkundet. Du kannst denselben Eintrag mit mehreren Veranstaltungen verknüpfen.',
  'eventDetail.yourPins': 'Deine Orte',
  'eventDetail.yourArtworks': 'Deine Kunstwerke',
  'eventDetail.clickToShowArtists': 'Klicken, um teilnehmende Künstler anzuzeigen',
  'eventDetail.clickToShowPlaces': 'Klicken, um Orte anzuzeigen',
  'eventDetail.clickToHide': 'Klicken zum Einklappen',

  // ── Months (abbreviated) ─────────────────────────
  'monthShort.0': 'Jan', 'monthShort.1': 'Feb', 'monthShort.2': 'Mär',
  'monthShort.3': 'Apr', 'monthShort.4': 'Mai', 'monthShort.5': 'Jun',
  'monthShort.6': 'Jul', 'monthShort.7': 'Aug', 'monthShort.8': 'Sep',
  'monthShort.9': 'Okt', 'monthShort.10': 'Nov', 'monthShort.11': 'Dez',

  // ── Pin Detail Extras ────────────────────────────
  'pinDetail.claimPin': 'Standort übernehmen',
  'pinDetail.claimSupport': 'Diesen Eintrag verwalten und bearbeiten — Standort selbst verwalten und aktuell halten.',
  'pinDetail.claimPlaceholder': 'Warum übernimmst du diesen Standort? (z. B. Ich bin der Galerist)',
  'pinDetail.claimReleaseConfirm': 'Diesen Standort freigeben? Du verlierst die Eigentümerschaft und er wird nicht mehr beansprucht.',


  // ── Common Extras ────────────────────────────────
  'common.saved': 'Gespeichert',
  'common.submitting': 'Wird gesendet...',
  'common.lensQr': 'Lens-QR',
  'common.editPin': 'Pin bearbeiten',
  'common.manage': 'Verwalten',
  'common.newArticle': 'Neuer Artikel',
  'common.createRoute': 'Route erstellen',
  'common.createEvent': 'Veranstaltung erstellen',
  'common.createProfile': 'Profil erstellen',
  'common.all': 'Alle',
  'common.artist': 'K\u00fcnstler',
  'common.collective': 'Kollektiv',
  'common.curator': 'Kurator',
  'common.kmAway': 'km entfernt',
  'common.showOnMap': 'Auf Karte zeigen',
  'common.loadingOf': 'Wird geladen...',
  'common.of': 'von',
  'common.away': 'entfernt',
  'common.nearby': 'in der N\u00e4he',
  'share.share': 'Teilen',
  'share.sendToFriend': 'An einen Freund senden',
  'share.whatsapp': 'WhatsApp',
  'share.copyLink': 'Link kopieren',
  'share.copied': 'Link kopiert!',
  'share.email': 'E-Mail',
  'share.viaArtRouting': 'auf ArtRouting',
  'discover.unclaimed': 'Nicht beansprucht',
  'nav.messages': 'Nachrichten',
  // Messaging — stummschalten, blockieren und der eigene An/Aus-Schalter
  'messaging.fieldTier': 'Tarif',
  'messaging.fieldAmplifier': 'Multiplikator',
  'curatorType.creator': 'Ersteller',
  'curatorType.manager': 'Manager',
  'curatorType.agent': 'Agent',
  'messaging.fieldRole': 'Rolle',
  'messaging.fieldCountry': 'Land',
  'messaging.fieldLocation': 'Ort',
  'messaging.removeMember': 'Entfernen',
  'messaging.removeMemberConfirm': '{name} aus dieser Gruppe entfernen? Die Person verliert den Zugang. Bereits gesendete Nachrichten bleiben im Gespräch.',
  'messaging.errCannotRemoveOwner': 'Wer die Gruppe erstellt hat, kann nicht entfernt werden — lösche stattdessen die Gruppe.',
  'messaging.errNotAMember': 'Diese Person ist nicht in dieser Gruppe.',
  'messaging.groupMembers': 'Gruppenmitglieder',
  'messaging.groupOwner': 'Ersteller',
  'messaging.deleteGroup': 'Gruppe löschen',
  'messaging.deleteGroupConfirm': 'Diese Gruppe löschen? Sie verschwindet für alle Mitglieder, samt allen Nachrichten. Das lässt sich nicht rückgängig machen.',
  'messaging.errNotGroupOwner': 'Nur wer die Gruppe erstellt hat, kann sie löschen.',
  'messaging.errNotAGroup': 'Dieses Gespräch ist keine Gruppe.',
  'messaging.errConversationNotFound': 'Dieses Gespräch existiert nicht mehr.',
  'messaging.conversationMenu': 'Optionen für das Gespräch',
  'messaging.mute': 'Gespräch stummschalten',
  'messaging.unmute': 'Stummschaltung aufheben',
  'messaging.muted': 'Stummgeschaltet',
  'messaging.block': 'Diese Person blockieren',
  'messaging.unblock': 'Blockierung aufheben',
  'messaging.blocked': 'Blockiert',
  'messaging.blockConfirm': 'Diese Person blockieren? Ihr könnt euch dann keine Nachrichten mehr schreiben, bis du die Blockierung aufhebst. Die Person erfährt nichts davon.',
  'messaging.blockedNotice': 'Du hast diese Person blockiert. Hebe die Blockierung auf, um wieder zu schreiben.',
  'messaging.blockedPeople': 'Blockierte Personen',
  'messaging.noBlocked': 'Du hast niemanden blockiert.',
  'messaging.privacy': 'Privatsphäre',
  'messaging.turnOff': 'Nachrichten ausschalten',
  'messaging.turnOn': 'Nachrichten einschalten',
  'messaging.offTitle': 'Nachrichten sind ausgeschaltet',
  'messaging.offBody': 'Deine Nachrichtenfunktion ist ausgeschaltet. Niemand kann ein Gespräch mit dir beginnen oder dich zu einer Gruppe hinzufügen, und „Nachrichten“ bleibt aus deinem Menü verschwunden.',
  'messaging.offConfirm': 'Nachrichten ausschalten? Niemand kann dir dann schreiben oder dich zu einer Gruppe hinzufügen, und „Nachrichten“ verschwindet aus deinem Menü, bis du es wieder einschaltest.',
  'messaging.errBlockedByYou': 'Du hast diese Person blockiert. Hebe die Blockierung auf, um zu schreiben.',
  'messaging.errBlockedByThem': 'Diese Person nimmt keine Nachrichten an.',
  'messaging.errRecipientUnavailable': 'Diese Person nimmt keine Nachrichten an.',
  'messaging.errMessagingOff': 'Deine Nachrichtenfunktion ist ausgeschaltet. Schalte sie ein, um zu schreiben.',
  'messaging.errNoReachableMembers': 'Keine der ausgewählten Personen nimmt derzeit Nachrichten an.',
  'messaging.errSendFailed': 'Senden fehlgeschlagen',
  'messaging.errFailed': 'Das hat nicht geklappt',
  'account.section.messaging': 'Nachrichten',
  'account.section.messagingDesc': 'Entscheide, ob dir andere Menschen auf ArtRouting schreiben können.',
  'account.messaging.toggle': 'Nachrichten an mich erlauben',
  'account.messaging.hintOn': '„Nachrichten“ erscheint in deinem Menü und andere können ein Gespräch mit dir beginnen oder dich zu einer Gruppe hinzufügen.',
  'account.messaging.hintOff': 'Nachrichten sind aus — du bist in der Personensuche und bei Gruppeneinladungen nicht sichtbar, und „Nachrichten“ fehlt in deinem Menü.',
  'account.messaging.saved': 'Nachrichteneinstellung gespeichert',
  'common.close': 'Schließen',
  'messaging.title': 'Nachrichten',
  'messaging.newMessage': 'Neue Nachricht',
  'messaging.searchRecipient': 'Personen suchen…',
  'messaging.noConversations': 'Noch keine Unterhaltungen',
  'messaging.send': 'Senden',
  'messaging.typeMessage': 'Nachricht schreiben…',
  'messaging.notAvailable': 'Nachrichten sind für dein Konto noch nicht verfügbar.',
  'messaging.sent': 'Gesendet',
  'messaging.delivered': 'Zugestellt',
  'messaging.read': 'Gelesen',
  'messaging.markUnread': 'Als ungelesen markieren',
  'messaging.markRead': 'Als gelesen markieren',
  'messaging.markUnreadHint': 'Behalte dies als ungelesene Erinnerung im Posteingang (der Absender sieht es weiterhin als gelesen).',
  'messaging.markReadHint': 'Ungelesen-Erinnerung entfernen.',
  'messaging.selectConversation': 'Wähle eine Unterhaltung, um zu chatten',
  'messaging.changeAvatar': 'Foto ändern',
  'messaging.uploadPhoto': 'Foto hochladen',
  'messaging.useProfilePhoto': 'Profilfoto verwenden',
  'messaging.removePhoto': 'Foto entfernen',
  'messaging.direct': 'Direkt',
  'messaging.group': 'Gruppe',
  'messaging.groupName': 'Gruppenname',
  'messaging.createGroup': 'Gruppe erstellen',
  'messaging.members': 'Mitglieder',
  'messaging.myStatus': 'Dein Status',
  'messaging.statusAvailable': 'Offen zum Chatten',
  'messaging.statusBusy': 'Nicht offen zum Chatten',
  'messaging.statusOffline': 'Offline',
  'messaging.searchMessages': 'Nachrichten suchen',
  'messaging.searchHint': 'Tippe, um deine Nachrichten zu durchsuchen',
  'messaging.noResults': 'Keine Nachrichten gefunden',
  'messaging.you': 'Du',
  'messaging.notesToSelf': 'Notizen an mich – notiere alles, was du dir merken willst',
  'nav.aboutUs': 'Über uns',
  'common.remaining': '\u00fcbrig',
  'common.results': 'Ergebnisse',
  'common.result': 'Ergebnis',
  'common.loadMore': 'Mehr laden',
  'common.myArtworks': 'Meine Kunstwerke',
  'common.allDifficulties': 'Alle Schwierigkeitsgrade',
  'common.stops': 'Haltestellen',
  'common.days': 'Tage',
  'common.routes': 'Routen',
  'common.verified': 'Verifiziert',
  'common.locating': 'Wird geortet...',
  'common.nearMeOn': 'In der N\u00e4he AN',
  'common.nearMe': 'In der N\u00e4he',
  'common.pinTypes': 'Pin-Typen',
  'common.loadingPins': 'Pins werden geladen...',
  'common.searchPlaceholder': 'Stadt oder Ort suchen...',
  'common.searching': 'Suche',
  'common.clearAll': 'Alle entfernen',
  'common.filters': 'Filter',
  'common.pinType': 'Ortstyp',
  'common.routeType': 'Routentyp',
  'common.profileType': 'Profiltyp',
  'common.articleCategory': 'Artikelkategorie',
  'common.eventType': 'Veranstaltungstyp',
  'common.sortEvents': 'Veranstaltungen sortieren',
  'common.discoverType': 'Entdecken-Typ',
  'common.country': 'Land',
  'common.allCountries': 'Alle Laender',
  'filter.what': 'Was',
  'filter.where': 'Wo',
  'filter.when': 'Wann',
  'filter.cityTown': 'Stadt / Ort',
  'filter.searchCityTown': 'Stadt oder Ort suchen...',
  'filter.dateRange': 'Zeitraum',
  'filter.from': 'Von',
  'filter.to': 'Bis',
  'common.manageArticles': 'Artikel verwalten',
  'common.manageArticlesDesc': 'Redaktionelle Inhalte erstellen, bearbeiten und verwalten',
  'common.publicView': '\u00d6ffentliche Ansicht',
  'common.noArticlesYet': 'Noch keine Artikel. Erstellen Sie Ihren ersten!',
  'common.createArticle': 'Artikel erstellen',
  'common.noArticlesMatch': 'Keine Artikel entsprechen Ihrer Suche',
  'common.searchArticles': 'Artikel suchen...',
  'common.acceptsStudioVisits': 'Atelierbesuche m\u00f6glich',
  'common.artisticPhilosophy': 'K\u00fcnstlerische Philosophie',
  'common.contactLinks': 'Kontakt & Links',
  'common.artworksByArtist': 'Kunstwerke dieses K\u00fcnstlers',
  'common.getDirections': 'Wegbeschreibung',
  'common.submitClaim': 'Anspruch einreichen',
  'common.claimPending': 'Ihr Anspruch wird von einem Administrator \u00fcberpr\u00fcft.',
  'common.claimDescription': 'Ist dies Ihr K\u00fcnstlerprofil? Reichen Sie einen Anspruch ein, um verifizierter Eigent\u00fcmer zu werden.',
  'common.claimPlaceholder': 'Warum beanspruchen Sie dieses Profil? (optional)',
  'common.routesWillAppear': 'Kulturelle Routen erscheinen hier, sobald sie erstellt werden.',
  'common.loadingMoreRoutes': 'Weitere Routen werden geladen...',

  // ── Pin Types ───────────────────────────────────
  'pinType.gallery': 'Galerie',
  'pinType.museum': 'Museum',
  'pinType.art_centre': 'Kunstzentrum',
  'pinType.studio': 'Atelier',
  'pinType.venue': 'Veranstaltungsort',
  'pinType.heritage': 'Kulturerbe',
  'pinType.supplier': 'Lieferant',
  'pinType.education': 'Bildung',
  'pinType.residency': 'Residenz',
  'pinType.public_art': '\u00d6ffentliche Kunst',
  'pinType.cultural_site': 'Kulturst\u00e4tte',
  'pinType.collection': 'Sammlung',
  'pinType.artist': 'K\u00fcnstler',
  'pinType.artwork': 'Kunstwerk',

  // ── Profile Section Titles ─────────────────────
  'profile.about': '\u00dcber',
  'profile.mediums': 'Medien',
  'profile.tags': 'Schlagw\u00f6rter',
  'profile.artisticStyle': 'K\u00fcnstlerischer Stil',
  'profile.studioHours': 'Atelierzeiten',
  'profile.viewProfile': 'Künstlerprofil ansehen',
  'profile.events': 'Veranstaltungen',
  'profile.eventsDesc': 'Verknüpfen Sie Ihre Pins mit bevorstehenden Veranstaltungen, damit sie auf der Karte erscheinen.',
  'profile.eventsNoPins': 'Sie haben noch keine beanspruchten Pins. Erstellen oder beanspruchen Sie zuerst einen Pin.',
  'profile.eventsNoEvents': 'Keine bevorstehenden Veranstaltungen gefunden.',
  'profile.eventsJoin': 'Beitreten',
  'profile.eventsLeave': 'Verlassen',
  'profile.eventsJoined': 'Beigetreten',
  'profile.eventsLoading': 'Veranstaltungen werden geladen…',

  // ── Profile Form ──────────────────────────────────
  'profileForm.artisticPhilosophy': 'K\u00fcnstlerische Philosophie',
  'profileForm.contactEmail': 'Kontakt-E-Mail',
  'profileForm.coverImageUrl': 'Titelbild-URL',
  'profileForm.profileImageUrl': 'Profilbild-URL',
  'profileForm.studioVisits': 'Ich akzeptiere Atelierbesuche',
  'profileForm.studioInfo': 'Atelier-Informationen',
  'profileForm.visibilityStatus': 'Sichtbarkeitsstatus',
  'profileForm.importAuto': 'Profil automatisch importieren',
  'profileForm.hideFromMap': 'Mein Profil von der Karte ausblenden',
  'profileForm.hideFromMapHint': 'Mein Profil bleibt durchsuchbar und über verbundene Galerien / Ateliers erreichbar, aber mein eigener Punkt wird nicht auf der Karte gezeigt.',
  'profileForm.hostPins.title': 'Verbundene Galerien & Ateliers',
  'profileForm.hostPins.desc': 'Verknüpfen Sie Ihr Profil mit Galerien oder Ateliers, die Ihre Arbeit zeigen. Besucher dieser Orte sehen Sie unter „Hier vertretene Künstler" — nützlich, wenn Ihr eigener Pin ausgeblendet ist.',
  'profileForm.hostPins.searchLabel': 'Galerie oder Atelier finden',
  'profileForm.hostPins.searchPlaceholder': 'Mindestens 2 Zeichen eingeben…',
  'profileForm.hostPins.roleLabel': 'Beziehung',
  'profileForm.hostPins.role.represented_by': 'Vertreten durch',
  'profileForm.hostPins.role.studio_at': 'Atelier bei',
  'profileForm.hostPins.role.exhibits_at': 'Stellt aus bei',
  'profileForm.hostPins.role.collective_member': 'Kollektiv-Mitglied',
  'profileForm.hostPins.verb.represented_by': 'wird vertreten von',
  'profileForm.hostPins.verb.studio_at': 'hat ein Atelier bei',
  'profileForm.hostPins.verb.exhibits_at': 'stellt aus bei',
  'profileForm.hostPins.verb.collective_member': 'ist Teil von',
  'profileForm.hostPins.youLabel': 'Sie',
  'profileForm.hostPins.remove': 'Entfernen',
  'profileForm.hostPins.alreadyLinked': 'Bereits verknüpft',

  // ── Pin Form ──────────────────────────────────────
  'pinForm.clickMap': 'Klicken Sie auf die Karte, um Koordinaten festzulegen',

  // ── Event Form (additional) ───────────────────────
  'eventForm.culturalSignificance': 'Kulturelle Bedeutung',
  'eventForm.organizerEmail': 'Veranstalter-E-Mail',
  'eventForm.organizerName': 'Veranstaltername',
  'eventForm.participatingArtists': 'Teilnehmende Künstler',
  'eventForm.artistsHint': 'Künstler, Galerien oder Veranstaltungsorte suchen oder Namen eingeben und Enter drücken',
  'eventForm.searchArtists': 'Suchen oder Namen eingeben…',
  'eventForm.addCustomArtist': 'Hinzufügen',
  'eventForm.noArtistsLinked': 'Noch keine Teilnehmer hinzugefügt',
  'eventForm.linkedPlaces': 'Orte in diesem Event',
  'eventForm.searchPins': 'Pins suchen um sie hinzuzufügen…',
  'eventForm.noLinkedPlaces': 'Noch keine Orte verknüpft. Suchen Sie oben nach Studios, Galerien, Veranstaltungsorten…',
  'eventForm.ticketUrl': 'Ticket-URL',

  // ── Route Form (additional) ───────────────────────
  'routeForm.bestSeason': 'Beste Jahreszeit',
  'routeForm.coverImage': 'Titelbild f\u00fcr Routenkarten und Detailseite',
  'routeForm.estimatedDuration': 'Gesch\u00e4tzte Dauer',
  'routeForm.imageUrl': 'Bild-URL',
  'routeForm.slug': 'Slug',
  'routeForm.culturalSignificance': 'Kulturelle Bedeutung',

  // ── Provenance ────────────────────────────────────
  'provenance.date': 'Datum',
  'provenance.eventType': 'Ereignistyp',
  'provenance.location': 'Ort',
  'provenance.latest': 'NEUESTE',

  // ── Submission (additional) ───────────────────────
  'submission.imageUrl': 'Bild-URL',
  'submission.photoLink': 'Link zu einem Foto des Veranstaltungsortes',
  'submission.moderatorNotes': 'Anmerkungen f\u00fcr den Moderator',

  // ── Kontakt ─────────────────────────────────────────
  'contact.title': 'Kontakt',
  'contact.subtitle': 'Haben Sie eine Frage, einen Vorschlag oder m\u00f6chten Sie zusammenarbeiten? Senden Sie uns eine Nachricht und wir melden uns bei Ihnen.',
  'contact.directEmail': 'Oder schreiben Sie uns direkt',
  'contact.yourDetails': 'Ihre Angaben',
  'contact.name': 'Name',
  'contact.namePlaceholder': 'Ihr vollst\u00e4ndiger Name',
  'contact.email': 'E-Mail',
  'contact.emailPlaceholder': 'ihre@email.com',
  'contact.yourMessage': 'Ihre Nachricht',
  'contact.message': 'Nachricht',
  'contact.messagePlaceholder': 'Erz\u00e4hlen Sie uns, was Ihnen am Herzen liegt...',
  'contact.send': 'Nachricht senden',
  'contact.sending': 'Wird gesendet...',
  'contact.sendFailed': 'Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
  'contact.allRequired': 'Bitte f\u00fcllen Sie alle Felder aus.',
  'contact.thankYou': 'Nachricht gesendet!',
  'contact.successMessage': 'Vielen Dank f\u00fcr Ihre Nachricht. Wir melden uns an die angegebene E-Mail-Adresse.',
  'contact.sendAnother': 'Weitere Nachricht senden',
  'footer.contact': 'Kontakt',

  // ── Common (additional) ───────────────────────────
  'common.login': 'Anmelden',

  // ── Import Wizard ─────────────────────────────────
  'importWizard.title': 'Profil von URL importieren',
  'importWizard.subtitle': 'Erstellen Sie Ihr Künstlerprofil aus Ihrer Webpräsenz',
  'importWizard.introTitle': 'Willkommen beim Profilimport',
  'importWizard.introDesc': 'Dieser Assistent hilft Ihnen, Ihr Künstlerprofil aus Ihrer bestehenden Webpräsenz zu erstellen. Halten Sie Folgendes bereit:',
  'importWizard.checklist': 'Was Sie brauchen',
  'importWizard.checkUrls': 'Ihre Website-, Portfolio- oder Social-Media-URLs',
  'importWizard.checkImages': 'Profilfoto und Kunstwerke (werden automatisch extrahiert)',
  'importWizard.checkBio': 'Ihre Biografie oder Künstlerstatement (wird extrahiert oder Sie können eines schreiben)',
  'importWizard.checkLocation': 'Ihre Studio-/Galeriestadt und Ihr Land',
  'importWizard.checkSocial': 'Social-Media-Links (Instagram, Facebook usw.)',
  'importWizard.howItWorks': 'So funktioniert es',
  'importWizard.step1Desc': 'Fügen Sie Ihre Website- & Social-URLs ein — wir scannen sie mit KI',
  'importWizard.step2Desc': 'Überprüfen Sie die extrahierten Daten — Kunstwerke auswählen, Text bearbeiten',
  'importWizard.step3Desc': 'Profil verfeinern — Name, Bio, Medien',
  'importWizard.step4Desc': 'Standort & Social-Links hinzufügen',
  'importWizard.step5Desc': 'Überprüfen und speichern — alles auf einmal',
  'importWizard.importMode': 'Importmodus',
  'importWizard.importForMyself': 'Für mich importieren',
  'importWizard.importForMyselfDesc': 'Kunstwerke zu Ihrem Profil & Studio hinzufügen',
  'importWizard.importNewArtist': 'Neuen Künstler importieren',
  'importWizard.importNewArtistDesc': 'Ein eigenständiges Profil für einen anderen Künstler erstellen',
  'importWizard.getStarted': 'Loslegen',
  'importWizard.urlTitle': 'Ihre URLs hinzufügen',
  'importWizard.urlDesc': 'Fügen Sie Ihre Website-, Portfolio- oder Social-Media-URLs ein. Wir scannen jede mit KI, um Ihre Infos und Kunstwerke zu extrahieren.',
  'importWizard.urlsLabel': 'Website- oder Social-Media-URLs',
  'importWizard.singleInput': 'Einzeleingabe',
  'importWizard.pasteMultiple': 'Mehrere einfügen',
  'importWizard.bulkPlaceholder': 'Mehrere URLs hier einfügen, eine pro Zeile',
  'importWizard.addUrls': 'Hinzufügen',
  'importWizard.addAnotherUrl': 'Weitere URL hinzufügen',
  'importWizard.extracting': 'Extrahiere',
  'importWizard.extractPreview': 'Extrahieren & Vorschau',
  'importWizard.orManual': 'oder manuell erstellen',
  'importWizard.extractingInfo': 'Jede URL dauert bis zu 30 Sekunden. Wir scannen jede Seite mit KI, um Künstlerinformationen, Biografien und Kunstwerke zu extrahieren.',
  'importWizard.tipsTitle': 'Tipps für beste Ergebnisse',
  'importWizard.tip1': 'Fügen Sie mehrere URLs hinzu — Website, Instagram, Facebook usw.',
  'importWizard.tip2': 'Ihre Portfolio- oder "Über mich"-Seite liefert die beste Bio und Kunstwerke',
  'importWizard.tip3': 'Instagram- und Facebook-Künstlerseiten werden unterstützt',
  'importWizard.tip4': 'Jede URL bereichert Ihr Profil — Kunstwerke aus allen Quellen werden kombiniert',
  'importWizard.tip5': 'Sie sehen eine vollständige Vorschau, bevor etwas gespeichert wird',
  'importWizard.reviewTitle': 'Extrahierte Daten überprüfen',
  'importWizard.reviewDesc': 'Wir haben Folgendes aus Ihren URLs gefunden. Wählen Sie die Kunstwerke aus, die Sie behalten möchten, und bearbeiten Sie jeden Text.',
  'importWizard.duplicateFound': 'Ähnliche Profile gefunden',
  'importWizard.duplicateDesc': 'Wir haben Profile mit einem ähnlichen Namen gefunden. Sie können in ein bestehendes zusammenführen oder ein neues erstellen.',
  'importWizard.exactMatch': 'EXAKTE ÜBEREINSTIMMUNG',
  'importWizard.mergeInto': 'Zusammenführen',
  'importWizard.cancelMerge': 'Zusammenführung abbrechen — stattdessen neu erstellen',
  'importWizard.noName': 'Kein Name extrahiert',
  'importWizard.artworksFound': 'Gefundene Kunstwerke',
  'importWizard.selected': 'ausgewählt',
  'importWizard.deselectAll': 'Alle abwählen',
  'importWizard.selectAll': 'Alle auswählen',
  'importWizard.artworkTitle': 'Titel',
  'importWizard.medium': 'Medium',
  'importWizard.year': 'Jahr',
  'importWizard.dimensions': 'Maße',
  'importWizard.noArtworks': 'Auf den gecrawlten Seiten wurden keine Kunstwerke gefunden. Sie können nach dem Speichern manuell Kunstwerke hinzufügen.',
  'importWizard.nextProfile': 'Weiter: Profil bearbeiten',
  'importWizard.profileTitle': 'Profildetails',
  'importWizard.profileDesc': 'Bearbeiten Sie Ihre Profilinformationen. Felder sind aus den extrahierten Daten vorausgefüllt.',
  'importWizard.namePlaceholder': 'Künstler- oder Galeriename',
  'importWizard.bioPlaceholder': 'Erzählen Sie der Welt von Ihrer künstlerischen Praxis...',
  'importWizard.stylePlaceholder': 'z.B. Zeitgenössisch, Abstrakt, Realismus',
  'importWizard.nextLocation': 'Weiter: Standort & Links',
  'importWizard.locationTitle': 'Standort & Links',
  'importWizard.locationDesc': 'Fügen Sie Ihren Standort hinzu, damit Leute Sie auf der Karte finden, und Ihre Webpräsenz.',
  'importWizard.cityPlaceholder': 'z.B. Amsterdam',
  'importWizard.countryPlaceholder': 'z.B. Niederlande',
  'importWizard.nextReview': 'Weiter: Überprüfen & Speichern',
  'importWizard.reviewTitle2': 'Überprüfen & Speichern',
  'importWizard.reviewDesc2': 'Überprüfen Sie alles vor dem Speichern. Stellen Sie sicher, dass alle Details korrekt sind.',
  'importWizard.duplicateWarning': 'Duplikat-Warnung',
  'importWizard.duplicateWarningDesc': 'Profile mit ähnlichen Namen existieren bereits. Erwägen Sie eine Zusammenführung, um Duplikate zu vermeiden.',
  'importWizard.mergingInto': 'Wird in bestehendes Profil zusammengeführt',
  'importWizard.addingToYour': 'Wird Ihrem Profil hinzugefügt',
  'importWizard.creatingNew': 'Neues eigenständiges Profil wird erstellt',
  'importWizard.noLocation': 'Kein Standort festgelegt',
  'importWizard.hasWebsite': 'Website',
  'importWizard.mediums': 'Medien',
  'importWizard.socialLinks': 'Social-Links',
  'importWizard.artworksToImport': 'Kunstwerk(e) zum Importieren',
  'importWizard.addToProfile': 'Zu meinem Profil hinzufügen',
  'importWizard.mergeAndSave': 'Zusammenführen & Speichern',
  'importWizard.saveProfile': 'Profil speichern',
  'importWizard.profileUpdated': 'Profil aktualisiert!',
  'importWizard.profileCreated': 'Profil erstellt!',
  'importWizard.artworksSaved': 'Kunstwerk(e) gespeichert',
  'importWizard.reviewEdit': 'Profil überprüfen & bearbeiten',
  'importWizard.viewProfile': 'Profil anzeigen',
  'importWizard.importAnother': 'Weiteres Profil importieren',
  'importWizard.startOver': 'Neu beginnen',
  'importWizard.stepIntro': 'Start',
  'importWizard.stepUrls': 'URLs',
  'importWizard.stepReview': 'Überprüfen',
  'importWizard.stepProfile': 'Profil',
  'importWizard.stepLocation': 'Standort',
  'importWizard.stepSave': 'Speichern',
  'importWizard.addressPlaceholder': 'z.B. Hauptstraße 12, 10115 Berlin',
  'importWizard.addressHint': 'Straße, Hausnummer, PLZ — für genaue Kartenplatzierung.',
  'importWizard.pinWillCreate': 'Kartenpin wird erstellt',
  'importWizard.noPinWarning': 'Kein Kartenpin ohne Standort — geben Sie mindestens Ihre Stadt ein.',
  'importWizard.doNotNavigate': 'Bitte warten — schließen oder verlassen Sie diese Seite nicht.',
  'profileForm.address': 'Vollständige Adresse',

  // ── Profile Wizard (Guided Setup) ─────────────────
  'wizard.title': 'Künstlerprofil erstellen',
  'wizard.introDesc': 'Dieser Assistent führt Sie in 5 einfachen Schritten durch die Einrichtung Ihres Profils auf ArtRouting. Bevor Sie beginnen, hier was Sie brauchen. Keine Sorge — alles ist optional und Ihr Fortschritt wird automatisch gespeichert, Sie können jederzeit unterbrechen und später weitermachen.',
  'wizard.step1Title': 'Ihr Name und ein Profilfoto',
  'wizard.step2Title': 'Eine kurze Biografie über Ihre Kunst',
  'wizard.step3Title': 'Ihre Stadt und Ihr Land',
  'wizard.step4Title': 'Ihre Website und Social-Media-Links',
  'wizard.step5Title': 'Überprüfen und veröffentlichen',
  'wizard.haveWebsite': 'Haben Sie eine Website oder Instagram?',
  'wizard.haveWebsiteDesc': 'Sie können in Schritt 1 einen Link einfügen und wir füllen automatisch Ihren Namen, Ihre Bio, Ihr Foto und Ihre Social-Links mit KI aus. Das dauert ca. 10 Sekunden.',
  'wizard.progressSaved': 'Ihr Fortschritt wird automatisch gespeichert',
  'wizard.progressSavedDesc': 'Sie können diese Seite schließen und später wiederkommen — Sie machen genau dort weiter, wo Sie aufgehört haben.',
  'wizard.step1of5': 'Schritt 1 von 5',
  'wizard.step2of5': 'Schritt 2 von 5',
  'wizard.step3of5': 'Schritt 3 von 5',
  'wizard.step4of5': 'Schritt 4 von 5',
  'wizard.step5of5': 'Schritt 5 von 5',
  'wizard.letsGetStarted': 'Legen wir los',
  'wizard.step1Desc': 'Zuerst die Grundlagen. Sagen Sie uns, wer Sie sind, damit Besucher Sie auf ArtRouting finden können.',
  'wizard.quickImport': 'Schnell-Import — fügen Sie Ihre URLs ein und wir füllen alles für Sie aus',
  'wizard.yourName': 'Ihr Name',
  'wizard.whatDescribes': 'Was beschreibt Sie am besten?',
  'wizard.profilePhoto': 'Profilfoto',
  'wizard.tellStory': 'Erzählen Sie Ihre Geschichte',
  'wizard.step2Desc': 'Teilen Sie mit, was Ihre Kunst einzigartig macht. Das hilft Besuchern, sich mit Ihrer Arbeit zu verbinden.',
  'wizard.aboutYou': 'Über Sie',
  'wizard.artStyle': 'Ihr Kunststil',
  'wizard.mediums': 'Medien, mit denen Sie arbeiten',
  'wizard.tapToSelect': 'Tippen zum Auswählen. Sie können unten auch eigene eingeben.',
  'wizard.whereAreYou': 'Wo sind Sie ansässig?',
  'wizard.step3Desc': 'So erscheinen Sie auf der ArtRouting-Karte und Menschen in Ihrer Nähe können Sie entdecken. Geben Sie Ihre Adresse ein und wir finden die Koordinaten automatisch.',
  'wizard.fullAddress': 'Vollständige Adresse',
  'wizard.cityTown': 'Stadt / Ort',
  'wizard.country': 'Land',
  'wizard.coverImage': 'Titelbild',
  'wizard.pinWillCreate': 'Kartenpin wird erstellt',
  'wizard.noPinWarning': 'Kein Kartenpin ohne Standort',
  'wizard.verifyLocation': 'Standort auf Karte überprüfen',
  'wizard.connectWorld': 'Verbinden Sie sich mit der Welt',
  'wizard.step4Desc': 'Fügen Sie Ihre Links hinzu, damit Besucher Ihrer Arbeit folgen können. Einfach die vollständige URL oder Ihren Benutzernamen einfügen. Alles ist optional.',
  'wizard.websitePortfolio': 'Ihre Website oder Portfolio',
  'wizard.socialMedia': 'Soziale Medien',
  'wizard.contactEmail': 'Kontakt-E-Mail',
  'wizard.reviewPublish': 'Überprüfen & Veröffentlichen',
  'wizard.step5Desc': 'So sieht Ihr Profil aus. Gehen Sie zurück, um Änderungen vorzunehmen, oder speichern Sie jetzt und bearbeiten Sie später weiter.',
  'wizard.saveAsDraft': 'Als Entwurf speichern',
  'wizard.publishProfile': 'Profil veröffentlichen',
  'wizard.continue': 'Weiter',
  'wizard.resumeWhereLeft': 'Dort weitermachen, wo ich aufgehört habe',
  'wizard.startFresh': 'Neu beginnen',
  'wizard.letMeStart': 'Los geht\'s!',
  'wizard.clickToExpand': 'aufklappen',
  'wizard.backToProfile': 'Zurück zu Mein Profil',

  // ── i18n sweep 2026-04-21 ──
  'account.title': 'Kontoeinstellungen',
  'account.subtitle': 'Deine persönlichen Kontoeinstellungen. Diese sind getrennt von deinem Künstlerprofil.',
  'account.section.info': 'Kontoinformationen',
  'account.section.infoDesc': 'Deine Anmeldedaten und Kontoart. Zum Ändern deines Passworts nutze die Option „Passwort ändern".',
  'account.label.email': 'E-Mail',
  'account.label.displayName': 'Anzeigename',
  'account.label.tier': 'Stufe',
  'account.tier.free': 'Kostenlos',
  'account.tier.tier1': 'Profil',
  'account.tier.tier2': 'Pro',
  'account.section.role': 'Deine Rolle',
  'account.section.roleDesc': 'Wechsle jederzeit zwischen Explorer, Künstler oder Galerie — ohne Neuregistrierung. Die Rollenänderung aktualisiert, was du auf ArtRouting tun kannst (entdecken, Arbeit präsentieren, Galerie vertreten).',
  'account.role.explorer': 'Explorer',
  'account.role.explorerDesc': 'Ich möchte Kunst entdecken',
  'account.role.artist': 'Künstler',
  'account.role.artistDesc': 'Ich möchte meine Kunst präsentieren',
  'account.role.gallery': 'Kunstort',
  'account.role.galleryDesc': 'Ich präsentiere oder stelle Kunst an einem physischen Ort aus – Galerie, Museum, Messe, Pop-up',
  'account.role.updated': 'Rolle aktualisiert!',
  'account.role.failed': 'Rolle konnte nicht geändert werden. Bitte versuche es erneut.',
  'account.section.nearme': 'Standort für „In meiner Nähe"',
  'account.section.nearmeDesc': 'Lege deine Stadt für die Funktion „In meiner Nähe" fest. Beim Klick wird die Karte auf diesen Ort zentriert, statt dein GPS zu verwenden. Leer lassen, um GPS zu nutzen.',
  'account.nearme.label': 'Stadt für „In meiner Nähe"',
  'account.nearme.placeholder': 'z. B. Berlin, Rostock, Amsterdam…',
  'account.nearme.hint': 'Gib deine Stadt ein. Wenn du „In meiner Nähe" auf der Karte nutzt, wird rund um diesen Ort gesucht. Leer = GPS-Abfrage im Browser.',
  'account.nearme.save': 'Standort speichern',
  'account.nearme.saving': 'Wird gespeichert…',
  'account.nearme.saved': 'Gespeichert!',
  'account.nearme.failed': 'Speichern fehlgeschlagen. Bitte erneut versuchen.',
  'account.section.privacy': 'Karte & Adresse – Privatsphäre',
  'account.section.privacyDesc': 'Lege fest, ob deine Standortmarkierung und deine Adresse öffentlich auf der Karte angezeigt werden.',
  'account.privacy.toggle': 'Meine Markierung und Adresse auf der Karte anzeigen',
  'account.privacy.hintOn': 'Deine Markierung erscheint auf der Karte und deine Adresse ist sichtbar, damit dich Besucher finden und besuchen können.',
  'account.privacy.hintOff': 'Deine Markierung wird von der Karte entfernt und deine Adresse wird überall ausgeblendet. Deine Kunstwerke, Artikel und dein Profil bleiben sichtbar.',
  'account.privacy.saved': 'Gespeichert!',
  'account.privacy.failed': 'Speichern fehlgeschlagen. Bitte erneut versuchen.',
  'account.loginRequired': 'Bitte einloggen, um die Kontoeinstellungen zu sehen.',
  'account.section.artistProfile': 'Künstlerprofil',
  'account.section.artistProfileDesc': 'Dein Künstlerprofil ist deine öffentliche Präsenz auf ArtRouting — Bio, Kunstwerke, Standort auf der Karte und mehr. Getrennt von den Kontoeinstellungen oben.',
  'account.goToProfile': 'Zu meinem Künstlerprofil →',
  'account.section.curator': 'Kurator',
  'account.section.curatorDesc': 'Als {tier} Nutzer kannst du als Kurator agieren — eine Galerie, ein Agent oder Manager, der Profile, Kunstwerke und Artikel im Namen von Künstlern erstellt und verwaltet. Wähle unten, ob und in welcher Rolle du als Kurator agieren möchtest.',
  'account.curator.toggle': 'Ich möchte als Kurator agieren',
  'account.curator.typeLabel': 'Kurator-Typ',
  'account.curator.type.creator': 'Creator — Ich erstelle Profile und Inhalte von Grund auf',
  'account.curator.type.manager': 'Manager — Ich verwalte bestehende Künstlerdaten und -präsenz',
  'account.curator.type.agent': 'Agent — Ich vertrete Künstler als professioneller Agent',
  'account.curator.typeHint': 'Dein gewählter Typ wird neben deinem Namen bei den von dir kuratierten Künstlern angezeigt.',
  'account.curator.saved': 'Kurator-Einstellungen gespeichert.',
  'account.curator.failed': 'Kurator-Einstellungen konnten nicht gespeichert werden.',

  'profileDetail.curateThisArtist': 'Diesen Künstler kuratieren',
  'profileDetail.curating': 'Du kuratierst diesen Künstler',
  'profileDetail.curatingDesc': 'Dieser Künstler erscheint in deinem Menü „Meine Künstler“. Klicke unten, um die Kuration zu beenden.',
  'profileDetail.curateDesc': 'Füge diesen Künstler zu „Meine Künstler“ hinzu. Als {type} kannst du Profil, Kunstwerke und Artikel an einem Ort verwalten.',
  'profileDetail.curateButton': 'Diesen Künstler kuratieren',
  'profileDetail.stopCurating': 'Kuration beenden',
  'profileDetail.curateFailed': 'Kurator-Status konnte nicht aktualisiert werden.',
  'profileDetail.curatedBy': 'Kuratiert von',
  'profileDetail.artistsIWorkWith': 'Künstler, mit denen ich arbeite',
  'profileDetail.noArtistsYet': 'Noch keine Künstler kuratiert.',
  'profileDetail.curatedEvents': 'Kuratierte Veranstaltungen / Projekte',
  'profileDetail.noEventsYet': 'Noch keine Veranstaltungen organisiert.',

  'myArtists.title': 'Meine Künstler',
  'myArtists.subtitle': 'Künstler, die du kuratierst. Klicke auf einen Künstler, um Profil, Kunstwerke und Artikel in einem Arbeitsbereich zu sehen.',
  'myArtists.empty': 'Du kuratierst noch keine Künstler.',
  'myArtists.emptyHint': 'Öffne ein Künstlerprofil und klicke auf „Diesen Künstler kuratieren“, um ihn hier hinzuzufügen.',
  'myArtists.notCurator': 'Kurator-Zugang erforderlich',
  'myArtists.notCuratorDesc': '„Meine Künstler“ ist nur für {tier} Nutzer verfügbar, die in den Kontoeinstellungen den Kurator-Modus aktiviert haben.',
  'myArtists.goToAccount': 'Zu den Kontoeinstellungen',
  'myArtists.back': 'Zurück zu Meine Künstler',
  'myArtists.openProfile': 'Öffentliches Profil öffnen',
  'myArtists.editProfile': 'Profil bearbeiten',
  'myArtists.bio': 'Biografie',
  'myArtists.artworks': 'Kunstwerke',
  'myArtists.articles': 'Artikel',
  'myArtists.noArtworks': 'Noch keine Kunstwerke.',
  'myArtists.noArticles': 'Noch keine Artikel.',
  'myArtists.notFound': 'Künstler nicht gefunden oder nicht mehr kuratiert.',
  'myArtists.detailLoadFailed': 'Künstlerdetails konnten nicht geladen werden.',
  'myArtists.addArtist': 'Künstler hinzufügen',
  'myArtists.cancelAdd': 'Abbrechen',
  'myArtists.searchLabel': 'Künstler nach Name suchen',
  'myArtists.searchPlaceholder': 'Mindestens 2 Zeichen eingeben...',
  'myArtists.noSearchResults': 'Keine passenden Künstler gefunden.',
  'myArtists.addFailed': 'Künstler konnte nicht hinzugefügt werden.',

  'myArticles.title': 'Meine Artikel',
  'myArticles.subtitle': 'Artikel, die Sie geschrieben haben. Artikel von Mitgliedern werden vor der Veröffentlichung von der ArtRadar-Redaktion geprüft.',
  'myArticles.createNew': 'Neuen Artikel einreichen',
  'myArticles.createFirst': 'Ersten Artikel einreichen',
  'myArticles.empty': 'Du hast noch keine Artikel.',
  'myArticles.emptyFilter': 'Keine Artikel entsprechen diesem Filter.',
  'myArticles.deleteConfirm': '„{title}" löschen? Dies kann nicht rückgängig gemacht werden.',
  'myArticles.deleteFailed': 'Artikel konnte nicht gelöscht werden.',
  'myArticles.filter.all': 'Alle',
  'myArticles.filter.draft': 'Entwürfe',
  'myArticles.filter.published': 'Veröffentlicht',

  'myCurators.title': 'Meine Kuratoren',
  'myCurators.subtitle': 'Kuratoren (Galerien, Agenten und Manager), die eines deiner Profile kuratieren. Füge unten einen Kurator hinzu, damit dieser deine Kunstwerke und Artikel mitverwalten kann.',
  'myCurators.empty': 'Noch keine eigenen Profile.',
  'myCurators.emptyHint': 'Wenn ein Kurator dich hinzufügt, erscheint er hier, gruppiert nach dem Profil, das er kuratiert.',
  'myCurators.emptyClaimHint': 'Beanspruche oder erstelle zuerst ein Profil — danach kannst du Kuratoren hinzufügen.',
  'myCurators.findProfile': 'Profil zum Beanspruchen suchen',
  'myCurators.since': 'Seit',
  'myCurators.addCurator': 'Kurator hinzufügen',
  'myCurators.cancelAdd': 'Abbrechen',
  'myCurators.searchLabel': 'Kurator nach Name oder E-Mail suchen',
  'myCurators.searchPlaceholder': 'Mindestens 2 Zeichen eingeben...',
  'myCurators.noResults': 'Keine berechtigten Kuratoren gefunden. Kuratoren müssen {tier} Nutzer mit aktiviertem Kurator-Modus sein.',
  'myCurators.noCuratorsForProfile': 'Noch keine Kuratoren für dieses Profil. Klicke auf „Kurator hinzufügen“.',
  'myCurators.remove': 'Entfernen',
  'myCurators.removeConfirm': 'Diesen Kurator entfernen? Er verliert den Verwaltungszugriff auf dieses Profil.',
  'myCurators.removeFailed': 'Kurator konnte nicht entfernt werden.',
  'myCurators.addFailed': 'Kurator konnte nicht hinzugefügt werden.',

  'common.loginRequired': 'Bitte melde dich an, um fortzufahren.',

  'map.geolocationUnsupported': 'Dein Browser unterstützt keine Standortermittlung.',
  'map.locationDenied': 'Standortzugriff verweigert. Bitte in den Browsereinstellungen aktivieren.',
  'map.locationFailed': 'Standort konnte nicht ermittelt werden. Bitte erneut versuchen.',
  'map.failedLoadPins': 'Pins konnten nicht geladen werden. Bitte Seite neu laden.',
  'map.backToHome': 'Zurück zur Startseite',
  'map.addNewPin': 'Neuen Pin hinzufügen',
  'map.findMyLocation': 'Meinen Standort finden',
  'map.collapseLegend': 'Legende ein-/ausklappen',
  'map.togglePins': '{type}-Pins umschalten',
  'map.eventDetails': 'Details',
  'map.eventsMatching': 'Passende Veranstaltungen',
  'map.exitEventMode': 'Beenden',
  'map.eventCount.one': '{n} Event',
  'map.eventCount.other': '{n} Events',
  'map.eventFallbackTitle': 'Event',

  'pinDetail.home': 'Startseite',
  'pinDetail.mission': 'Auftrag',
  'pinDetail.appointmentRequired': 'Termin erforderlich',
  'pinDetail.admission': 'Eintritt',
  'pinDetail.culturalContext': 'Kultureller Kontext',
  'pinDetail.culturalSignificance': 'Kulturelle Bedeutung',
  'pinDetail.historicalNotes': 'Historische Notizen',
  'pinDetail.bestTimeToVisit': 'Beste Besuchszeit',
  'pinDetail.heritageInfo': 'Informationen zum Kulturerbe',
  'pinDetail.heritageType': 'Art des Kulturerbes',
  'pinDetail.associatedArtist': 'Verknüpfter Künstler',
  'pinDetail.availableIn': 'Verfügbar in',
  'pinDetail.tags': 'Schlagwörter',
  'pinDetail.events': 'Veranstaltungen',
  'pinDetail.eventNow': 'Jetzt',
  'pinDetail.eventUpcoming': 'Kommend',
  'pinDetail.eventShowAll': 'Alle Veranstaltungen anzeigen',
  'pinDetail.pastExhibitionsHosted.one': '{n} vergangene Ausstellung veranstaltet',
  'pinDetail.pastExhibitionsHosted.other': '{n} vergangene Ausstellungen veranstaltet',
  'pinDetail.artistsHostedHere': 'Hier vertretene Künstler',
  'pinDetail.artworksByArtists': 'Kunstwerke dieser Künstler',
  'pinDetail.articlesByArtists': 'Artikel',
  'pinDetail.curate': 'Kuratieren',
  'pinDetail.curatingBadge': 'Kuratiert',
  'pinDetail.ownerControls': 'Eigentümer-Einstellungen',
  'pinDetail.makePrivate': 'Privat schalten',
  'pinDetail.makePublic': 'Öffentlich schalten',
  'pinDetail.releaseClaim': 'Anspruch freigeben',
  'pinDetail.claimPrompt': ', um diesen Standort selbst zu übernehmen.',
  'pinDetail.failedDelete': 'Löschen fehlgeschlagen',
  'pinDetail.failedSubmitClaim': 'Anspruch konnte nicht eingereicht werden',
  'pinDetail.failedToggleVisibility': 'Sichtbarkeit konnte nicht geändert werden',
  'pinDetail.failedReleaseClaim': 'Anspruch konnte nicht freigegeben werden',

  'pinForm.backToMap': 'Zurück zur Karte',
  'pinForm.backToPin': 'Zurück zum Pin',
  'pinForm.createNewPin': 'Neuen Pin erstellen',
  'pinForm.editPin': 'Pin bearbeiten',
  'pinForm.section.basic': 'Basisinformationen',
  'pinForm.venueName': 'Name des Ortes',
  'pinForm.describeVenue': 'Diesen Ort beschreiben…',
  'pinForm.section.location': 'Standort',
  'pinForm.streetAddress': 'Straße und Hausnummer',
  'pinForm.city': 'Stadt',
  'pinForm.stateRegion': 'Bundesland / Region',
  'pinForm.country': 'Land',
  'pinForm.latExample': 'z. B. 54.0887',
  'pinForm.lngExample': 'z. B. 12.1407',
  'pinForm.section.image': 'Bild',
  'pinForm.imageUrlLabel': 'Bild-URL',
  'pinForm.section.contact': 'Kontakt',
  'pinForm.httpsPlaceholder': 'https://…',
  'pinForm.phonePlaceholder': '+49 …',
  'pinForm.emailPlaceholder': 'info@…',
  'pinForm.section.hoursTags': 'Öffnungszeiten & Schlagwörter',
  'pinForm.hoursPlaceholder': 'Mo–Fr: 10:00–18:00\nSa–So: 11:00–17:00',
  'pinForm.pricePlaceholder': 'Kostenlos / 10 € / R50',
  'pinForm.priceHint': 'z. B. Kostenlos, 10 € Erwachsene / 5 € Studierende',
  'pinForm.appointmentRequired': 'Termin erforderlich',
  'pinForm.tagsPlaceholder': 'zeitgenössisch, Skulptur, Ausstellungen',
  'pinForm.tagsHint': 'Schlagwörter durch Komma getrennt',
  'pinForm.languagesPlaceholder': 'DE, EN, FR',
  'pinForm.languagesHint': 'Sprachcodes durch Komma getrennt',
  'pinForm.section.venueDetails': 'Detailangaben zum Ort',
  'pinForm.missionPlaceholder': 'Kuratorischer Fokus, Auftrag…',
  'pinForm.missionHint': 'Was ist der künstlerische Fokus oder Auftrag dieses Ortes?',
  'pinForm.section.social': 'Soziale Medien',
  'pinForm.usernamePlaceholder': 'benutzername',
  'pinForm.pageNamePlaceholder': 'seitenname',
  'pinForm.twitterXLabel': 'Twitter/X',
  'pinForm.section.additionalImages': 'Weitere Bilder',
  'pinForm.addImageUrl': 'Bild-URL hinzufügen',
  'pinForm.additionalImagesHint': 'Bis zu 6 weitere Bilder (direkte URLs)',
  'pinForm.maxImages': 'Maximal 6 weitere Bilder',
  'pinForm.section.cultural3W': 'Kultureller 3W-Kontext',
  'pinForm.culturalSignPlaceholder': 'Die kulturelle Bedeutung dieses Ortes beschreiben…',
  'pinForm.historicalNotesPlaceholder': 'Historischer Hintergrund und Kontext…',
  'pinForm.bestTimePlaceholder': 'z. B. Frühjahr (Sep–Nov), werktags vormittags',
  'pinForm.section.heritageDetails': 'Details zum Kulturerbe',
  'pinForm.section.mapVisibility': 'Sichtbarkeit auf der Karte',
  'pinForm.hideFromMap': 'Diesen Pin auf der Karte ausblenden',
  'pinForm.hideFromMapHint': 'Der Pin erscheint weiterhin in der Suche und über direkte Links, aber sein Punkt wird nicht auf der Karte angezeigt.',
  'pinForm.hostedArtists.title': 'Gastkünstler:innen',
  'pinForm.hostedArtists.desc': 'Füge Künstlerprofile hinzu, die ihre Werke in dieser Galerie oder diesem Studio zeigen. Sie erscheinen unter „Hier ansässige Künstler:innen" auf diesem Pin.',
  'pinForm.hostedArtists.searchLabel': 'Künstlerprofil suchen',
  'pinForm.hostedArtists.searchPlaceholder': '2+ Zeichen eingeben, um zu suchen…',
  'pinForm.hostedArtists.remove': 'Entfernen',
  'pinForm.heritageTypeSelect': 'Art des Kulturerbes wählen…',
  'pinForm.artistPlaceholder': 'z. B. Drew McRitchie',
  'pinForm.periodPlaceholder': 'z. B. 1920–1980',
  'pinForm.foundationPlaceholder': 'z. B. McRitchie Stiftung',
  'pinForm.historicalDescPlaceholder': 'Die historische Bedeutung beschreiben…',
  'pinForm.verificationVerified': 'Verifiziert (Museum/Stiftung bestätigt)',
  'pinForm.verificationDocumented': 'Dokumentiert (Glaubwürdige Quellen)',
  'pinForm.sourcesPlaceholder': 'Links oder Quellenangaben…',
  'pinForm.nameRequired': 'Name ist erforderlich',
  'pinForm.deleteConfirm': 'Diesen Pin wirklich löschen? Dies kann nicht rückgängig gemacht werden.',
  'pinForm.deleteFailed': 'Löschen fehlgeschlagen',
  'pinForm.errorPrefix': 'Fehler',

  'event.showAllSuper': 'Alle anzeigen (Superadmin — inkl. Entwürfe)',
  'event.notFound': 'Event nicht gefunden',
  'event.about': 'Über',
  'event.culturalSignificance': 'Kulturelle Bedeutung',
  'event.details': 'Details',
  'event.getTickets': 'Tickets kaufen',
  'event.recurring': 'Wiederkehrend',
  'event.participatingArtists': 'Teilnehmende Künstler',
  'event.location': 'Standort',
  'event.allEvents': 'Alle Events',
  'event.coordsHint': 'Koordinaten eingeben, damit das Event auf der Karte erscheint. In Google Maps rechtsklicken → Lat/Lng kopieren.',
  'event.titleRequired': 'Titel ist erforderlich',
  'event.createFailed': 'Event konnte nicht erstellt werden',
  'event.titlePlaceholder': 'Event-Titel',
  'event.describePlaceholder': 'Event beschreiben…',
  'event.venueExample': 'z. B. Tate Modern',
  'event.addressPlaceholder': 'Straße und Hausnummer',
  'event.cityExample': 'z. B. London',
  'event.countryExample': 'z. B. Deutschland',

  'myEvents.superadminView': 'Superadmin-Ansicht — alle Events auf der Plattform',
  'myEvents.yourEvents': 'Events, die du erstellt hast',
  'myEvents.showAllSuper': 'Alle anzeigen (Superadmin)',
  'myEvents.filter.all': 'Alle',
  'myEvents.filter.upcoming': 'Bevorstehend',
  'myEvents.filter.past': 'Vergangen',
  'myEvents.filter.drafts': 'Entwürfe',
  'myEvents.loading': 'Wird geladen…',
  'myEvents.loadFailed': 'Laden fehlgeschlagen',
  'myEvents.empty.title': 'Noch keine Events',
  'myEvents.empty.desc': 'Erstelle dein erstes Event — es erscheint hier und auf der öffentlichen Event-Seite.',
  'myEvents.createBtn': 'Event erstellen',
  'myEvents.editBtn': 'Bearbeiten',
  'myEvents.showOnMapBtn': 'Auf Karte zeigen',
  'myEvents.dateTba': 'Datum folgt',
  'myEvents.statusPast': 'vergangen',
  'myEvents.statusDraft': 'Entwurf',

  'artworkDetail.about': 'Über',
  'artworkDetail.details': 'Details',
  'artworkDetail.market': 'Markt',
  'artworkDetail.qrCodes': 'QR-Codes',
  'artworkDetail.lensDiscovery': 'Lens — Entdeckung',
  'artworkDetail.provenanceOwnership': 'Provenienz — Eigentum',
  'artworkDetail.scanLens': 'Scannen, um mehr über dieses Kunstwerk und den Künstler zu erfahren',
  'artworkDetail.scanProvenance': 'Scannen, um Eigentumskette und Provenienzgeschichte zu sehen',
  'artworkDetail.view': 'Ansehen',
  'artworkDetail.print': 'Drucken',
  'artworkDetail.currentOwner': 'Aktueller Eigentümer',
  'artworkDetail.provenanceHistory': 'Provenienzgeschichte',
  'artworkDetail.viewFullProvenance': 'Vollständige Provenienz ansehen',
  'artworkDetail.tags': 'Schlagwörter',
  'artworkDetail.documentation': 'Dokumentation',
  'artworkDetail.exhibitionHistory': 'Ausstellungshistorie',
  'artworkDetail.claimPrompt': 'Bist du der Künstler, der dieses Werk geschaffen hat? Reiche einen Anspruch ein, um verifizierter Eigentümer zu werden.',
  'artworkDetail.claimPlaceholder': 'Warum beanspruchst du dieses Kunstwerk? (optional)',
  'artworkDetail.claimFailed': 'Anspruch konnte nicht eingereicht werden',
  'artworkDetail.claimPending': 'Dein Anspruch wird von einem Administrator geprüft.',
  'artworkDetail.pricePlaceholder': 'z. B. 5.000 €',
  'artworkDetail.priceNote': 'Nur du und der Galerist / Event-Organisator sehen diesen Preis.',
  'artworkDetail.submitSent': 'Einreichung gesendet! Die Galerie wird deine Anfrage prüfen.',
  'artworkDetail.submitFailed': 'Einreichung fehlgeschlagen',
  'artworkDetail.allArtworks': 'Alle Kunstwerke',
  'artworkDetail.editArtwork': 'Kunstwerk bearbeiten',
  'artworkDetail.provenanceQr': 'Provenienz-QR',
  'artworkDetail.lensQrAlt': 'Lens-QR',
  'artworkDetail.provenanceQrAlt': 'Provenienz-QR',

  'artworkCreate.titleRequired': 'Titel ist erforderlich',
  'artworkCreate.createFailed': 'Kunstwerk konnte nicht erstellt werden',
  'artworkCreate.titlePlaceholder': 'Titel des Kunstwerks',
  'artworkCreate.artistPlaceholder': 'Name des Künstlers',
  'artworkCreate.yearExample': 'z. B. 2024',
  'artworkCreate.mediumExample': 'z. B. Öl auf Leinwand',
  'artworkCreate.dimensionsExample': 'z. B. 120 x 80 cm',
  'artworkCreate.describePlaceholder': 'Kunstwerk beschreiben…',
  'artworkCreate.imageLabel': 'Kunstwerk-Bild',
  'artworkCreate.galleryPlaceholder': 'Name der Galerie oder des Museums',
  'artworkDetail.viewArtwork': 'Kunstwerk ansehen',

  // ── Kunstwerk-Standort auf der Karte ("Pin-Bereich") ────────────
  'artworkLocation.sectionTitle': 'Standort auf der Karte',
  'artworkLocation.showToggle': 'Dieses Kunstwerk auf der Karte anzeigen',
  'artworkLocation.showHint': 'Standardmäßig aus. Aktivieren, um für dieses Kunstwerk einen Pin an einer bestimmten Adresse zu setzen.',
  'artworkLocation.addressPlaceholder': 'z. B. Stadtbibliothek, Hauptstraße 12, Berlin',
  'artworkLocation.addressHint': 'Adresse eingeben – wir ermitteln den Pin automatisch daraus.',
  'artworkLocation.locating': 'Adresse wird ermittelt…',
  'artworkLocation.located': 'Pin-Standort gesetzt',
  'artworkLocation.notFound': 'Adresse konnte nicht ermittelt werden – ergänze Stadt oder Land.',
  'artworkLocation.reason': 'Grund für die Anzeige auf der Karte',
  'artworkLocation.reasonHint': 'Warum ist dieses Kunstwerk jetzt hier? z. B. Ausstellung, offenes Atelier, hängt an einem öffentlichen Ort.',
  'artworkLocation.always': 'Dauerhaft anzeigen (fester Standort)',

  'myArtworks.deleteAllConfirm': 'Wirklich alle {n} Kunstwerke löschen? Dies kann nicht rückgängig gemacht werden.',
  'myArtworks.releaseFailed': 'Kunstwerk konnte nicht freigegeben werden',
  'myArtworks.deleteConfirm': '„{title}" endgültig löschen? Dies kann nicht rückgängig gemacht werden — nutze stattdessen Freigeben, wenn du es nur abmelden willst.',
  'myArtworks.deleteFailed': 'Kunstwerk konnte nicht gelöscht werden',

  'route.type.art_trail': 'Kunstroute',
  'route.type.heritage': 'Kulturerbe',
  'route.type.walking': 'Wanderung',
  'route.type.cycling': 'Radtour',
  'route.type.cultural': 'Kulturell',
  'route.type.user_route': 'Eigene Route',
  'routeDetail.forkConfirm': 'Diese Route forken? Eine Kopie wird als Entwurf zu Meine Routen hinzugefügt.',
  'routeDetail.forkFailed': 'Fork fehlgeschlagen',
  'routeDetail.deleteConfirm': 'Diese Route wirklich löschen? Dies kann nicht rückgängig gemacht werden.',
  'routeDetail.deleteFailed': 'Löschen fehlgeschlagen',
  'routeDetail.createdBy': 'Erstellt von',
  'routeDetail.forkedFrom': 'Geforkt von',
  'routeDetail.days': 'Tage',
  'routeDetail.aboutThisRoute': 'Über diese Route',
  'routeDetail.highlights': 'Highlights',
  'routeDetail.culturalContext': 'Kultureller Kontext',
  'routeDetail.waypoints': 'Wegpunkte',
  'routeDetail.directionsTo': 'Route zu {name}',
  'routeDetail.tags': 'Schlagwörter',
  'routeDetail.allRoutes': 'Alle Routen',
  'routeDetail.fullInMaps': 'Vollständige Route in Maps',
  'routeDetail.save': 'Speichern',
  'routeDetail.saved': 'Gespeichert',
  'routeDetail.forking': 'Wird geforkt…',
  'routeDetail.forkRoute': 'Route forken',
  'routeDetail.editRoute': 'Route bearbeiten',
  'routeDetail.delete': 'Löschen',
  'routeDetail.errorPrefix': 'Fehler',

  'routesList.deleteRoute': 'Route löschen',
  'routesList.deleteConfirm': 'Route „{name}" löschen? Dies kann nicht rückgängig gemacht werden.',
  'routesList.deleteFailed': 'Löschen fehlgeschlagen',
  'routesList.fetchFailed': 'Routen konnten nicht geladen werden',
  'routesList.ofTotal': 'von',

  'routeCreate.title': 'Route erstellen',
  'routeCreate.details': 'Route-Details',
  'routeCreate.nameLabel': 'Name',
  'routeCreate.namePlaceholder': 'Routenname',
  'routeCreate.descPlaceholder': 'Route beschreiben…',
  'routeCreate.imageLabel': 'Routen-Bild',
  'routeCreate.imageUrlPlaceholder': 'https://example.com/routen-bild.jpg',
  'routeCreate.regionExample': 'z. B. Toskana',
  'routeCreate.countryExample': 'z. B. Italien',
  'routeCreate.distanceLabel': 'Distanz (km)',
  'routeCreate.distanceExample': 'z. B. 25',
  'routeCreate.durationLabel': 'Dauer (Tage)',
  'routeCreate.durationExample': 'z. B. 3',
  'routeCreate.stops': 'Routen-Stopps',
  'routeCreate.moveUp': 'Nach oben',
  'routeCreate.moveDown': 'Nach unten',
  'routeCreate.remove': 'Entfernen',
  'routeCreate.noStops': 'Noch keine Stopps. Orte unten durchsuchen und mit + hinzufügen.',
  'routeCreate.browsePlaces': 'Orte durchsuchen',
  'routeCreate.searchPlaces': 'Orte suchen…',
  'routeCreate.loading': 'Wird geladen…',
  'routeCreate.noPlaces': 'Keine Orte passen zu den Filtern.',
  'routeCreate.alreadyAdded': 'Bereits hinzugefügt',
  'routeCreate.addAsStop': 'Als Routen-Stopp hinzufügen',
  'routeCreate.pageOf': 'Seite {current} von {total}',
  'routeCreate.stop.one': '{n} Stopp',
  'routeCreate.stop.other': '{n} Stopps',
  'routeCreate.nameRequired': 'Name ist erforderlich',

  'auth.loginFailed': 'Anmeldung fehlgeschlagen. Bitte erneut versuchen.',
  'auth.registrationFailed': 'Registrierung fehlgeschlagen',

  'profileDetail.coverAlt': '{name} Titelbild',
  'profileDetail.studio': 'Atelier',
  'profileDetail.claimFailed': 'Anspruch konnte nicht eingereicht werden',
  'profileDetail.lensQr': 'Lens-QR',

  'myProfile.releaseFailed': 'Profil konnte nicht freigegeben werden',
  'myProfile.draftNotice.before': 'Dein Profil hat den Status',
  'myProfile.draftNotice.middle': 'und ist noch nicht öffentlich. Bearbeite es und setze die Sichtbarkeit auf',
  'myProfile.draftNotice.after': ', sobald du bereit bist.',

  'bookmarks.savedOn': 'Gespeichert',
  'bookmarks.removeBookmark': 'Lesezeichen entfernen',

  'search.placeholder': 'Suchen…',
  'search.placeholder.map': 'Galerien, Museen, Ateliers suchen…',
  'search.placeholder.discover': 'Künstler, Events, Artikel suchen…',
  'search.placeholder.routes': 'Routen nach Name oder Beschreibung suchen…',
  'search.placeholder.profiles': 'Künstler, Kollektive, Kuratoren suchen…',
  'search.placeholder.articles': 'Artikel, Rezensionen, Guides suchen…',
  'search.placeholder.events': 'Events, Orte, Festivals suchen…',
  'search.searchRadius': 'Suchradius',
  'search.hideRadiusRing': 'Radius ausblenden',
  'search.showRadiusRing': 'Radius einblenden',
  'search.radiusLabel': 'Radius',
  'search.clear': 'Löschen',
  'search.clearDates': 'Daten löschen',
  'search.multipleLocations': 'Mehrere Orte — einen auswählen:',
  'search.hiddenCount': '{n} ausgeblendet',
  'search.pinTypesHidden.one': '{n} Pin-Typ ausgeblendet',
  'search.pinTypesHidden.other': '{n} Pin-Typen ausgeblendet',


  'article.category.gallery_spotlight': 'Galerie-Spotlight',
  'article.category.artist_profile': 'Künstlerprofil',
  'article.category.exhibition_review': 'Ausstellungs-Rezension',
  'article.category.cultural_insight': 'Kulturelle Einblicke',
  'article.category.route_guide': 'Routen-Guide',
  'article.category.news': 'Nachrichten',
  'article.category.event': 'Event',
  'article.category.opinion': 'Meinung',

  'filter.label.routeType': 'Routenart',
  'filter.label.profileType': 'Profil-Typ',
  'filter.label.eventType': 'Event-Typ',
  'filter.label.discoverType': 'Kategorie',
  'pricing.paypalFailed': 'Abonnement bei PayPal erstellt, aber nicht aktiviert. Bitte kontaktiere den Support mit deiner Abonnement-ID:',

  'subscription.tier.freeVisibility': 'Kostenlos — Sichtbarkeit',
  'subscription.tier.profile': 'Profil',
  'subscription.tier.pro': 'Pro',
  'subscription.tier.pioneer': 'Pionier',

  'register.city': 'Deine Stadt / dein Ort',
  'register.cityPlaceholder': 'z. B. Amsterdam, Berlin, Kapstadt',
  'register.cityHelp': 'Zentriert die Karte auf deine Region',
  'register.showAddress': 'Meine Markierung und Adresse auf der Karte anzeigen',
  'register.showAddressHelp': 'Standardmäßig aktiviert, damit dich Besucher finden können. Deaktivieren, um deine Adresse privat zu halten – dann werden nur deine Kunstwerke und dein Profil angezeigt, ohne Markierung auf der Karte.',

  // ── batch 4 ──
  'artworkCreate.title': 'Kunstwerk erstellen',
  'eventCreate.title': 'Event erstellen',
  'routeCreate.addNew': 'Neu hinzufügen',
  'subscription.expires': 'Läuft ab',
  'subscription.nextPayment': 'Nächste Zahlung',
  'subscription.cancelConfirm': 'Abonnement kündigen? Zugriff bleibt bis zum Ende der aktuellen Abrechnungsperiode bestehen.',
  'subscription.cancelFailed': 'Kündigung fehlgeschlagen',
  'subscription.noneActive': 'Kein aktives Abonnement',
  'subscription.viewPricing': 'Preispläne ansehen',
  'subscription.managePlan': 'Plan verwalten',
  'subscription.cancel': 'Abonnement kündigen',
  'subscription.activated': 'Abonnement erfolgreich aktiviert!',
  'subscription.activateFailed': 'Aktivierung fehlgeschlagen. Bitte kontaktiere den Support.',
  'subscription.failedLoad': 'Abonnement konnte nicht geladen werden',
  'myArtworks.deleteAll': 'Alle löschen',
  'myArtworks.deleting': 'Wird gelöscht…',
  'home.heroTitle': 'Entdecke Kunst dort, wo sie lebt',
  'home.heroSubtitle': 'ArtRouting verbindet Künstler, Galerien und kulturelle Orte auf einer lebendigen Karte.',
  'home.openMap': 'Karte öffnen',
  'home.browseEvents': 'Events durchstöbern',
  'contact.successMsg': 'Danke — deine Nachricht ist unterwegs. Wir melden uns bald.',
  'contact.errorMsg': 'Etwas ist schiefgegangen. Bitte erneut versuchen.',
  'contact.nameLabel': 'Dein Name',
  'contact.emailLabel': 'Deine E-Mail',
  'contact.messageLabel': 'Deine Nachricht',
  'contact.submit': 'Nachricht senden',
  'eventsList.activeFilters': 'Aktive Filter',
  'eventsList.clearFilters': 'Alle löschen',
  'eventsList.filterCountry': 'Land',
  'eventsList.filterCity': 'Stadt',
  'eventsList.filterSearch': 'Suche',
  'eventsList.filterType': 'Typ',

  // ── ArtRadar Newspaper (territoriale Kulturzeitung) ──────────
  'article.category.interview': 'Interview',
  'article.category.opportunity': 'Gelegenheit',
  'article.category.educational_guide': 'Lernartikel',
  'article.category.heritage_story': 'Kulturerbe-Geschichte',

  'artradar.newspaper.title': 'ArtRadar Zeitung',
  'artradar.worldEdition': 'Weltausgabe',
  'artradar.worldEdition.tagline': 'Eine globale Mischung aus Künstlern, Orten, Gelegenheiten und Redaktion — wähle ein Gebiet, um zu sehen, was in deiner Nähe passiert.',
  'artradar.territory.tagline': 'Die Kunstwelt aus {name} — in der Nähe, diese Woche und darüber hinaus.',
  'artradar.territory.viewEdition': 'Die territoriale Ausgabe öffnen',
  'artradar.viewAll': 'Alle anzeigen',
  'artradar.viewAsList': 'Listenansicht',
  'artradar.empty': 'Noch keine Geschichten. Versuche die Weltausgabe oder ein anderes Gebiet.',

  'artradar.territorySelector.label': 'Wähle dein Gebiet',
  'artradar.territorySelector.useLocation': 'Meinen Standort verwenden',
  'artradar.territorySelector.locating': 'Standort wird bestimmt…',
  'artradar.territorySelector.locationDenied': 'Standortberechtigung verweigert — aktuelle Auswahl bleibt erhalten.',
  'artradar.territorySelector.locationFailed': 'Standort konnte keinem Gebiet zugeordnet werden. Weltausgabe wird angezeigt.',
  'artradar.territorySelector.locationUnsupported': 'Geolokalisierung wird in diesem Browser nicht unterstützt.',
  'artradar.territorySelector.outsideKnown': 'Du befindest dich außerhalb bekannter Gebiete — Weltausgabe wird angezeigt.',

  'artradar.section.near_me': 'In meiner Nähe',
  'artradar.section.near_me.tagline': 'Was im aktuell ausgewählten Gebiet passiert.',
  'artradar.section.this_week': 'Diese Woche',
  'artradar.section.this_week.tagline': 'Eröffnungen, Veranstaltungen und Geschichten dieser Woche.',
  'artradar.section.artists': 'Künstler',
  'artradar.section.artists.tagline': 'Porträts, Interviews und Atelierbesuche.',
  'artradar.section.places': 'Orte',
  'artradar.section.places.tagline': 'Galerien, Museen, Ateliers und kulturelle Ziele.',
  'artradar.section.opportunities': 'Gelegenheiten',
  'artradar.section.opportunities.tagline': 'Open Calls, Residenzen, Stipendien und Einladungen.',
  'artradar.section.learn': 'Lernen',
  'artradar.section.learn.tagline': 'Anleitung für Künstler, Galerien, Kuratoren und Besucher.',
  'artradar.section.cultural_stories': 'Kulturgeschichten',
  'artradar.section.cultural_stories.tagline': 'Kulturerbe, Geschichte und warum ein Ort wichtig ist.',
  'artradar.section.explore': 'Entdecken',
  'artradar.section.explore.tagline': 'Andere Regionen, Länder und ländliche Kunstziele.',
  'artradar.section.editors_desk': 'Redaktion',
  'artradar.section.editors_desk.tagline': 'Meinung, Forschung und ArtRouting-Stimme.',
  'artradar.section.editors_picks': 'Redaktionstipps',
  'artradar.section.editors_picks.tagline': 'Handverlesene Geschichten aus aller Welt.',
  'artradar.sponsored': 'Gesponsert',
  'artradar.sponsoredHint': 'Dieser Artikel ist eine bezahlte Platzierung.',
  'artradar.linkedFromMap': 'In ArtRadar lesen',
  'artradar.relatedStories': 'Verwandte Geschichten',
  'artradar.newspaperTitle': 'ArtRadar Zeitung',

  // Spezialausgaben / Seitenwende (§15)
  'artradar.editionsTitle': 'Spezialausgaben',
  'artradar.editionsSubtitle': 'Kuratierte ArtRadar-Ausgaben — wöchentlich, saisonal und territoriale Specials.',
  'artradar.noEditions': 'Noch keine Spezialausgaben veröffentlicht.',
  'artradar.allEditions': 'Alle Ausgaben',
  'artradar.specialEdition': 'Spezialausgabe',
  'artradar.editionNotFound': 'Ausgabe nicht gefunden',
  'artradar.cover': 'Titel',
  'artradar.editionPages': 'Seiten',
  'artradar.readFullArticle': 'Vollständigen Artikel lesen',
  'artradar.previousPage': 'Vorherige Seite',
  'artradar.nextPage': 'Nächste Seite',
  'artradar.manageEditions': 'Ausgaben verwalten',

  // Admin-Sammlungen
  'admin.collections.title': 'Spezialausgaben verwalten',
  'admin.collections.subtitle': 'ArtRadar-Ausgaben erstellen und ordnen — wöchentlich, saisonal, Ausstellungskataloge, Premium-Ausgaben.',
  'admin.collections.viewPublic': 'Öffentliche Ansicht',
  'admin.collections.newEdition': 'Neue Ausgabe',
  'admin.collections.empty': 'Noch keine Ausgaben. Erstelle die erste.',
  'admin.collections.back': 'Zurück zur Ausgabenliste',
  'admin.collections.titleRequired': 'Titel ist erforderlich',
  'admin.collections.fieldTitle': 'Titel',
  'admin.collections.fieldDescription': 'Beschreibung',
  'admin.collections.fieldCover': 'Titelbild-URL',
  'admin.collections.fieldType': 'Ausgabentyp',
  'admin.collections.fieldTerritory': 'Gebiet',
  'admin.collections.fieldStatus': 'Status',
  'admin.collections.fieldArticles': 'Artikel in dieser Ausgabe',
  'admin.collections.articlesHint': 'Artikel ankreuzen zum Aufnehmen. Mit den Pfeilen umsortieren — Leser sehen sie in dieser Reihenfolge als Seiten.',
  'admin.collections.pageOrder': 'Seitenreihenfolge',
  'admin.collections.searchArticles': 'Veröffentlichte Artikel suchen…',
  'admin.collections.delete': 'Ausgabe löschen',
  'admin.collections.deleteConfirm': 'Diese Ausgabe löschen? Die Artikel selbst werden nicht gelöscht.',

  // ── Kunstwerk-Geschichte (Artwork PIN) ───────────────────────
  'story.pageTitle': 'Geschichte des Kunstwerks',
  'story.subtitle': 'Die Geschichte hinter diesem Kunstwerk, erzählt von der Künstlerin oder dem Künstler.',
  'story.loading': 'Geschichte wird geladen…',
  'story.notFound': 'Dieses Kunstwerk wurde nicht gefunden.',
  'story.backToArtwork': 'Zurück zum Kunstwerk',
  'story.draftBadge': 'Entwurf — nur für Sie sichtbar',
  'story.editStory': 'Geschichte bearbeiten',
  'story.viewStoryLink': 'Geschichte lesen',
  'story.playAll': 'Ganze Geschichte abspielen',
  'story.stopAll': 'Wiedergabe beenden',
  'story.listen': 'Diesen Abschnitt anhören',
  'story.stopListening': 'Wiedergabe stoppen',
  'story.expandAll': 'Alle ausklappen',
  'story.collapseAll': 'Alle einklappen',
  'story.narrationUnsupported': 'Sprachwiedergabe ist in diesem Browser nicht verfügbar.',
  'story.noStoryYet': 'Für dieses Kunstwerk wurde noch keine Geschichte veröffentlicht.',
  'story.noStoryYetOwner': 'Sie haben für dieses Kunstwerk noch keine Geschichte geschrieben.',
  'story.writeStory': 'Geschichte schreiben',
  'story.languageHint': 'Lesen und hören Sie in Ihrer bevorzugten Sprache.',

  'story.section.welcome': 'Willkommen',
  'story.section.artist': 'Über die Künstlerin / den Künstler',
  'story.section.info': 'Angaben zum Kunstwerk',
  'story.section.storyBehind': 'Die Geschichte hinter dem Kunstwerk',
  'story.section.process': 'Entstehungsprozess',
  'story.section.details': 'Details zum Entdecken',
  'story.section.context': 'Kontext',
  'story.section.journey': 'Weg des Kunstwerks',
  'story.section.related': 'Verwandte Inhalte',
  'story.section.reflection': 'Rückblick der Künstlerin / des Künstlers',
  'story.section.explore': 'Weiter entdecken',

  'story.field.bio': 'Kurzbiografie',
  'story.field.philosophy': 'Künstlerische Philosophie',
  'story.field.background': 'Künstlerischer Werdegang',
  'story.field.themes': 'Zentrale Themen',
  'story.field.studioLocation': 'Atelierstandort',
  'story.field.website': 'Website / Portfolio',
  'story.field.title': 'Titel',
  'story.field.year': 'Jahr',
  'story.field.medium': 'Technik',
  'story.field.materials': 'Materialien',
  'story.field.dimensions': 'Maße',
  'story.field.weight': 'Gewicht',
  'story.field.series': 'Serie',
  'story.field.edition': 'Edition',
  'story.field.status': 'Aktueller Status',
  'story.field.pinNumber': 'Kunstwerk-PIN-Nummer',

  'story.prompt.welcome': 'Eine kurze Begrüßung, die Besucherinnen und Besucher in dieses Kunstwerk einführt.',
  'story.prompt.storyBehind': 'Was hat dieses Kunstwerk inspiriert? Warum haben Sie es geschaffen? Welche Gefühle waren dabei? Welche Botschaft trägt es? Gibt es eine verborgene Bedeutung?',
  'story.prompt.process': 'Verwendete Techniken, Materialien, benötigte Zeit, Herausforderungen, überraschende Entdeckungen.',
  'story.prompt.details': 'Verborgene Details, Symbolik, Farbwahl, Textur, Komposition, leicht übersehene Kleinigkeiten.',
  'story.prompt.context': 'Historische oder kulturelle Bezüge, Literatur, Natur, Musik, persönliche Erfahrungen, verwandte Werke.',
  'story.prompt.reflection': 'Was hat Sie dieses Kunstwerk gelehrt? Würden Sie es heute anders schaffen? Was sollen Besucherinnen und Besucher mitnehmen?',

  'story.journey.exhibitions': 'Ausstellungen',
  'story.journey.provenance': 'Erfasste Ereignisse',
  'story.journey.empty': 'Für dieses Kunstwerk sind noch keine Ausstellungen erfasst.',
  'story.related.empty': 'Noch keine verwandten Artikel.',
  'story.explore.artistProfile': 'Künstlerprofil',
  'story.explore.otherArtworks': 'Weitere Kunstwerke',
  'story.explore.nearbyArt': 'Wo zu sehen',
  'story.explore.empty': 'Noch nichts zu entdecken.',

  'story.edit.title': 'Kunstwerk-Geschichte bearbeiten',
  'story.edit.intro': 'Einmal schreiben — ArtRouting zeigt Ihre Geschichte in der Sprache der Besucherinnen und Besucher und liest sie vor.',
  'story.edit.save': 'Geschichte speichern',
  'story.edit.saving': 'Wird gespeichert…',
  'story.edit.saved': 'Geschichte gespeichert.',
  'story.edit.saveError': 'Die Geschichte konnte nicht gespeichert werden. Bitte erneut versuchen.',
  'story.edit.loadError': 'Die Geschichte konnte nicht geladen werden.',
  'story.edit.forbidden': 'Sie haben keine Berechtigung, diese Geschichte zu bearbeiten.',
  'story.edit.publish': 'Diese Geschichte veröffentlichen',
  'story.edit.publishHint': 'Solange sie nicht veröffentlicht ist, sehen nur Sie die Geschichte.',
  'story.edit.autoTranslateHint': 'Übersetzungen in die jeweils andere Sprache werden automatisch erstellt.',
  'story.edit.imageUrl': 'Bild-URL (optional)',
  'story.edit.videoUrl': 'Video-URL (optional)',
  'story.edit.viewStory': 'Geschichte ansehen',
  'story.edit.optional': 'Optional',
  'story.edit.required': 'Erforderlich',
  // ── Text direkt auf der Seite bearbeiten (Superadmin) ──
  'textEditor.enter': 'Text bearbeiten',
  'textEditor.exit': 'Bearbeitung beenden',
  'textEditor.banner': 'Bearbeitungsmodus ist aktiv. Klicken Sie auf einen hervorgehobenen Text, um ihn auf Englisch und Deutsch zu ändern.',
  'textEditor.title': 'Diesen Text bearbeiten',
  'textEditor.browseTitle': 'Alle Texte dieser Seite',
  'textEditor.hint': 'Beide Sprachen werden zusammen gespeichert. Die Änderung ist sofort nach dem Speichern auf der Website sichtbar.',
  'textEditor.browseHint': 'Alles, was diese Seite anzeigt, auch Texte in Kurzhinweisen, Platzhaltern und Auswahllisten.',
  'textEditor.close': 'Schließen',
  'textEditor.english': 'Englisch',
  'textEditor.german': 'Deutsch',
  'textEditor.englishPlaceholder': 'Der englische Wortlaut',
  'textEditor.germanPlaceholder': 'Der deutsche Wortlaut',
  'textEditor.bothRequired': 'Bitte füllen Sie den englischen und den deutschen Text aus.',
  'textEditor.saveFailed': 'Das konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
  'textEditor.save': 'Speichern',
  'textEditor.cancel': 'Abbrechen',
  'textEditor.reset': 'Original wiederherstellen',
  'textEditor.resetConfirm': 'Den ursprünglichen Wortlaut für diesen Text wiederherstellen?',
  'textEditor.pageList': 'Alle Texte dieser Seite',
  'textEditor.pageListHint': 'Wählen Sie einen Eintrag, um ihn zu bearbeiten.',
  'textEditor.searchPlaceholder': 'Diese Seite durchsuchen',
  'textEditor.noMatches': 'Zu dieser Suche gibt es nichts.',
  'textEditor.toolbar': 'Formatierung',
  'textEditor.bold': 'Fett',
  'textEditor.italic': 'Kursiv',
  'textEditor.underline': 'Unterstrichen',
  'textEditor.link': 'Link',
  'textEditor.bullet': 'Aufzählung',
  'textEditor.lineBreak': 'Zeilenumbruch',
  'textEditor.preview': 'Vorschau',
  'textEditor.previewEmpty': 'Noch nichts anzuzeigen.',
  'textEditor.sampleBold': 'fetter Text',
  'textEditor.sampleItalic': 'kursiver Text',
  'textEditor.sampleUnderline': 'unterstrichener Text',
  'textEditor.sampleLink': 'Linktext',
  // ── Entwickler-API (API-Schlüssel + Explorer) ──────────────────
  'nav.developerApi': 'Entwickler-API',

  'developer.title': 'Entwickler-API',
  'developer.subtitle': 'Geben Sie einem Skript, einer App oder einem Partnersystem denselben Zugang, den Sie im Browser haben. Ein Schlüssel liest und schreibt Ihre Einträge über die API, begrenzt auf die Rechte, die Sie ihm geben.',
  'developer.tab.keys': 'API-Schlüssel',
  'developer.tab.explorer': 'API-Explorer',
  'developer.scope.read': 'lesen',
  'developer.scope.write': 'schreiben',

  'developer.keys.createTitle': 'Schlüssel erstellen',
  'developer.keys.createIntro': 'Benennen Sie den Schlüssel nach dem, was ihn verwendet — dann wissen Sie später, was Sie abschalten, wenn Sie ihn widerrufen.',
  'developer.keys.nameLabel': 'Name des Schlüssels',
  'developer.keys.namePlaceholder': 'Galerie-Importskript',
  'developer.keys.nameRequired': 'Bitte geben Sie dem Schlüssel einen Namen.',
  'developer.keys.scopesLabel': 'Was dieser Schlüssel darf',
  'developer.keys.scopesHint': 'Geben Sie dem Schlüssel nur, was er braucht. Ein Schlüssel kann niemals Ihr Konto, Ihre Zahlungen oder Ihre anderen Schlüssel verwalten.',
  'developer.keys.scopeRequired': 'Bitte wählen Sie mindestens ein Recht.',
  'developer.keys.allowance': '{used} von {limit} Schlüsseln in Verwendung.',
  'developer.keys.createButton': 'Schlüssel erstellen',
  'developer.keys.creating': 'Wird erstellt…',
  'developer.keys.createError': 'Der Schlüssel konnte nicht erstellt werden.',
  'developer.keys.loadError': 'Ihre Schlüssel konnten nicht geladen werden.',
  'developer.keys.needsPlan': 'API-Schlüssel gehören zu den bezahlten Plänen.',
  'developer.keys.seePlans': 'Pläne ansehen',
  'developer.keys.secretTitle': 'Ihr neuer Schlüssel',
  'developer.keys.secretOnce': 'Nur dieses eine Mal wird der Schlüssel angezeigt. Kopieren Sie ihn jetzt in Ihr Skript oder Ihren Passwortmanager — ArtRouting speichert nur einen Hash davon.',
  'developer.keys.copy': 'Kopieren',
  'developer.keys.copied': 'Kopiert',
  'developer.keys.dismiss': 'Fertig',
  'developer.keys.listTitle': 'Ihre Schlüssel',
  'developer.keys.listIntro': 'Erneuern vergibt ein neues Geheimnis und stoppt das alte sofort. Widerrufen behält den Schlüssel samt Verlauf, setzt ihn aber außer Kraft.',
  'developer.keys.loading': 'Wird geladen…',
  'developer.keys.empty': 'Noch keine Schlüssel.',
  'developer.keys.revoked': 'widerrufen',
  'developer.keys.createdAt': 'Erstellt',
  'developer.keys.lastUsed': 'Zuletzt verwendet',
  'developer.keys.never': 'nie',
  'developer.keys.rotate': 'Erneuern',
  'developer.keys.rotateConfirm': 'Ein neues Geheimnis für diesen Schlüssel vergeben? Alles, was noch das alte verwendet, funktioniert sofort nicht mehr.',
  'developer.keys.rotateError': 'Der Schlüssel konnte nicht erneuert werden.',
  'developer.keys.revoke': 'Widerrufen',
  'developer.keys.revokeConfirm': 'Diesen Schlüssel widerrufen? Er funktioniert sofort nicht mehr und kann nicht wieder aktiviert werden.',
  'developer.keys.revokeError': 'Der Schlüssel konnte nicht widerrufen werden.',
  'developer.keys.delete': 'Löschen',
  'developer.keys.deleteConfirm': 'Diesen Schlüssel und seinen Nutzungsverlauf endgültig löschen?',
  'developer.keys.deleteError': 'Der Schlüssel konnte nicht gelöscht werden.',
  'developer.keys.showUsage': 'Nutzung',
  'developer.keys.hideUsage': 'Nutzung ausblenden',
  'developer.keys.usageError': 'Der Nutzungsverlauf konnte nicht geladen werden.',
  'developer.keys.usageEmpty': 'Dieser Schlüssel wurde noch nicht verwendet.',
  'developer.keys.statTotal': 'Aufrufe',
  'developer.keys.stat24h': 'Letzte 24 Std.',
  'developer.keys.statErrors': 'Fehler 24 Std.',
  'developer.keys.statAvg': 'Durchschnitt',
  'developer.keys.usingTitle': 'Einen Schlüssel verwenden',
  'developer.keys.usingIntro': 'Senden Sie den Schlüssel bei jedem Aufruf im Header X-API-Key. Er handelt als Ihr Konto, im Rahmen seiner Rechte, und jeder Aufruf wird dem Schlüssel zugerechnet.',
  'developer.keys.tryHint': 'Testen Sie jeden Endpunkt im',

  'developer.explorer.title': 'API-Explorer',
  'developer.explorer.subtitle': 'Alle Endpunkte, die ArtRouting veröffentlicht — direkt aus der laufenden API gelesen und hier ausführbar, solange Sie angemeldet sind.',
  'developer.explorer.specError': 'Die API-Beschreibung konnte nicht geladen werden.',
  'developer.explorer.runError': 'Der Aufruf konnte nicht ausgeführt werden.',
  'developer.explorer.authTitle': 'Wie authentifizieren',
  'developer.explorer.authIntro': 'Aufrufe von dieser Seite gehen an die echte API und verändern echte Einträge. Wählen Sie, womit sie gesendet werden.',
  'developer.explorer.auth.session': 'Meine Sitzung',
  'developer.explorer.auth.key': 'Ein API-Schlüssel',
  'developer.explorer.auth.none': 'Keine Authentifizierung',
  'developer.explorer.keyLabel': 'API-Schlüssel',
  'developer.explorer.keyHint': 'Der Schlüssel wird nur in diesem Browser-Tab verwendet. Schlüssel erstellen oder erneuern unter',
  'developer.explorer.loading': 'API-Beschreibung wird geladen…',
  'developer.explorer.filterLabel': 'Endpunkt suchen',
  'developer.explorer.filterPlaceholder': 'PINs, Kunstwerk, Provenienz…',
  'developer.explorer.noMatches': 'Kein Endpunkt passt.',
  'developer.explorer.requiresAuth': 'benötigt Authentifizierung',
  'developer.explorer.parameters': 'Parameter',
  'developer.explorer.body': 'Anfrage-Body (JSON)',
  'developer.explorer.send': 'Anfrage senden',
  'developer.explorer.sending': 'Wird gesendet…',
  'developer.explorer.copyCurl': 'Als curl kopieren',

  // Legal: Authorship + Messaging rules (Impressum additions)
  'footer.authorshipRules': 'Regeln zur Autorenschaft',
  'footer.messagingRules': 'Regeln für Nachrichten',
  'legal.impressumMoreTitle': 'Weitere rechtliche Informationen',
  'legal.authorshipTitle': 'Autorenschaft / Delegierte Bearbeitungsrechte',
  'legal.authorship.s1Title': 'Was Autorenschaft bedeutet',
  'legal.authorship.s1Body': 'Die ArtRouting-Autorenschaft ermöglicht es dem Inhaber eines ArtRouting-Profils, eines Kunstwerks, einer Ausstellung, eines Veranstaltungsorts oder eines anderen dafür geeigneten Eintrags, einer namentlich benannten Person die Erlaubnis zu erteilen, ausgewählte Inhalte in seinem Namen mitzuverwalten. Die Autorenschaft überträgt weder das Eigentum an dem Profil, dem Kunstwerk oder dem Konto noch das Urheberrecht.',
  'legal.authorship.s2Title': 'Zustimmung beider Seiten',
  'legal.authorship.s2Body': 'Die Autorenschaft wird erst wirksam, nachdem der Inhaber eine Einladung versendet und die eingeladene Person sie angenommen hat. Beide Seiten müssen die geltenden Regeln zur Autorenschaft akzeptieren, bevor der Zugang freigeschaltet wird.',
  'legal.authorship.s3Title': 'Der Inhaber behält die Kontrolle',
  'legal.authorship.s3Body': 'Der Inhaber entscheidet, welche Person Zugang erhält, und kann diesen Zugang jederzeit widerrufen. Der Inhaber bleibt der Hauptkontoinhaber und behält die übergeordnete Kontrolle über die betreffenden ArtRouting-Einträge.',
  'legal.authorship.s4Title': 'Was eine berechtigte Autorin oder ein berechtigter Autor darf',
  'legal.authorship.s4Body': 'Je nach erteilten Berechtigungen darf eine berechtigte Autorin oder ein berechtigter Autor Profilangaben, Kunstwerke, Ausstellungen, Veranstaltungen, Standortangaben und geeignete ArtRadar-Einreichungen bearbeiten. Der Zugang soll auf die vom Inhaber ausgewählten Berechtigungen beschränkt sein.',
  'legal.authorship.s5Title': 'Was eine berechtigte Autorin oder ein berechtigter Autor nicht darf',
  'legal.authorship.s5Body': 'Eine berechtigte Autorin oder ein berechtigter Autor darf weder das Eigentum an Werk oder Identität einer anderen Person beanspruchen noch Rechte an eine andere Person übertragen, den Zugang für fremde Werbung oder Sponsoring nutzen oder Änderungen außerhalb der vom Inhaber erteilten Berechtigungen vornehmen.',
  'legal.authorship.s6Title': 'Änderungsverlauf und Benachrichtigungen',
  'legal.authorship.s6Body': 'Änderungen, die über die Autorenschaft vorgenommen werden, sollen in einem Änderungsprotokoll erfasst werden. Der Inhaber soll sehen können, wer wann eine Änderung vorgenommen hat, und soll bei relevanten Änderungen benachrichtigt werden.',
  'legal.authorship.s7Title': 'Widerruf und Sperrung',
  'legal.authorship.s7Body': 'Der Inhaber kann den Zugang einer Autorin oder eines Autors jederzeit widerrufen. ArtRouting kann den Zugang zur Autorenschaft außerdem einschränken, sperren oder entziehen, wenn die Funktion missbraucht wird, Rechte strittig sind oder gegen Plattformregeln verstoßen wird.',
  'legal.authorship.s8Title': 'Verantwortung für Inhalte',
  'legal.authorship.s8Body': 'Inhaber und berechtigte Autorinnen und Autoren sind dafür verantwortlich, dass die von ihnen eingestellten Informationen, Bilder und sonstigen Materialien zutreffend sind und dass sie über die erforderlichen Rechte oder Erlaubnisse zu ihrer Veröffentlichung verfügen.',
  'legal.authorship.s9Title': 'Keine Übertragung von Urheberrecht oder rechtlichem Eigentum',
  'legal.authorship.s9Body': 'Die Autorenschaft ist ausschließlich eine administrative Berechtigung. Sie überträgt weder Urheberrechte, Urheberpersönlichkeitsrechte, Eigentum an Kunstwerken, vertragliche Rechte, Vertretungsrechte noch sonstiges rechtliches Eigentum, sofern keine gesonderte Vereinbarung außerhalb von ArtRouting besteht.',
  'legal.authorship.acceptTitle': 'Erforderliche Zustimmung vor der Freischaltung',
  'legal.authorship.acceptHelp': 'Diese Erklärungen müssen im Ablauf der Autorenschaft bestätigt werden, bevor der Zugang freigeschaltet wird.',
  'legal.authorship.acceptOwner1': 'Inhaber: Ich bestätige, dass ich berechtigt bin, dieser Person Bearbeitungszugang zu den ausgewählten ArtRouting-Inhalten zu gewähren.',
  'legal.authorship.acceptOwner2': 'Inhaber: Mir ist bewusst, dass ich für das Konto verantwortlich bleibe und den Zugang jederzeit widerrufen kann.',
  'legal.authorship.acceptAuthor1': 'Autorin/Autor: Ich nehme nur die mir erteilten Berechtigungen an und werde mich nicht als Inhaber ausgeben, sofern ich dazu nicht gesondert ermächtigt bin.',
  'legal.authorship.acceptAuthor2': 'Autorin/Autor: Ich lade nur Material hoch oder bearbeite nur Material, zu dessen Nutzung ich berechtigt bin.',
  'legal.authorship.acceptBoth': 'Beide Seiten: Wir akzeptieren die ArtRouting-Regeln zur Autorenschaft und nehmen zur Kenntnis, dass der Zugang bei Missbrauch der Funktion gesperrt oder widerrufen werden kann.',
  'legal.authorship.openWorkflow': 'Zur Delegierten Autorenschaft',
  'legal.messagingTitle': 'Private Nachrichten / Kommunikationsregeln',
  'legal.messaging.s1Title': 'Was ArtRouting-Nachrichten sind',
  'legal.messaging.s1Body': 'ArtRouting-Nachrichten sind eine private Kommunikationsfunktion für registrierte Nutzerinnen und Nutzer. Sie dienen der berechtigten kunstbezogenen Kommunikation, etwa Besuchsanfragen, Preisanfragen, Ausstellungseinladungen, beruflichen Vorstellungen, Empfehlungen, Ausschreibungen und Wettbewerben sowie sonstiger relevanter Kommunikation zwischen Teilnehmenden.',
  'legal.messaging.s2Title': 'Privat, nicht öffentlich',
  'legal.messaging.s2Body': 'Nachrichten sind keine öffentlichen Kommentare. Sie sind für Absender und Empfänger bestimmt oder, sofern Gruppennachrichten verfügbar sind, für die eingeladenen Teilnehmenden des jeweiligen Gesprächs.',
  'legal.messaging.s3Title': 'Identität und Kontext',
  'legal.messaging.s3Body': 'Nachrichten sollen mit der registrierten ArtRouting-Identität des Absenders verbunden sein. Soweit relevant, kann die Oberfläche Name, Rolle, Stadt/Land und berufliche Spezialisierung des Absenders anzeigen sowie das Profil, das Kunstwerk, den Veranstaltungsort, die Ausstellung, die Einladung oder den QR-Kontext, aus dem die Nachricht gesendet wurde.',
  'legal.messaging.s4Title': 'Kein Spam und keine massenhaften unerwünschten Nachrichten',
  'legal.messaging.s4Body': 'ArtRouting-Nachrichten dürfen nicht genutzt werden, um wiederholt unerwünschte Nachrichten, Massenwerbung, irreführende Werbeaktionen, automatisierten Spam oder sachfremdes kommerzielles Marketing zu versenden. ArtRouting kann technische Beschränkungen, Versandlimits und Spam-Erkennung einsetzen, um missbräuchliche Nachrichten einzudämmen.',
  'legal.messaging.s5Title': 'Einladungen zu ArtRouting',
  'legal.messaging.s5Body': 'Nutzerinnen und Nutzer dürfen externe Künstlerinnen und Künstler, Veranstaltungsorte, Bewahrer des kulturellen Erbes oder andere relevante Personen zu ArtRouting einladen, sofern die Einladung einen echten Bezug zu Kunst, einem Artikel, einem Kunstwerk, einer Ausstellung oder einer anderen relevanten ArtRouting-Aktivität hat. Einladungen dürfen nicht für wahllose Massenansprache genutzt werden.',
  'legal.messaging.s6Title': 'Respektvolle und rechtmäßige Nutzung',
  'legal.messaging.s6Body': 'Nachrichten dürfen nicht für Belästigung, Drohungen, Betrug, das Vortäuschen einer fremden Identität, rechtswidrige Inhalte, Rechtsverletzungen oder sonstiges missbräuchliches Verhalten genutzt werden.',
  'legal.messaging.s7Title': 'Anhänge und geteiltes Material',
  'legal.messaging.s7Body': 'Der Absender ist dafür verantwortlich, dass Dateien, Bilder, Links und sonstiges über Nachrichten geteiltes Material rechtmäßig geteilt werden darf und keine Rechte Dritter verletzt.',
  'legal.messaging.s8Title': 'Kontaktanfragen',
  'legal.messaging.s8Body': 'Sofern ArtRouting Kontaktanfragen anbietet, kann der Empfänger sie annehmen oder ablehnen. Eine abgelehnte oder unbeantwortete Anfrage begründet keine Erlaubnis für wiederholte Kontaktaufnahme.',
  'legal.messaging.s9Title': 'Blockieren, Melden und Moderation',
  'legal.messaging.s9Body': 'Nutzerinnen und Nutzer sollen unangemessene Nachrichten blockieren oder melden können. ArtRouting kann Meldungen prüfen und den Zugang zu Nachrichten einschränken, sperren oder entziehen, wenn die Funktion missbraucht wird.',
  'legal.messaging.s10Title': 'Aufbewahrung von Nachrichten und Datenschutz',
  'legal.messaging.s10Body': 'ArtRouting soll die Aufbewahrung und Löschung von Nachrichten sowie den Umgang mit dem Datenschutz in seiner Datenschutzerklärung beschreiben. Private Nachrichten sollen nicht als öffentlich sichtbare Inhalte dargestellt werden.',
  'legal.messaging.s11Title': 'Keine Antwortpflicht',
  'legal.messaging.s11Body': 'Der Erhalt einer Nachricht, Einladung, Besuchsanfrage oder Anfrage über ArtRouting verpflichtet den Empfänger nicht, zu antworten, eine Anfrage anzunehmen, ein Kunstwerk zu verkaufen, einen Besuch zu vereinbaren oder eine Vereinbarung einzugehen.',
  'legal.messaging.confirmTitle': 'Bestätigung durch Nutzerinnen und Nutzer',
  'legal.messaging.confirm1': 'Ich nutze ArtRouting-Nachrichten für relevante und rechtmäßige Kommunikation.',
  'legal.messaging.confirm2': 'Ich versende keinen Spam, keine wiederholte unerwünschte Werbung und keine missbräuchlichen Nachrichten.',
  'legal.messaging.confirm3': 'Mir ist bewusst, dass Empfänger eine Kontaktaufnahme ablehnen, blockieren oder melden können.',
  'legal.messaging.confirm4': 'Ich bin für das Material und die Anhänge verantwortlich, die ich sende.',
  'legal.messaging.confirm5': 'Ich akzeptiere die ArtRouting-Regeln für Nachrichten.',
  'legal.messaging.privacyLink': 'Datenschutzerklärung',
  'legal.messaging.blockHowTo': 'Um jemanden zu blockieren, öffnen Sie in den Nachrichten das Gesprächsmenü und wählen Sie „Blockieren“. Blockierte Personen finden Sie in Ihrem Nachrichtenmenü unter „Privatsphäre“. Missbrauch melden Sie bitte an info@artrouting.com.',
  'messaging.rulesGateTitle': 'Bevor Sie Nachrichten senden',
  'messaging.rulesGateHelp': 'Bitte bestätigen Sie jede Erklärung einmalig. Sie sind Teil der ArtRouting-Regeln für Nachrichten.',
  'messaging.rulesGateAccept': 'Bestätigen und fortfahren',
  'messaging.rulesLink': 'Regeln für Nachrichten',
  'messaging.errRulesNotAccepted': 'Bitte bestätigen Sie vor dem Senden die Regeln für Nachrichten.',
  'authorship.legal.title': 'Erforderliche Zustimmung vor der Freischaltung',
  'authorship.legal.readFull': 'Die vollständigen Regeln zur Autorenschaft lesen',

  // ArtRadar — open to every member (contributors, submissions, review)
  'artradar.submitArticle': 'Artikel einreichen',
  'artradar.learnMore': 'Was ist ArtRadar?',
  'artradar.guidelinesLink': 'Richtlinien für Beitragende',
  'artradar.welcomeLine': 'ArtRadar freut sich über Beiträge registrierter ArtRouting-Mitglieder. Alle Einreichungen werden vor der Veröffentlichung geprüft.',
  'artradar.about.title': 'Was ist ArtRadar?',
  'artradar.about.p1': 'ArtRadar ist die geografische Redaktionsebene von ArtRouting. Geschichten über Kunstschaffende, Kunstwerke, Ausstellungen, Kunstorte, Kulturerbe und kulturelles Geschehen sind mit den Orten und Einträgen verbunden, um die es geht.',
  'artradar.about.p2': 'Lokale Geschichten sind im jeweiligen Ort oder Gebiet, in der Region und im Land auffindbar. Ausgewählte Geschichten von größerer Bedeutung können zusätzlich in der World Edition erscheinen.',
  'artradar.about.p3': 'Allgemeine oder internationale Artikel ohne festen Ort können ebenfalls eingereicht werden; die Aufnahme in die World Edition wird jedoch redaktionell entschieden und erfolgt nicht automatisch.',
  'artradar.about.p4': 'Ihr eigener Wohnort bestimmt nicht, wohin ein Artikel gehört: Sein Ort richtet sich nach dem Thema der Geschichte.',
  'artradar.about.p5': 'Alle auf ArtRouting Registrierten können beitragen, in jedem Tarif und in jeder Rolle: Kunstschaffende, Kunstorte, Entdeckende, Vertretungen des Kulturerbes und die Autorinnen und Autoren lokaler Zeitungen und Magazine. Ihr Name und Ihre Publikation werden bei jedem Artikel genannt, sodass eine anderswo kopierte Geschichte immer zu Ihnen und Ihrer Publikation zurückverfolgt werden kann.',
  'artradar.about.start': 'Artikel einreichen',
  'artradar.guidelines.title': 'Richtlinien für Beitragende',
  'artradar.guidelines.1': 'Registrieren Sie sich einmal: Ihr Name, in welcher Funktion Sie schreiben und, falls zutreffend, Ihre Zeitung oder Ihr Magazin. ArtRouting speichert diese Angaben und nennt sie bei jedem eingereichten Artikel.',
  'artradar.guidelines.2': 'Schreiben Sie über etwas Reales: Kunstschaffende, ein Kunstwerk, eine Ausstellung, einen Kunstort, einen Kulturerbe-Eintrag oder einen Ort. Verbinden Sie den Artikel mit den passenden ArtRouting-Einträgen oder laden Sie die Beteiligten ein.',
  'artradar.guidelines.3': 'Sie sind für die Richtigkeit Ihrer Einreichung und die Rechte an Text und Bildern verantwortlich. Geben Sie für jedes Bild an, auf welcher Grundlage es veröffentlicht werden darf.',
  'artradar.guidelines.4': 'Ist der Artikel bereits anderswo erschienen, nennen Sie Originalpublikation, Link und Datum und bestätigen Sie, dass Sie oder Ihre Organisation ihn erneut veröffentlichen dürfen.',
  'artradar.guidelines.5': 'Jede Einreichung wird vor der Veröffentlichung geprüft. Die Redaktion kann Änderungen anfordern, einen Artikel ablehnen, korrigieren, platzieren oder entfernen.',
  'artradar.guidelines.6': 'Bezahlte, gesponserte oder sonstige kommerzielle Inhalte müssen als solche gekennzeichnet werden.',
  'artradar.contributor.title': 'Ihre Angaben als ArtRadar-Beitragende*r',
  'artradar.contributor.intro': 'Sie füllen dies nur einmal aus. ArtRouting speichert die Angaben und zeigt sie bei jedem eingereichten Artikel, sodass Lesende und alle, die Ihren Artikel anderswo finden, sehen, wer ihn für welche Publikation geschrieben hat.',
  'artradar.contributor.fullName': 'Vollständiger Name',
  'artradar.contributor.type': 'Sie schreiben als',
  'artradar.contributor.type.journalist': 'Journalist*in',
  'artradar.contributor.type.curator': 'Kurator*in',
  'artradar.contributor.type.researcher': 'Forscher*in',
  'artradar.contributor.type.historian': 'Historiker*in',
  'artradar.contributor.type.educator': 'Kunstvermittler*in',
  'artradar.contributor.type.artist': 'Künstler*in',
  'artradar.contributor.type.art_venue': 'Kunstort',
  'artradar.contributor.type.heritage': 'Vertretung Kunsterbe',
  'artradar.contributor.type.explorer': 'Entdecker*in',
  'artradar.contributor.type.other': 'Sonstiges',
  'artradar.contributor.choose': 'Bitte wählen…',
  'artradar.contributor.publication': 'Zeitung, Magazin oder Organisation (optional)',
  'artradar.contributor.publicationPh': 'z. B. Müritz-Zeitung',
  'artradar.contributor.publicationUrl': 'Link zur Zeitung oder zum Magazin (optional)',
  'artradar.contributor.publicationUrlHint': 'Wird bei jedem Ihrer Artikel als Link angezeigt.',
  'artradar.contributor.city': 'Stadt',
  'artradar.contributor.country': 'Land',
  'artradar.contributor.bio': 'Kurze berufliche Beschreibung',
  'artradar.contributor.website': 'Website oder beruflicher Link (optional)',
  'artradar.contributor.acceptRules': 'Ich akzeptiere die redaktionellen Regeln von ArtRadar und die Richtlinien für Beitragende.',
  'artradar.contributor.acceptRights': 'Ich bestätige, dass ich für die Rechte und Genehmigungen des eingereichten Materials verantwortlich bin.',
  'artradar.contributor.save': 'Speichern und weiter',
  'artradar.contributor.saveChanges': 'Änderungen speichern',
  'artradar.contributor.saved': 'Angaben gespeichert.',
  'artradar.contributor.edit': 'Angaben als Beitragende*r',
  'artradar.contributor.suspended': 'Ihre ArtRadar-Einreichungen sind ausgesetzt. Ihr ArtRouting-Konto ist davon nicht betroffen. Bitte wenden Sie sich an die Redaktion.',
  'artradar.err.full_name_required': 'Bitte geben Sie Ihren vollständigen Namen ein.',
  'artradar.err.contributor_type_required': 'Bitte wählen Sie, in welcher Funktion Sie schreiben.',
  'artradar.err.invalid_publication_url': 'Der Link zur Zeitung oder zum Magazin ist keine gültige Webadresse.',
  'artradar.err.invalid_website_url': 'Der Website-Link ist keine gültige Webadresse.',
  'artradar.err.acceptance_required': 'Bitte akzeptieren Sie die redaktionellen Regeln und bestätigen Sie Ihre Verantwortung für die Rechte.',
  'artradar.err.contributor_required': 'Bitte hinterlegen Sie zuerst Ihre Angaben als Beitragende*r.',
  'artradar.err.contributor_suspended': 'Ihre ArtRadar-Einreichungen sind ausgesetzt.',
  'artradar.err.not_your_article': 'Dieser Artikel gehört zu einer anderen beitragenden Person.',
  'artradar.err.locked_in_review': 'Dieser Artikel liegt bei der Redaktion und kann bis zu deren Antwort nicht geändert werden.',
  'artradar.err.title_required': 'Bitte geben Sie einen Titel ein.',
  'artradar.err.body_required': 'Bitte geben Sie den Artikeltext ein.',
  'artradar.err.rights_missing': 'Bitte wählen Sie für jedes Bild die Rechtegrundlage.',
  'artradar.err.republish_missing': 'Bitte bestätigen Sie die Rechte zur erneuten Veröffentlichung.',
  'artradar.err.generic': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
  'artradar.submit.title': 'Artikel einreichen',
  'artradar.submit.editTitle': 'Ihren Artikel bearbeiten',
  'artradar.submit.steps': 'Schreiben · Verbinden oder Einladen · Rechte bestätigen · Zur Prüfung einreichen',
  'artradar.submit.creditPreview': 'Ihr Artikel wird so gekennzeichnet',
  'artradar.submit.articleTitle': 'Titel des Artikels',
  'artradar.submit.excerpt': 'Kurze Zusammenfassung',
  'artradar.submit.body': 'Artikeltext',
  'artradar.submit.category': 'Kategorie',
  'artradar.submit.geo': 'Geografischer Bezug',
  'artradar.submit.geo.specific': 'Ein bestimmter Ort',
  'artradar.submit.geo.multiple': 'Mehrere Orte',
  'artradar.submit.geo.general': 'Allgemein oder international',
  'artradar.submit.geoHint': 'Der Ort richtet sich nach dem Thema der Geschichte, nicht nach Ihrem Wohnort.',
  'artradar.submit.city': 'Ort oder Gebiet',
  'artradar.submit.country': 'Land',
  'artradar.submit.worldEdition': 'Diese Geschichte hat größere Bedeutung: für die World Edition vorschlagen (die Redaktion entscheidet).',
  'artradar.submit.dates': 'Daten, falls zeitgebunden',
  'artradar.submit.datesPh': 'z. B. 3.–28. Oktober 2026',
  'artradar.submit.sources': 'Quellen',
  'artradar.submit.images': 'Bilder',
  'artradar.submit.imagesHint': 'Das erste Bild ist das Titelbild. Bis zu 10 weitere erscheinen mit dem Artikel.',
  'artradar.submit.addImage': 'Bild hinzufügen',
  'artradar.submit.uploading': 'Wird hochgeladen…',
  'artradar.submit.removeImage': 'Bild entfernen',
  'artradar.submit.imageCredit': 'Fotograf*in / Bildnachweis',
  'artradar.submit.rights': 'Rechte an diesem Bild',
  'artradar.rights.choose': 'Rechtegrundlage wählen…',
  'artradar.rights.own': 'Ich bin Rechteinhaber*in / Ich habe dieses Bild erstellt',
  'artradar.rights.permission': 'Ich habe die Erlaubnis, dieses Bild auf ArtRouting zu veröffentlichen',
  'artradar.rights.approved_via_artrouting': 'Die Rechteinhaber*in hat dieses Bild über ArtRouting freigegeben',
  'artradar.rights.public_domain': 'Gemeinfrei oder anderweitig rechtlich nutzbar',
  'artradar.rights.unsure': 'Ich bin unsicher / eine Genehmigung ist erforderlich',
  'artradar.rights.requestPermission': 'Genehmigung anfragen',
  'artradar.rights.requestSubject': 'Genehmigungsanfrage: ein Bild für ArtRadar auf ArtRouting',
  'artradar.rights.requestBody': 'Guten Tag,\n\nich möchte dieses Bild in einem ArtRadar-Artikel auf ArtRouting (artrouting.com) veröffentlichen:\n{url}\n\nArtikel: {title}\nVorgeschlagener Bildnachweis: {credit}\nAngefragt von: {name}\n\nBitte antworten Sie mit Zustimmung oder Ablehnung.\n\nVielen Dank.',
  'artradar.submit.republished': 'Dieser Artikel wurde bereits anderswo veröffentlicht',
  'artradar.submit.origPublication': 'Originalpublikation',
  'artradar.submit.origUrl': 'Link zum Original',
  'artradar.submit.origDate': 'Datum der Erstveröffentlichung',
  'artradar.submit.republishRights': 'Ich bestätige, dass ich oder meine Organisation die Rechte haben, diesen Text und seine Bilder auf ArtRouting erneut zu veröffentlichen, oder dass ich Bilder mit gesondertem Genehmigungsbedarf gekennzeichnet habe.',
  'artradar.submit.connect': 'Verbinden oder Einladen',
  'artradar.submit.connectHint': 'Suchen Sie auf ArtRouting nach den Personen, Kunstwerken, Kunstorten, Ausstellungen, Kulturerbe-Einträgen und Orten, die Ihr Artikel erwähnt. Sind sie noch nicht auf ArtRouting, laden Sie sie ein.',
  'artradar.submit.searchPh': 'Kunstschaffende, Kunstwerke, Orte, Ausstellungen suchen…',
  'artradar.submit.search': 'Suchen',
  'artradar.submit.connectAction': 'Verbinden',
  'artradar.submit.disconnect': 'Verbindung entfernen',
  'artradar.submit.connected': 'Verbunden',
  'artradar.submit.noResults': 'Nichts auf ArtRouting gefunden. Laden Sie sie unten ein.',
  'artradar.connect.kind.profile': 'Künstler*in / Profil',
  'artradar.connect.kind.pin': 'Ort / Kunstort',
  'artradar.connect.kind.event': 'Ausstellung / Veranstaltung',
  'artradar.connect.kind.artwork': 'Kunstwerk',
  'artradar.invite.title': 'Jemanden einladen, der noch nicht auf ArtRouting ist',
  'artradar.invite.name': 'Name',
  'artradar.invite.kind': 'Wer oder was',
  'artradar.invite.kind.person': 'Person',
  'artradar.invite.kind.artwork': 'Kunstwerk',
  'artradar.invite.kind.venue': 'Kunstort',
  'artradar.invite.kind.exhibition': 'Ausstellung',
  'artradar.invite.kind.heritage': 'Kulturerbe-Eintrag',
  'artradar.invite.kind.place': 'Ort',
  'artradar.invite.contact': 'E-Mail oder Telefon (optional)',
  'artradar.invite.email': 'E-Mail',
  'artradar.invite.whatsapp': 'WhatsApp',
  'artradar.invite.copy': 'Link kopieren',
  'artradar.invite.copied': 'Einladung kopiert',
  'artradar.invite.subject': 'Sie wurden auf ArtRadar erwähnt',
  'artradar.invite.message': 'Sie wurden in einem ArtRadar-Artikel auf ArtRouting erwähnt: „{title}“. Sie sind eingeladen, ArtRouting beizutreten und Ihr Profil, Kunstwerk oder Ihren Ort mit dem Artikel zu verbinden: {url}',
  'artradar.invite.sent': 'Einladung gesendet',
  'artradar.invite.awaiting': 'Wartet auf Verbindung',
  'artradar.invite.remove': 'Einladung entfernen',
  'artradar.submit.saveDraft': 'Entwurf speichern',
  'artradar.submit.submit': 'Zur Prüfung einreichen',
  'artradar.submit.submittedMsg': 'Vielen Dank. Ihr Artikel wurde eingereicht und wird vor der Veröffentlichung geprüft.',
  'artradar.submit.draftSaved': 'Entwurf gespeichert.',
  'artradar.submit.toMyArticles': 'Zu Meine Artikel',
  'artradar.review.draft': 'Entwurf',
  'artradar.review.submitted': 'Eingereicht',
  'artradar.review.under_review': 'In Prüfung',
  'artradar.review.changes_requested': 'Änderungen angefordert',
  'artradar.review.approved': 'Freigegeben',
  'artradar.review.published': 'Veröffentlicht',
  'artradar.review.declined': 'Abgelehnt',
  'artradar.review.revoked': 'Zurückgezogen',
  'artradar.review.archived': 'Archiviert',
  'artradar.review.notes': 'Hinweise der Redaktion',
  'artradar.credit.by': 'Von',
  'artradar.credit.roles': 'Auf ArtRouting',
  'artradar.credit.firstPublished': 'Erstmals erschienen in {name}',
  'artradar.credit.readOriginal': 'Zum Original',
  'artradar.credit.images': 'Bilder',
  'artradar.credit.sources': 'Quellen',
  'artradar.credit.visitPublication': '{name} besuchen',
  'artradar.role.artist': 'Künstler*in',
  'artradar.role.gallery': 'Kunstort',
  'artradar.role.explorer': 'Entdecker*in',
  'artradar.role.curator': 'Kurator*in',
  'artradar.role.collective': 'Kollektiv',
  'admin.artradar.title': 'ArtRadar-Prüfung',
  'admin.artradar.desc': 'Einreichungen, Bildrechte, Einladungen und Beitragende prüfen.',
  'admin.artradar.cardStat': 'Offen für',
  'admin.artradar.cardStatValue': 'Jeden Tarif',
  'admin.artradar.cardCta': 'Prüfen',
  'admin.artradar.queue': 'Einreichungen',
  'admin.artradar.contributors': 'Beitragende',
  'admin.artradar.filterOpen': 'Offen',
  'admin.artradar.empty': 'Keine Einreichungen.',
  'admin.artradar.submittedAt': 'Eingereicht',
  'admin.artradar.rightsOk': 'Bildrechte bestätigt',
  'admin.artradar.rightsNeeded': 'Bildgenehmigung erforderlich',
  'admin.artradar.invites': 'Einladungen, die auf Verbindung warten: {n}',
  'admin.artradar.republished': 'Übernommen aus {name}',
  'admin.artradar.worldRequested': 'Für die World Edition vorgeschlagen',
  'admin.artradar.action.under_review': 'Prüfung beginnen',
  'admin.artradar.action.request_changes': 'Änderungen anfordern',
  'admin.artradar.action.approve': 'Freigeben und veröffentlichen',
  'admin.artradar.action.decline': 'Ablehnen',
  'admin.artradar.action.revoke': 'Zurückziehen',
  'admin.artradar.notesPrompt': 'Hinweis an die beitragende Person (optional)',
  'admin.artradar.open': 'Artikel öffnen',
  'admin.artradar.edit': 'Bearbeiten',
  'admin.artradar.suspend': 'Einreichungen aussetzen',
  'admin.artradar.reinstate': 'Wieder zulassen',
  'admin.artradar.suspendReason': 'Grund für die Aussetzung',
  'admin.artradar.suspended': 'Ausgesetzt',
  'admin.artradar.articles': 'Artikel: {n}',
  'admin.artradar.noContributors': 'Noch keine Beitragenden registriert.',
  'legal.impressumArtRadarTitle': 'Redaktionelle Beiträge auf ArtRadar',
  'legal.impressumArtRadarBody': 'ArtRadar enthält redaktionelle Beiträge registrierter ArtRouting-Nutzender. Eingereichte Artikel werden vor der Veröffentlichung geprüft. Die genannte beitragende Person bleibt für die Richtigkeit des eingereichten Materials und für die Bestätigung der erforderlichen Veröffentlichungs- und Bildrechte verantwortlich. ArtRouting behält die redaktionelle Kontrolle über Annahme, Korrektur, Platzierung und Entfernung von ArtRadar-Inhalten.',
  'legal.impressumArtRadarGuidelines': 'ArtRadar-Richtlinien für Beitragende',
  'legal.impressumCommercialTitle': 'Kommerzielle Inhalte',
  'legal.impressumCommercialBody': 'Bezahlte, gesponserte oder sonstige kommerzielle Inhalte auf ArtRouting und ArtRadar sind klar als solche gekennzeichnet; die dahinterstehende Partei wird genannt.',
  // Profile creation, Complete Your Profile, external video links
  'roleBar.switch': 'Rolle:',
  'profileComplete.title': 'Profil vervollständigen',
  'profileComplete.info': 'Profilinformationen',
  'profileComplete.editInfo': 'Profilinformationen bearbeiten',
  'profileComplete.manageRotating': 'Rotierende Galerie verwalten',
  'profileComplete.rotatingHelp': 'Fügen Sie der rotierenden Galerie oben in Ihrem Profil Bilder, Atelieransichten, Ausstellungshinweise oder Ankündigungsgrafiken hinzu.',
  'profileComplete.artworkGallery': 'Kunstwerk-Galerie',
  'profileComplete.artworkGalleryHelp': 'Ihre Kunstwerke und Kunstwerk-PINs erscheinen hier automatisch. Wählen Sie ein Kunstwerk, um seine Informationen, seinen Standort, seinen QR-Code und seine verbundene Geschichte zu sehen.',
  'profileComplete.addArtwork': 'Kunstwerk hinzufügen',
  'profileComplete.videos': 'Externe Videolinks',
  'profileComplete.editLinks': 'Website und soziale Links bearbeiten',
  'profileComplete.studioPin': 'Atelier-PIN',
  'profileComplete.studioPinHelp': 'Ihr Atelier-PIN legt Ihren genauen Ort auf der Karte fest und ob er angezeigt oder verborgen wird. Suchen Sie eine Adresse oder einen Ort und bestätigen oder korrigieren Sie dann die Position auf der Karte.',
  'profileComplete.createStudioPin': 'Atelier-PIN erstellen oder verbinden',
  'profileComplete.connectExisting': 'Einen Ihrer bestehenden PINs verbinden',
  'profileComplete.studioConnected': 'Atelier-PIN verbunden.',
  'profileComplete.adjustPin': 'Position anpassen',
  'profileComplete.visibility': 'Sichtbarkeit des Profils',
  'profileComplete.visibilityHelp': 'Öffentliche Profile erscheinen auf ArtRouting. Verborgene Profile bleiben erhalten, werden aber nicht aufgelistet. Entwürfe sieht niemand sonst.',
  'profileVisibility.approved': 'Öffentlich',
  'profileVisibility.hidden': 'Verborgen',
  'profileVisibility.draft': 'Entwurf',
  'profileVisibility.pending': 'In Prüfung',
  'profileVisibility.rejected': 'Nicht freigegeben',
  'profileCreate.title': 'Künstlerprofil erstellen',
  'profileCreate.nameRequired': 'Ein Anzeigename ist erforderlich.',
  'profileCreate.failed': 'Das Profil konnte nicht erstellt werden.',
  'profileCreate.haveWebsite': 'Sie haben bereits eine Website?',
  'profileCreate.namePlaceholder': 'Ihr Name oder Künstlername',
  'profileCreate.profileImage': 'Profilbild',
  'profileCreate.bioPlaceholder': 'Erzählen Sie von sich und Ihrer künstlerischen Arbeit …',
  'profileCreate.medium.painting': 'Malerei',
  'profileCreate.medium.sculpture': 'Skulptur',
  'profileCreate.medium.ceramics': 'Keramik',
  'profileCreate.medium.photography': 'Fotografie',
  'profileCreate.medium.printmaking': 'Druckgrafik',
  'profileCreate.medium.mixed_media': 'Mixed Media',
  'profileCreate.medium.digital_art': 'Digitale Kunst',
  'profileCreate.medium.other': 'Andere',
  'profileCreate.otherMedium': 'Anderes Medium',
  'profileCreate.otherMediumPlaceholder': 'z. B. Textil, Glas (mehrere mit Komma trennen)',
  'profileCreate.links': 'Website und soziale Links',
  'profileCreate.linksHelp': 'Links zu Ihrer Website oder Ihren sozialen Profilen. Links zu einzelnen Videos fügen Sie später unter Externe Videolinks hinzu.',
  'profileCreate.youtubeChannel': 'YouTube',
  'profileCreate.otherLink': 'Weiterer beruflicher Link',
  'profileCreate.cityPlaceholder': 'z. B. Berlin',
  'profileCreate.countryPlaceholder': 'z. B. Deutschland',
  'profileCreate.studioPinNext': 'Ihre genaue Kartenposition legen Sie danach mit Ihrem Atelier-PIN fest.',
  'myProfile.draftTip': 'Ihr Profil ist ein Entwurf und noch nicht öffentlich sichtbar. Wählen Sie unter Sichtbarkeit des Profils „Öffentlich“, wenn Sie so weit sind.',
  'imageUpload.label': 'Bild',
  'imageUpload.upload': 'Hochladen',
  'imageUpload.uploadProfile': 'Profilbild hochladen',
  'imageUpload.uploading': 'Wird hochgeladen …',
  'imageUpload.useUrl': 'Stattdessen eine Bild-URL verwenden',
  'imageUpload.url': 'Bild-URL',
  'imageUpload.preview': 'Vorschau',
  'imageUpload.notImage': 'Bitte wählen Sie eine Bilddatei.',
  'imageUpload.tooLarge': 'Das Bild muss kleiner als 10 MB sein.',
  'imageUpload.failed': 'Hochladen fehlgeschlagen.',
  'dropZone.drop': 'Bilder hier ablegen oder Dateien auswählen',
  'dropZone.types': 'JPG, PNG oder WebP, jeweils bis 10 MB',
  'dropZone.choose': 'Bilder auswählen',
  'dropZone.takePhoto': 'Foto aufnehmen',
  'dropZone.title': 'Titel (wird auch Screenreader-Nutzenden vorgelesen)',
  'dropZone.caption': 'Bildunterschrift (optional)',
  'dropZone.link': 'Link (optional, https://…)',
  'dropZone.rotate': 'Drehen',
  'dropZone.skippedType': 'Einige Dateien wurden ausgelassen: Nur JPG-, PNG- oder WebP-Bilder bis 10 MB können hinzugefügt werden.',
  'dropZone.overAllowance': 'Im Rahmen Ihres Tarifs können nur noch {n} hinzugefügt werden.',
  'gallery.openOn.youtube': 'Auf YouTube öffnen',
  'gallery.openOn.vimeo': 'Auf Vimeo öffnen',
  'gallery.openOn.instagram': 'Auf Instagram öffnen',
  'galleryEditor.upgradeFor': 'Ein höheres Kontingent beginnt mit {tier}.',
  'galleryEditor.seePlans': 'Tarife ansehen',
  'galleryEditor.topTier': 'Dies ist das höchste Kontingent.',
  'galleryEditor.usage.artworkPins': '{used} von {max} Kunstwerk-PINs genutzt',
  'galleryEditor.usage.artworkPinsUnlimited': '{used} Kunstwerk-PINs · unbegrenzt',
  'galleryEditor.full.rotating': 'Alle Bilder der rotierenden Galerie sind belegt. Entfernen Sie eines, um ein neues hinzuzufügen.',
  'galleryEditor.full.additional': 'Alle zusätzlichen Galeriebilder Ihres Tarifs sind belegt.',
  'galleryEditor.full.videos': 'Alle {max} Videolinks Ihres Tarifs sind belegt.',
  'galleryEditor.full.artworkPins': 'Alle {max} Kunstwerk-PINs Ihres Tarifs sind belegt.',
  'galleryEditor.replaceImage': 'Bild ersetzen',
  'galleryEditor.addImages': '{n} Bilder hinzufügen',
  'galleryEditor.videoHelp': 'Fügen Sie einen Link zu einem Video hinzu, das auf YouTube, Vimeo oder Instagram veröffentlicht ist. ArtRouting lädt keine Videodateien hoch und speichert keine.',
  'galleryEditor.videoUrl': 'Externe Video-URL',
  'galleryEditor.videoDescription': 'Kurze Beschreibung (optional)',
  'galleryEditor.dragToReorder': 'Ziehen Sie Bilder am Computer an ihre Position oder nutzen Sie die Pfeile.',
  'galleryEditor.err.unsupported_video_link': 'Fügen Sie einen Link zu einem einzelnen Video auf YouTube, Vimeo oder Instagram hinzu. Ein Kanal- oder Konto-Link gehört unter Website und soziale Links.',
  'pinForm.positionHelp': 'Geben Sie die Adresse oder den Ort ein: Die Karte springt dorthin. Klicken Sie in die Karte oder ziehen Sie die Markierung, um die genaue Position anzupassen.',
  'activity.viewsTitle': 'Insgesamt {total}-mal geöffnet, {week}-mal in den letzten 7 Tagen. Ihre eigenen Besuche werden nicht gezählt.',
  'activity.thisWeekShort': 'diese Woche',
  'legal.cookies.updated': 'Zuletzt aktualisiert: September 2026',
  'legal.cookies.essentialTitle': 'Nur notwendige Speicherung',
  'legal.cookies.essentialBody': 'Beim Anmelden wird ein Anmelde-Token in Ihrem Browser gespeichert, damit Sie angemeldet bleiben. Es ist für die Nutzung Ihres Kontos erforderlich und wird beim Abmelden entfernt. Wenn Sie mit „Meine Route“ einen Besuch planen, werden die Stationen ebenfalls in Ihrem Browser gespeichert und verlassen ihn nur, wenn Sie die Route in Ihrem Konto sichern.',
  'legal.cookies.noTrackingTitle': 'Keine Tracking-Cookies',
  'legal.cookies.noTrackingBody': 'ArtRouting verwendet keine Werbe-Cookies, keine Analysedienste von Dritten und keine anderen Tracking-Cookies.',
  'legal.activityCounts.title': 'Anonyme Aktivitätszählung',
  'legal.activityCounts.body': 'Damit Eigentümer:innen sehen, wie oft ihre öffentlichen Seiten geöffnet werden, zählt ArtRouting Seitenaufrufe, Hinzufügungen zu Besucherrouten, Aufrufe der Wegbeschreibung und geöffnete Videolinks auf dem eigenen Server, ohne Cookies. Gespeichert wird nur eine Tagessumme pro Seite. Wiederholte Aufrufe werden nur 30 Minuten lang erkannt, und zwar über einen aus Verbindung und Browser abgeleiteten Code, der sich täglich ändert und Sie nicht identifiziert. Eigentümer:innen sehen nur Summen, nie, wer eine Seite geöffnet hat. Suchmaschinen, Linkvorschauen und eigene Besuche der Eigentümer:innen werden nicht gezählt. Scans von QR-Codes sind nicht Teil dieser Zählung.',
  'myRoute.title': 'Meine Route',
  'myRoute.chip': 'Meine Route ({n})',
  'myRoute.addToRoute': 'Zur Route hinzufügen',
  'myRoute.viewRoute': 'Route ansehen',
  'myRoute.backToRoute': 'Zurück zu Meine Route',
  'myRoute.planThisRoute': 'In Meine Route planen',
  'myRoute.empty': 'Ihre Route hat noch keine Stationen. Öffnen Sie einen Ort auf der Karte und tippen Sie auf „Zur Route hinzufügen“, um die Stationen zu sammeln, die Sie besuchen möchten.',
  'myRoute.findStops': 'Orte auf der Karte finden',
  'myRoute.addMore': 'Stationen hinzufügen',
  'myRoute.clear': 'Route leeren',
  'myRoute.clearConfirm': 'Alle Stationen aus Ihrer Route entfernen?',
  'myRoute.intro': 'Ihre Route bleibt in diesem Browser gespeichert – auch wenn Sie einen Ort öffnen, die Seite neu laden oder aus Ihrer Karten-App zurückkommen. Ein Konto ist nicht nötig.',
  'myRoute.planDay': 'Den Tag planen',
  'myRoute.start': 'Startpunkt',
  'myRoute.startPlaceholder': 'Adresse, Ort oder Bahnhof',
  'myRoute.useMyLocation': 'Meinen Standort verwenden',
  'myRoute.myLocation': 'Mein Standort',
  'myRoute.locationUnavailable': 'Ihr Standort ist nicht verfügbar. Geben Sie stattdessen einen Startpunkt ein.',
  'myRoute.date': 'Datum',
  'myRoute.startTime': 'Startzeit',
  'myRoute.hoursAvailable': 'Verfügbare Stunden',
  'myRoute.travelMode': 'Verkehrsmittel',
  'myRoute.mode.driving': 'Auto',
  'myRoute.mode.walking': 'Zu Fuß',
  'myRoute.mode.bicycling': 'Fahrrad',
  'myRoute.mode.transit': 'Öffentliche Verkehrsmittel',
  'myRoute.suggestOrder': 'Reihenfolge vorschlagen',
  'myRoute.suggestOrderHint': 'Eine ungefähre Reihenfolge nach Entfernung vom Start – nicht die schnellste Route. Sie können sie übernehmen oder weiter anpassen.',
  'myRoute.proposedOrder': 'Vorgeschlagene Reihenfolge',
  'myRoute.acceptOrder': 'Diese Reihenfolge übernehmen',
  'myRoute.keepMyOrder': 'Meine Reihenfolge behalten',
  'myRoute.visited': 'besucht',
  'myRoute.skipped': 'übersprungen',
  'myRoute.unavailable': 'Dieser Ort ist nicht mehr öffentlich. Er bleibt in Ihrer Liste, bis Sie ihn entfernen.',
  'myRoute.noHoursListed': 'Keine Öffnungszeiten angegeben',
  'myRoute.source.owner': 'Öffnungszeiten von der verantwortlichen Person angegeben',
  'myRoute.source.public': 'Öffentlich angegebene Öffnungszeiten',
  'myRoute.source.unknown': 'Quelle dieser Öffnungszeiten unbekannt',
  'myRoute.lastChecked': 'zuletzt geprüft am {date}',
  'myRoute.appointmentOnly': 'Besuch nach Vereinbarung – bitte vorher Kontakt aufnehmen',
  'myRoute.exhibitionNow': 'Aktuell eine Ausstellung',
  'myRoute.warn.noHours': 'Es sind keine Öffnungszeiten angegeben. Bitte vorher prüfen.',
  'myRoute.warn.unreadableHours': 'Diese Öffnungszeiten konnten nicht automatisch geprüft werden. Bitte lesen Sie sie selbst.',
  'myRoute.warn.closedThatDay': 'Am gewählten Tag als geschlossen angegeben.',
  'myRoute.warn.notListedThatDay': 'Für den gewählten Tag sind keine Öffnungszeiten angegeben.',
  'myRoute.warn.closesBeforeArrival': 'Schließt um {time} – noch bevor Sie ankommen können, selbst ohne Fahrzeit.',
  'myRoute.warn.mayCloseDuringVisit': 'Schließt um {time}; möglicherweise während Ihres Besuchs.',
  'myRoute.warn.opensLater': 'Öffnet um {time}.',
  'myRoute.warn.exceedsDay': 'Schon die Besuchszeiten sind länger als Ihre verfügbare Zeit. Entfernen oder kürzen Sie Stationen.',
  'myRoute.warn.tightDay': 'Für die Wege zwischen den Stationen bleibt wenig Zeit. Der Plan passt möglicherweise nicht in den Tag.',
  'myRoute.visitTime': 'Besuchszeit in Minuten (Vorschlag {lo}–{hi})',
  'myRoute.legMode': 'Anreise mit',
  'myRoute.legModeDefault': 'Wie geplant ({mode})',
  'myRoute.earliestArrival': 'Früheste Ankunft {time} (ohne Fahrzeit)',
  'myRoute.moveUp': 'Station nach oben',
  'myRoute.moveDown': 'Station nach unten',
  'myRoute.directionsHere': 'Route',
  'myRoute.markVisited': 'Besucht',
  'myRoute.skip': 'Überspringen',
  'myRoute.backInPlan': 'Wieder einplanen',
  'myRoute.remove': 'Entfernen',
  'myRoute.summary': 'Ihr Tag',
  'myRoute.minutes': '{m} Min.',
  'myRoute.hoursMinutes': '{h} Std. {m} Min.',
  'myRoute.totalVisits': 'Besuche: {total} von {available} verfügbarer Zeit.',
  'myRoute.travelExcluded': 'Fahrzeiten sind nicht enthalten – ArtRouting hat dafür keine verlässlichen Daten. Ihre Karten-App zeigt sie, wenn Sie die Route öffnen.',
  'myRoute.startRoute': 'Route starten',
  'myRoute.continueRoute': 'Route fortsetzen',
  'myRoute.nextStop': 'Nächste Station: {name}.',
  'myRoute.readCard': 'Eintrag lesen',
  'myRoute.allDone': 'Alle Stationen sind besucht oder übersprungen. Genießen Sie den Rest des Tages!',
  'myRoute.openAllInMaps': 'Alle Stationen in Google Maps öffnen',
  'myRoute.directionsRemaining': 'Route für die übrigen Stationen',
  'myRoute.legsReason.too_many': 'Google Maps nimmt auf dem Smartphone höchstens fünf Punkte in einem Link an. Ihre Route ist daher in nummerierte Abschnitte aufgeteilt.',
  'myRoute.legsReason.transit': 'Routen mit öffentlichen Verkehrsmitteln funktionieren nur abschnittsweise. Jeder Abschnitt öffnet sich einzeln.',
  'myRoute.legsReason.mixed_modes': 'Ihre Abschnitte nutzen verschiedene Verkehrsmittel. Jeder Abschnitt öffnet sich daher einzeln.',
  'myRoute.leg': 'Abschnitt {n}: {from} → {to}',
  'myRoute.whereYouAre': 'Ihr Standort',
  'myRoute.keepTitle': 'Diese Route behalten',
  'myRoute.keepLocal': 'Sie ist bereits in diesem Browser gespeichert. Mitglieder können sie zusätzlich unter Meine Routen sichern und auf einem anderen Gerät öffnen.',
  'myRoute.routeName': 'Name der Route',
  'myRoute.defaultName': 'Meine Route, {date}',
  'myRoute.saveToMyRoutes': 'Unter Meine Routen sichern',
  'myRoute.updateSaved': 'Gesicherte Route aktualisieren',
  'myRoute.openSaved': 'Gesicherte Route öffnen',
  'myRoute.savedToMyRoutes': 'Unter Meine Routen gesichert. Nur Sie können sie sehen.',
  'myRoute.saveFailed': 'Die Route konnte nicht gesichert werden. Bitte versuchen Sie es erneut.',
  'myRoute.signInToSave': 'Anmelden, um diese Route unter Meine Routen zu sichern',
  'myRoute.mapsNote': 'Die Wegbeschreibung öffnet sich in Google Maps. ArtRouting navigiert nicht innerhalb der Website.',
  'myRoute.nextOnly': 'Nur Route zur nächsten Station',
  'pinForm.hoursSource': 'Woher stammen diese Öffnungszeiten?',
  'pinForm.hoursSourceNone': 'Nicht angegeben',
  'pinForm.hoursSourceOwner': 'Von der verantwortlichen Person',
  'pinForm.hoursSourcePublic': 'Öffentlich angegeben (z. B. Website)',
  'pinForm.hoursSourceUnknown': 'Unbekannt',
  'pinForm.hoursCheckedAt': 'Öffnungszeiten zuletzt geprüft am',
  'pinForm.hoursHelp': 'Wird Besucher:innen bei der Routenplanung angezeigt, damit sie einschätzen können, wie verlässlich die Zeiten sind.',
  'heart.follow': 'Folgen',
  'heart.following': 'Folge ich',
  'heart.save': 'In Interessen speichern',
  'heart.saved': 'In Interessen gespeichert',
  'heart.saveArticleAndEvent': 'Artikel und Veranstaltung speichern',
  'heart.savedArticleAndEvent': 'Artikel und Veranstaltung gespeichert',
  'nav.interests': 'Interessen',
  'interests.unreadLabel': '{n} neue Hinweise in Interessen',
  'interests.title': '♡ Interessen',
  'interests.intro': 'Alles, dem Sie ein Herz gegeben haben: Menschen und Orte, denen Sie folgen, und Dinge, die Sie gespeichert haben. Neue Veranstaltungen und Artikel von ihnen erscheinen zuerst hier.',
  'interests.empty': 'Noch nichts hier. Tippen Sie auf das Herz bei Künstler:innen, Orten, Veranstaltungen, Kunstwerken oder Artikeln, um sie hier zu sammeln.',
  'interests.explore': 'Karte erkunden',
  'interests.thisWeek': 'Diese Woche',
  'interests.quietWeek': 'Diese Woche ist bei dem, dem Sie folgen, nichts geplant.',
  'interests.newFromFollowed': 'Neu bei dem, dem Sie folgen',
  'interests.nextWeek': 'Nächste Woche',
  'interests.saved': 'Alles Gespeicherte und Gefolgte',
  'interests.cat.artists': 'Künstler:innen',
  'interests.cat.venues': 'Kunstorte',
  'interests.cat.profiles': 'Profile',
  'interests.cat.authors': 'ArtRadar-Autor:innen',
  'interests.cat.artworks': 'Kunstwerke',
  'interests.cat.events': 'Veranstaltungen',
  'interests.cat.places': 'Orte',
  'interests.cat.articles': 'Artikel',
  'interests.cat.videos': 'Videos',
  'interests.cat.routes': 'Routen',
  'interests.showAll': 'Alle anzeigen',
  'interests.untitled': 'Ohne Titel',
  'interests.new': 'Neu',
  'interests.dateChanged': 'Datum geändert',
  'interests.cancelled': 'Abgesagt',
  'interests.via': 'über {name}',
  'interests.newArticle': 'Neuer Artikel',
  'interests.newArtwork': 'Neues Kunstwerk',
  'interests.addToCalendar': 'Zum Kalender hinzufügen',
  'interests.addToMyRoute': 'Zu Meiner Route hinzufügen',
  'interests.emailTitle': 'Wöchentliche E-Mail',
  'interests.emailToggle': 'Schicken Sie mir „Diese Woche“ jeden Montag per E-Mail',
  'interests.emailHelp': 'Standardmäßig aus. Jede E-Mail enthält einen Abmeldelink mit einem Klick.',
  'interests.privacy': 'Ihre Herzen sind privat. Eigentümer:innen sehen nur, wie viele Herzen ein Eintrag hat, nie von wem.',
  'interests.unsubscribed': 'Sie erhalten die wöchentliche Interessen-E-Mail nicht mehr.',
  'interests.unsubscribeFailed': 'Dieser Abmeldelink ist nicht mehr gültig.',
  'artworkDetail.askAbout': 'Zu diesem Kunstwerk anfragen',
  'messaging.aboutArtwork': 'Zum Kunstwerk „{title}“: {url}\n\n',
  'nav.insights': 'Insights',
  'insights.title': 'Insights',
  'insights.intro': 'Ein privater Bericht darüber, wie Ihre eigenen Einträge ankommen. Nur Sie sehen ihn. Jede Rolle wird nur mit ihrem eigenen früheren Zeitraum verglichen.',
  'insights.roleLabel': 'Rolle',
  'insights.menuTitle': 'Aktivität, letzte 7 Tage',
  'insights.menuEmpty': 'In dieser Rolle noch keine Einträge.',
  'insights.viewReport': 'Bericht ansehen',
  'insights.m.views7': 'Aufrufe',
  'insights.m.followers': 'Follower',
  'insights.m.saves': 'Merkungen',
  'insights.m.routeAdds7': 'in Routen',
  'insights.tab.week': 'Woche',
  'insights.tab.month': 'Monat',
  'insights.tab.quarter': 'Quartal',
  'insights.tab.year': 'Jahr',
  'insights.loadFailed': 'Der Bericht konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
  'insights.periodLine': '{from} bis {to}, verglichen mit {pfrom} bis {pto}',
  'insights.updated': 'Stand {date}',
  'insights.obsTitle.week': 'Diese Woche',
  'insights.obsTitle.month': 'Dieser Monat',
  'insights.obsTitle.quarter': 'Quartalstrend',
  'insights.obsTitle.year': 'Ihr Jahr',
  'insights.thisPeriod': 'Neu in diesem Zeitraum',
  'insights.rightNow': 'Aktuell',
  'insights.vsPrevious': 'ggü. Vorzeitraum',
  'insights.f.views': 'Aufrufe',
  'insights.f.newSaves': 'Neu gemerkt',
  'insights.f.routeAdds': 'In Routen aufgenommen',
  'insights.f.directions': 'Wegbeschreibungen geöffnet',
  'insights.f.linkOpens': 'Link-Öffnungen',
  'insights.f.uniqueMembers': 'Mitglieder, die öffneten',
  'insights.f.newConnections': 'Neue Kontakte',
  'insights.f.followersNow': 'Follower aktuell',
  'insights.f.savesNow': 'Gemerkt aktuell',
  'insights.f.connectionsNow': 'Kontakte aktuell',
  'insights.col.item': 'Eintrag',
  'insights.col.newFollowers': 'Neue Follower',
  'insights.type.artwork': 'Kunstwerke',
  'insights.type.profile': 'Profil',
  'insights.type.pin': 'PINs und Orte',
  'insights.type.event': 'Veranstaltungen und Ausstellungen',
  'insights.type.video': 'YouTube-Videos',
  'insights.type.route': 'Veröffentlichte Routen',
  'insights.type.article': 'ArtRadar-Artikel',
  'insights.type.author': 'ArtRadar-Autor:in',
  'insights.asAuthor': 'Sie als ArtRadar-Autor:in',
  'insights.delegated': 'delegiert',
  'insights.noRecords': 'Sie haben in dieser Rolle noch keine Einträge. Sobald Sie einen PIN, ein Kunstwerk, eine Veranstaltung oder einen Artikel anlegen, erscheinen die Zahlen hier.',
  'insights.lowActivity': 'Niedrige Zahlen sind anfangs normal. Gezählt wird erst seit Start dieser Funktion, Ihre eigenen Besuche und Suchmaschinen zählen nicht, und wiederholte Besuche innerhalb von 30 Minuten zählen einmal.',
  'insights.yearChart': 'Aufrufe pro Monat in den letzten 12 Monaten',
  'insights.yearNote': 'Die Balken zeigen Aufrufe pro Monat, gestapelt nach Rolle. Mit den Kästchen blenden Sie eine Rolle ein oder aus.',
  'insights.defsTitle': 'Was die Zahlen bedeuten',
  'insights.defName.views': 'Aufrufe',
  'insights.defName.saves': 'Gemerkt',
  'insights.defName.followers': 'Follower',
  'insights.defName.routeAdds': 'In Routen aufgenommen',
  'insights.defName.directions': 'Wegbeschreibungen',
  'insights.defName.linkOpens': 'Link-Öffnungen',
  'insights.defName.uniqueMembers': 'Mitglieder, die öffneten',
  'insights.defName.connections': 'Kontakte',
  'insights.def.views': 'Wie oft die Seite des Eintrags geöffnet wurde. Eigene Besuche, Bots und Wiederholungen innerhalb von 30 Minuten zählen nicht.',
  'insights.def.saves': 'Wie viele Mitglieder dem Eintrag ein Herz gegeben haben. Sie sehen die Zahl, nie wer.',
  'insights.def.followers': 'Herzen auf Ihrem Profil und für Sie als ArtRadar-Autor:in. Sie sehen die Zahl, nie wer.',
  'insights.def.routeAdds': 'Wie oft Besucher:innen den Ort als Station in ihre eigene Route aufgenommen haben. Wessen Route, wird nie gezeigt.',
  'insights.def.directions': 'Wie oft jemand die Wegbeschreibung zum Ort in Google Maps geöffnet hat.',
  'insights.def.linkOpens': 'Wie oft ein YouTube-Link geöffnet wurde. ArtRouting sieht nicht, ob das Video angesehen wurde, daher heißen diese Zahlen nie Aufrufe.',
  'insights.def.uniqueMembers': 'Verschiedene angemeldete Mitglieder, die den Videolink in diesem Zeitraum geöffnet haben.',
  'insights.def.connections': 'Personen, mit denen Sie in ArtRouting-Nachrichten beidseitig im Gespräch sind. Namen und Nachrichten sind nie Teil von Insights.',
  'insights.privacy': 'Insights zeigt nie, wer besucht oder gemerkt hat, keine privaten Routen, Nachrichten, Provenienz, Dokumente, Preisanfragen oder QR-Zahlen.',
  'insights.obs.noRecords': 'Es gibt noch nichts zu berichten, weil diese Rolle keine Einträge hat.',
  'insights.obs.quiet': 'In diesem und im vorigen Zeitraum wurden keine Aufrufe gezählt.',
  'insights.obs.actShare': 'Vorschlag: Teilen Sie den Link zu Ihrem PIN oder Profil mit Ihren Kontakten, das ist der schnellste Weg zu ersten Besucher:innen.',
  'insights.obs.week.first': '{views} Aufrufe diese Woche, die ersten gezählten.',
  'insights.obs.week.up': '{views} Aufrufe diese Woche, {pct} % mehr als letzte Woche.',
  'insights.obs.week.down': '{views} Aufrufe diese Woche, {pct} % weniger als letzte Woche.',
  'insights.obs.week.same': '{views} Aufrufe diese Woche, genauso viele wie letzte Woche.',
  'insights.obs.month.first': '{views} Aufrufe in den letzten 30 Tagen, die ersten gezählten.',
  'insights.obs.month.up': '{views} Aufrufe in den letzten 30 Tagen, {pct} % mehr als in den 30 Tagen davor.',
  'insights.obs.month.down': '{views} Aufrufe in den letzten 30 Tagen, {pct} % weniger als in den 30 Tagen davor.',
  'insights.obs.month.same': '{views} Aufrufe in den letzten 30 Tagen, genauso viele wie davor.',
  'insights.obs.quarter.first': '{views} Aufrufe in diesem Quartal, die ersten gezählten.',
  'insights.obs.quarter.up': 'Der Trend steigt: {views} Aufrufe in diesem Quartal, {pct} % mehr als im Quartal davor.',
  'insights.obs.quarter.down': 'Der Trend fällt: {views} Aufrufe in diesem Quartal, {pct} % weniger als im Quartal davor.',
  'insights.obs.quarter.same': 'Der Trend ist stabil: {views} Aufrufe in diesem Quartal, wie im Quartal davor.',
  'insights.obs.top': 'Am häufigsten aufgerufen: {name} ({views}).',
  'insights.obs.actImprove': 'Vorschlag: {name} wird angesehen, aber noch nicht gemerkt. Ein besseres Foto oder eine ausführlichere Beschreibung kann helfen.',
  'insights.obs.actHours': 'Vorschlag: Ihre Orte werden angesehen, aber noch nicht in Routen aufgenommen. Öffnungszeiten mit Prüfdatum erleichtern die Besuchsplanung.',
  'insights.obs.actEvent': 'Vorschlag: Legen Sie eine kommende Veranstaltung oder Ausstellung an, Follower sehen neue Veranstaltungen zuerst in ihren Interessen.',
  'insights.obs.actKeep': 'Vorschlag: Halten Sie Termine und Bilder aktuell, das bringt Menschen zurück.',
  'insights.obs.year.best': 'Ihr stärkster Monat war {month} mit {views} Aufrufen.',
  'insights.obs.year.up': 'Die letzten sechs Monate waren {pct} % stärker als die sechs davor.',
  'insights.obs.year.down': 'Die letzten sechs Monate waren {pct} % ruhiger als die sechs davor.',
  'insights.obs.year.started': '{views} Aufrufe seit Beginn der Zählung.',
  'activity.routeAddsTitle': '{total}-mal zu Besucherrouten hinzugefügt, {week} in den letzten 7 Tagen',
  'qa.title': 'Fragen und Antworten',
  'qa.navLabel': 'Fragen und Antworten',
  'qa.cardLink': 'Fragen und Antworten',
  'qa.intro': 'Kurze Antworten zu ArtRouting, nach Themen geordnet. Jede Frage hat einen eigenen Link zum Teilen.',
  'qa.contents': 'Themen',
  'qa.linkToQuestion': 'Link zu dieser Frage',
  'qa.moreQuestions': 'Noch eine Frage?',
};

export default de;
